(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6cf7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6cf7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1PrgP", function(module, exports) {

$parcel$export(module.exports, "$", function () { return $; });
$parcel$export(module.exports, "addClass", function () { return addClass; });
$parcel$export(module.exports, "removeClass", function () { return removeClass; });
$parcel$export(module.exports, "toggleClass", function () { return toggleClass; });
$parcel$export(module.exports, "hasClass", function () { return hasClass; });
$parcel$export(module.exports, "attr", function () { return attr; });
$parcel$export(module.exports, "removeAttr", function () { return removeAttr; });
$parcel$export(module.exports, "transform", function () { return transform; });
$parcel$export(module.exports, "transition", function () { return transition; });
$parcel$export(module.exports, "on", function () { return on; });
$parcel$export(module.exports, "off", function () { return off; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "transitionEnd", function () { return transitionEnd; });
$parcel$export(module.exports, "outerWidth", function () { return outerWidth; });
$parcel$export(module.exports, "outerHeight", function () { return outerHeight; });
$parcel$export(module.exports, "offset", function () { return offset; });
$parcel$export(module.exports, "styles", function () { return styles; });
$parcel$export(module.exports, "css", function () { return css; });
$parcel$export(module.exports, "each", function () { return each; });
$parcel$export(module.exports, "filter", function () { return filter; });
$parcel$export(module.exports, "html", function () { return html; });
$parcel$export(module.exports, "text", function () { return text; });
$parcel$export(module.exports, "is", function () { return is; });
$parcel$export(module.exports, "index", function () { return index; });
$parcel$export(module.exports, "eq", function () { return eq; });
$parcel$export(module.exports, "append", function () { return append; });
$parcel$export(module.exports, "prepend", function () { return prepend; });
$parcel$export(module.exports, "next", function () { return next; });
$parcel$export(module.exports, "nextAll", function () { return nextAll; });
$parcel$export(module.exports, "prev", function () { return prev; });
$parcel$export(module.exports, "prevAll", function () { return prevAll; });
$parcel$export(module.exports, "parent", function () { return parent; });
$parcel$export(module.exports, "parents", function () { return parents; });
$parcel$export(module.exports, "closest", function () { return closest; });
$parcel$export(module.exports, "find", function () { return find; });
$parcel$export(module.exports, "children", function () { return children; });
$parcel$export(module.exports, "remove", function () { return remove; });
/**
 * Dom7 3.0.0
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */ 
var $apdun = parcelRequire("apdun");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) _construct = Reflect.construct;
    else _construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
/* eslint-disable no-proto */ function makeReactive(obj) {
    var proto = obj.__proto__;
    Object.defineProperty(obj, '__proto__', {
        get: function get() {
            return proto;
        },
        set: function set(value) {
            proto.__proto__ = value;
        }
    });
}
var Dom7 = /*#__PURE__*/ function(_Array) {
    _inheritsLoose(Dom7, _Array);
    function Dom7(items) {
        var _this;
        _this = _Array.call.apply(_Array, [
            this
        ].concat(items)) || this;
        makeReactive(_assertThisInitialized(_this));
        return _this;
    }
    return Dom7;
}(/*#__PURE__*/ _wrapNativeSuper(Array));
function arrayFlat(arr) {
    if (arr === void 0) arr = [];
    var res = [];
    arr.forEach(function(el) {
        if (Array.isArray(el)) res.push.apply(res, arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    var uniqueArray = [];
    for(var i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, function(match, group) {
        return group.toUpperCase();
    });
}
function qsa(selector, context) {
    if (typeof selector !== 'string') return [
        selector
    ];
    var a = [];
    var res = context.querySelectorAll(selector);
    for(var i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    var window = (0, $apdun.getWindow)();
    var document = (0, $apdun.getDocument)();
    var arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === 'string') {
        var html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
            var toCreate = 'div';
            if (html.indexOf('<li') === 0) toCreate = 'ul';
            if (html.indexOf('<tr') === 0) toCreate = 'tbody';
            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
            if (html.indexOf('<tbody') === 0) toCreate = 'table';
            if (html.indexOf('<option') === 0) toCreate = 'select';
            var tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(var i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
function addClass() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++)classes[_key] = arguments[_key];
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(' ');
    }));
    this.forEach(function(el) {
        var _el$classList;
        (_el$classList = el.classList).add.apply(_el$classList, classNames);
    });
    return this;
}
function removeClass() {
    for(var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)classes[_key2] = arguments[_key2];
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(' ');
    }));
    this.forEach(function(el) {
        var _el$classList2;
        (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
    });
    return this;
}
function toggleClass() {
    for(var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)classes[_key3] = arguments[_key3];
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(' ');
    }));
    this.forEach(function(el) {
        classNames.forEach(function(className) {
            el.classList.toggle(className);
        });
    });
}
function hasClass() {
    for(var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)classes[_key4] = arguments[_key4];
    var classNames = arrayFlat(classes.map(function(c) {
        return c.split(' ');
    }));
    return arrayFilter(this, function(el) {
        return classNames.filter(function(className) {
            return el.classList.contains(className);
        }).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(var i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(var attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(var i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === 'string') {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(var i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(var propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    var el;
    if (typeof value === 'undefined') {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        var dataKey = el.getAttribute("data-" + key);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(var i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    var el = this[0];
    if (!el) return undefined;
    var dataset = {}; // eslint-disable-line
    if (el.dataset) for(var dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(var i = 0; i < el.attributes.length; i += 1){
        var _attr = el.attributes[i];
        if (_attr.name.indexOf('data-') >= 0) dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
    }
    for(var key in dataset){
        if (dataset[key] === 'false') dataset[key] = false;
        else if (dataset[key] === 'true') dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === 'undefined') {
        // get value
        var el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === 'select') {
            var values = [];
            for(var i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(var _i = 0; _i < this.length; _i += 1){
        var _el = this[_i];
        if (Array.isArray(value) && _el.multiple && _el.nodeName.toLowerCase() === 'select') for(var j = 0; j < _el.options.length; j += 1)_el.options[j].selected = value.indexOf(_el.options[j].value) >= 0;
        else _el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(var i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(var i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
    return this;
}
function on() {
    for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
    var eventType = args[0], targetSelector = args[1], listener = args[2], capture = args[3];
    if (typeof args[1] === 'function') {
        eventType = args[0];
        listener = args[1];
        capture = args[2];
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        var target = e.target;
        if (!target) return;
        var eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            var _parents = $(target).parents(); // eslint-disable-line
            for(var k = 0; k < _parents.length; k += 1)if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
        }
    }
    function handleEvent(e) {
        var eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    var events = eventType.split(' ');
    var j;
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            var event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            var _event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];
            el.dom7LiveListeners[_event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(_event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    var eventType = args[0], targetSelector = args[1], listener = args[2], capture = args[3];
    if (typeof args[1] === 'function') {
        eventType = args[0];
        listener = args[1];
        capture = args[2];
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    var events = eventType.split(' ');
    for(var i = 0; i < events.length; i += 1){
        var event = events[i];
        for(var j = 0; j < this.length; j += 1){
            var el = this[j];
            var handlers = void 0;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(var k = handlers.length - 1; k >= 0; k -= 1){
                var handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once() {
    var dom = this;
    for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
    var eventName = args[0], targetSelector = args[1], listener = args[2], capture = args[3];
    if (typeof args[1] === 'function') {
        eventName = args[0];
        listener = args[1];
        capture = args[2];
        targetSelector = undefined;
    }
    function onceHandler() {
        for(var _len8 = arguments.length, eventArgs = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)eventArgs[_key8] = arguments[_key8];
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger() {
    var window = (0, $apdun.getWindow)();
    for(var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++)args[_key9] = arguments[_key9];
    var events = args[0].split(' ');
    var eventData = args[1];
    for(var i = 0; i < events.length; i += 1){
        var event = events[i];
        for(var j = 0; j < this.length; j += 1){
            var el = this[j];
            if (window.CustomEvent) {
                var evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter(function(data, dataIndex) {
                    return dataIndex > 0;
                });
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionEnd(callback) {
    var dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionend', fireCallBack);
    }
    if (callback) dom.on('transitionend', fireCallBack);
    return this;
}
function animationEnd(callback) {
    var dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('animationend', fireCallBack);
    }
    if (callback) dom.on('animationend', fireCallBack);
    return this;
}
function width() {
    var window = (0, $apdun.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css('width'));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            var _styles = this.styles();
            return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    var window = (0, $apdun.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css('height'));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            var _styles2 = this.styles();
            return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        var window = (0, $apdun.getWindow)();
        var document = (0, $apdun.getDocument)();
        var el = this[0];
        var box = el.getBoundingClientRect();
        var body = document.body;
        var clientTop = el.clientTop || body.clientTop || 0;
        var clientLeft = el.clientLeft || body.clientLeft || 0;
        var scrollTop = el === window ? window.scrollY : el.scrollTop;
        var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(var i = 0; i < this.length; i += 1)this[i].style.display = 'none';
    return this;
}
function show() {
    var window = (0, $apdun.getWindow)();
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.style.display === 'none') el.style.display = '';
        if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') // Still not visible
        el.style.display = 'block';
    }
    return this;
}
function styles() {
    var window = (0, $apdun.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    var window = (0, $apdun.getWindow)();
    var i;
    if (arguments.length === 1) {
        if (typeof props === 'string') {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(var _prop in props)this[i].style[_prop] = props[_prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === 'string') {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach(function(el, index) {
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    var result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === 'undefined') return this[0] ? this[0].innerHTML : null;
    for(var i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === 'undefined') return this[0] ? this[0].textContent.trim() : null;
    for(var i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    var window = (0, $apdun.getWindow)();
    var document = (0, $apdun.getDocument)();
    var el = this[0];
    var compareWith;
    var i;
    if (!el || typeof selector === 'undefined') return false;
    if (typeof selector === 'string') {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    var child = this[0];
    var i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === 'undefined') return this;
    var length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        var returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append() {
    var newChild;
    var document = (0, $apdun.getDocument)();
    for(var k = 0; k < arguments.length; k += 1){
        newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];
        for(var i = 0; i < this.length; i += 1){
            if (typeof newChild === 'string') {
                var tempDiv = document.createElement('div');
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(var j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    var document = (0, $apdun.getDocument)();
    var i;
    var j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === 'string') {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    var before = $(selector);
    for(var i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(var j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    var after = $(selector);
    for(var i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(var j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    var nextEls = [];
    var el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        var _next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(_next).is(selector)) nextEls.push(_next);
        } else nextEls.push(_next);
        el = _next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        var el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    var prevEls = [];
    var el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        var _prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(_prev).is(selector)) prevEls.push(_prev);
        } else prevEls.push(_prev);
        el = _prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    var parents = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    var parents = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1){
        var _parent = this[i].parentNode; // eslint-disable-line
        while(_parent){
            if (selector) {
                if ($(_parent).is(selector)) parents.push(_parent);
            } else parents.push(_parent);
            _parent = _parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    var closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    var foundElements = [];
    for(var i = 0; i < this.length; i += 1){
        var found = this[i].querySelectorAll(selector);
        for(var j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    var children = []; // eslint-disable-line
    for(var i = 0; i < this.length; i += 1){
        var childNodes = this[i].children;
        for(var j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(var i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add() {
    var dom = this;
    var i;
    var j;
    for(var _len10 = arguments.length, els = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++)els[_key10] = arguments[_key10];
    for(i = 0; i < els.length; i += 1){
        var toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(var i = 0; i < this.length; i += 1){
        var el = this[i];
        if (el.nodeType === 1) {
            for(var j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = '';
        }
    }
    return this;
}
function scrollTo() {
    var window = (0, $apdun.getWindow)();
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var left = args[0], top = args[1], duration = args[2], easing = args[3], callback = args[4];
    if (args.length === 4 && typeof easing === 'function') {
        callback = easing;
        left = args[0];
        top = args[1];
        duration = args[2];
        callback = args[3];
        easing = args[4];
    }
    if (typeof easing === 'undefined') easing = 'swing';
    return this.each(function animate() {
        var el = this;
        var currentTop;
        var currentLeft;
        var maxTop;
        var maxLeft;
        var newTop;
        var newLeft;
        var scrollTop; // eslint-disable-line
        var scrollLeft; // eslint-disable-line
        var animateTop = top > 0 || top === 0;
        var animateLeft = left > 0 || left === 0;
        if (typeof easing === 'undefined') easing = 'swing';
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        var startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time) {
            if (time === void 0) time = new Date().getTime();
            if (startTime === null) startTime = time;
            var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            var done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var top = args[0], duration = args[1], easing = args[2], callback = args[3];
    if (args.length === 3 && typeof easing === 'function') {
        top = args[0];
        duration = args[1];
        callback = args[2];
        easing = args[3];
    }
    var dom = this;
    if (typeof top === 'undefined') {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    var left = args[0], duration = args[1], easing = args[2], callback = args[3];
    if (args.length === 3 && typeof easing === 'function') {
        left = args[0];
        duration = args[1];
        callback = args[2];
        easing = args[3];
    }
    var dom = this;
    if (typeof left === 'undefined') {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
function animate(initialProps, initialParams) {
    var window = (0, $apdun.getWindow)();
    var els = this;
    var a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: 'swing' // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress: function easingProgress(easing, progress) {
            if (easing === 'swing') return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === 'function') return easing(progress);
            return progress;
        },
        stop: function stop() {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each(function(el) {
                var element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done: function done(complete) {
            a.animating = false;
            a.elements.each(function(el) {
                var element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                var que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate: function animate(props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            var elements = []; // Define & Cache Initials & Units
            a.elements.each(function(el, index) {
                var initialFullValue;
                var initialValue;
                var unit;
                var finalValue;
                var finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach(function(prop) {
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, '');
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            var startTime = null;
            var time;
            var elementsDone = 0;
            var propsDone = 0;
            var done;
            var began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                var progress;
                var easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach(function(element) {
                    var el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach(function(prop) {
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        var _el$prop = el[prop], initialValue = _el$prop.initialValue, finalValue = _el$prop.finalValue, unit = _el$prop.unit;
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        var currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    var animateInstance;
    for(var i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === 'stop') animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    var els = this;
    for(var i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
var noTrigger = 'resize scroll'.split(' ');
function shortcut(name) {
    function eventHandler() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'undefined') {
            for(var i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on.apply(this, [
            name
        ].concat(args));
    }
    return eventHandler;
}
var click = shortcut('click');
var blur = shortcut('blur');
var focus = shortcut('focus');
var focusin = shortcut('focusin');
var focusout = shortcut('focusout');
var keyup = shortcut('keyup');
var keydown = shortcut('keydown');
var keypress = shortcut('keypress');
var submit = shortcut('submit');
var change = shortcut('change');
var mousedown = shortcut('mousedown');
var mousemove = shortcut('mousemove');
var mouseup = shortcut('mouseup');
var mouseenter = shortcut('mouseenter');
var mouseleave = shortcut('mouseleave');
var mouseout = shortcut('mouseout');
var mouseover = shortcut('mouseover');
var touchstart = shortcut('touchstart');
var touchend = shortcut('touchend');
var touchmove = shortcut('touchmove');
var resize = shortcut('resize');
var scroll = shortcut('scroll');
var $154fb5342bbf77aa$export$2e2bcd8739ae039 = $;

});
parcelRegister("apdun", function(module, exports) {

$parcel$export(module.exports, "getDocument", function () { return $7936b3cc81c15f7a$export$f65ca476c09acec0; });
$parcel$export(module.exports, "getWindow", function () { return $7936b3cc81c15f7a$export$38b2d434cce3ea22; });
/**
 * SSR Window 3.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2020, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: November 9, 2020
 */ /* eslint-disable no-param-reassign */ function $7936b3cc81c15f7a$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $7936b3cc81c15f7a$export$8b58be045bf06082(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    Object.keys(src).forEach(function(key) {
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($7936b3cc81c15f7a$var$isObject(src[key]) && $7936b3cc81c15f7a$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $7936b3cc81c15f7a$export$8b58be045bf06082(target[key], src[key]);
    });
}
var $7936b3cc81c15f7a$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener: function() {},
    removeEventListener: function() {},
    activeElement: {
        blur: function() {},
        nodeName: ''
    },
    querySelector: function() {
        return null;
    },
    querySelectorAll: function() {
        return [];
    },
    getElementById: function() {
        return null;
    },
    createEvent: function() {
        return {
            initEvent: function() {}
        };
    },
    createElement: function() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function() {},
            getElementsByTagName: function() {
                return [];
            }
        };
    },
    createElementNS: function() {
        return {};
    },
    importNode: function() {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $7936b3cc81c15f7a$export$f65ca476c09acec0() {
    var doc = typeof document !== 'undefined' ? document : {};
    $7936b3cc81c15f7a$export$8b58be045bf06082(doc, $7936b3cc81c15f7a$export$3fdcb9b4d81368d8);
    return doc;
}
var $7936b3cc81c15f7a$export$8582633f185c62bb = {
    document: $7936b3cc81c15f7a$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState: function() {},
        pushState: function() {},
        go: function() {},
        back: function() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function() {},
    removeEventListener: function() {},
    getComputedStyle: function() {
        return {
            getPropertyValue: function() {
                return '';
            }
        };
    },
    Image: function() {},
    Date: function() {},
    screen: {},
    setTimeout: function() {},
    clearTimeout: function() {},
    matchMedia: function() {
        return {};
    },
    requestAnimationFrame: function(callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function(id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $7936b3cc81c15f7a$export$38b2d434cce3ea22() {
    var win = typeof window !== 'undefined' ? window : {};
    $7936b3cc81c15f7a$export$8b58be045bf06082(win, $7936b3cc81c15f7a$export$8582633f185c62bb);
    return win;
}

});


class $0ae05e362631bcb5$var$RuntimeComponentFactory {
    constructor(){
        this._ = {};
    }
    getDictionary = ()=>this._;
    /**
   add a class to the factory to be instantiated later with using the same typeID
   */ add = (typeID, classRef)=>{
        this._[typeID] = classRef;
    };
    /**
   get a class with the given typeID.
   */ get = (typeID)=>{
        return this._[typeID];
    };
}
const $0ae05e362631bcb5$var$instance = new $0ae05e362631bcb5$var$RuntimeComponentFactory();
var $0ae05e362631bcb5$export$2e2bcd8739ae039 = $0ae05e362631bcb5$var$instance;


var $7ad1c2c397dfc980$exports = {};
!function(t, n) {
    $7ad1c2c397dfc980$exports = n();
}($7ad1c2c397dfc980$exports, function() {
    "use strict";
    function t() {
        return (t = Object.assign || function(t) {
            for(var n = 1; n < arguments.length; n++){
                var e = arguments[n];
                for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
            }
            return t;
        }).apply(this, arguments);
    }
    var n = "undefined" != typeof window, e = n && !("onscroll" in window) || "undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent), i = n && "IntersectionObserver" in window, o = n && "classList" in document.createElement("p"), r = n && window.devicePixelRatio > 1, a = {
        elements_selector: ".lazy",
        container: e || n ? document : null,
        threshold: 300,
        thresholds: null,
        data_src: "src",
        data_srcset: "srcset",
        data_sizes: "sizes",
        data_bg: "bg",
        data_bg_hidpi: "bg-hidpi",
        data_bg_multi: "bg-multi",
        data_bg_multi_hidpi: "bg-multi-hidpi",
        data_poster: "poster",
        class_applied: "applied",
        class_loading: "loading",
        class_loaded: "loaded",
        class_error: "error",
        class_entered: "entered",
        class_exited: "exited",
        unobserve_completed: !0,
        unobserve_entered: !1,
        cancel_on_exit: !0,
        callback_enter: null,
        callback_exit: null,
        callback_applied: null,
        callback_loading: null,
        callback_loaded: null,
        callback_error: null,
        callback_finish: null,
        callback_cancel: null,
        use_native: !1
    }, c = function(n) {
        return t({}, a, n);
    }, s = function(t, n) {
        var e, i = "LazyLoad::Initialized", o = new t(n);
        try {
            e = new CustomEvent(i, {
                detail: {
                    instance: o
                }
            });
        } catch (t) {
            (e = document.createEvent("CustomEvent")).initCustomEvent(i, !1, !1, {
                instance: o
            });
        }
        window.dispatchEvent(e);
    }, l = "loading", u = "loaded", d = "applied", f = "error", _ = "native", g = "data-", v = "ll-status", p = function(t, n) {
        return t.getAttribute(g + n);
    }, b = function(t) {
        return p(t, v);
    }, h = function(t, n) {
        return function(t, n, e) {
            var i = "data-ll-status";
            null !== e ? t.setAttribute(i, e) : t.removeAttribute(i);
        }(t, 0, n);
    }, m = function(t) {
        return h(t, null);
    }, E = function(t) {
        return null === b(t);
    }, y = function(t) {
        return b(t) === _;
    }, A = [
        l,
        u,
        d,
        f
    ], I = function(t, n, e, i) {
        t && (void 0 === i ? void 0 === e ? t(n) : t(n, e) : t(n, e, i));
    }, L = function(t, n) {
        o ? t.classList.add(n) : t.className += (t.className ? " " : "") + n;
    }, w = function(t, n) {
        o ? t.classList.remove(n) : t.className = t.className.replace(new RegExp("(^|\\s+)" + n + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, "");
    }, k = function(t) {
        return t.llTempImage;
    }, O = function(t, n) {
        if (n) {
            var e = n._observer;
            e && e.unobserve(t);
        }
    }, x = function(t, n) {
        t && (t.loadingCount += n);
    }, z = function(t, n) {
        t && (t.toLoadCount = n);
    }, C = function(t) {
        for(var n, e = [], i = 0; n = t.children[i]; i += 1)"SOURCE" === n.tagName && e.push(n);
        return e;
    }, N = function(t, n, e) {
        e && t.setAttribute(n, e);
    }, M = function(t, n) {
        t.removeAttribute(n);
    }, R = function(t) {
        return !!t.llOriginalAttrs;
    }, G = function(t) {
        if (!R(t)) {
            var n = {};
            n.src = t.getAttribute("src"), n.srcset = t.getAttribute("srcset"), n.sizes = t.getAttribute("sizes"), t.llOriginalAttrs = n;
        }
    }, T = function(t) {
        if (R(t)) {
            var n = t.llOriginalAttrs;
            N(t, "src", n.src), N(t, "srcset", n.srcset), N(t, "sizes", n.sizes);
        }
    }, j = function(t, n) {
        N(t, "sizes", p(t, n.data_sizes)), N(t, "srcset", p(t, n.data_srcset)), N(t, "src", p(t, n.data_src));
    }, D = function(t) {
        M(t, "src"), M(t, "srcset"), M(t, "sizes");
    }, F = function(t, n) {
        var e = t.parentNode;
        e && "PICTURE" === e.tagName && C(e).forEach(n);
    }, P = {
        IMG: function(t, n) {
            F(t, function(t) {
                G(t), j(t, n);
            }), G(t), j(t, n);
        },
        IFRAME: function(t, n) {
            N(t, "src", p(t, n.data_src));
        },
        VIDEO: function(t, n) {
            !function(t, e) {
                C(t).forEach(function(t) {
                    N(t, "src", p(t, n.data_src));
                });
            }(t), N(t, "poster", p(t, n.data_poster)), N(t, "src", p(t, n.data_src)), t.load();
        }
    }, S = function(t, n) {
        var e = P[t.tagName];
        e && e(t, n);
    }, V = function(t, n, e) {
        x(e, 1), L(t, n.class_loading), h(t, l), I(n.callback_loading, t, e);
    }, U = [
        "IMG",
        "IFRAME",
        "VIDEO"
    ], $ = function(t, n) {
        !n || function(t) {
            return t.loadingCount > 0;
        }(n) || function(t) {
            return t.toLoadCount > 0;
        }(n) || I(t.callback_finish, n);
    }, q = function(t, n, e) {
        t.addEventListener(n, e), t.llEvLisnrs[n] = e;
    }, H = function(t, n, e) {
        t.removeEventListener(n, e);
    }, B = function(t) {
        return !!t.llEvLisnrs;
    }, J = function(t) {
        if (B(t)) {
            var n = t.llEvLisnrs;
            for(var e in n){
                var i = n[e];
                H(t, e, i);
            }
            delete t.llEvLisnrs;
        }
    }, K = function(t, n, e) {
        !function(t) {
            delete t.llTempImage;
        }(t), x(e, -1), function(t) {
            t && (t.toLoadCount -= 1);
        }(e), w(t, n.class_loading), n.unobserve_completed && O(t, e);
    }, Q = function(t, n, e) {
        var i = k(t) || t;
        B(i) || function(t, n, e) {
            B(t) || (t.llEvLisnrs = {});
            var i = "VIDEO" === t.tagName ? "loadeddata" : "load";
            q(t, i, n), q(t, "error", e);
        }(i, function(o) {
            !function(t, n, e, i) {
                var o = y(n);
                K(n, e, i), L(n, e.class_loaded), h(n, u), I(e.callback_loaded, n, i), o || $(e, i);
            }(0, t, n, e), J(i);
        }, function(o) {
            !function(t, n, e, i) {
                var o = y(n);
                K(n, e, i), L(n, e.class_error), h(n, f), I(e.callback_error, n, i), o || $(e, i);
            }(0, t, n, e), J(i);
        });
    }, W = function(t, n, e) {
        !function(t) {
            t.llTempImage = document.createElement("IMG");
        }(t), Q(t, n, e), function(t, n, e) {
            var i = p(t, n.data_bg), o = p(t, n.data_bg_hidpi), a = r && o ? o : i;
            a && (t.style.backgroundImage = 'url("'.concat(a, '")'), k(t).setAttribute("src", a), V(t, n, e));
        }(t, n, e), function(t, n, e) {
            var i = p(t, n.data_bg_multi), o = p(t, n.data_bg_multi_hidpi), a = r && o ? o : i;
            a && (t.style.backgroundImage = a, function(t, n, e) {
                L(t, n.class_applied), h(t, d), n.unobserve_completed && O(t, n), I(n.callback_applied, t, e);
            }(t, n, e));
        }(t, n, e);
    }, X = function(t, n, e) {
        !function(t) {
            return U.indexOf(t.tagName) > -1;
        }(t) ? W(t, n, e) : function(t, n, e) {
            Q(t, n, e), S(t, n), V(t, n, e);
        }(t, n, e);
    }, Y = [
        "IMG",
        "IFRAME"
    ], Z = function(t) {
        return t.use_native && "loading" in HTMLImageElement.prototype;
    }, tt = function(t, n, e) {
        t.forEach(function(t) {
            return function(t) {
                return t.isIntersecting || t.intersectionRatio > 0;
            }(t) ? function(t, n, e, i) {
                h(t, "entered"), L(t, e.class_entered), w(t, e.class_exited), function(t, n, e) {
                    n.unobserve_entered && O(t, e);
                }(t, e, i), I(e.callback_enter, t, n, i), function(t) {
                    return A.indexOf(b(t)) >= 0;
                }(t) || X(t, e, i);
            }(t.target, t, n, e) : function(t, n, e, i) {
                E(t) || (L(t, e.class_exited), function(t, n, e, i) {
                    e.cancel_on_exit && function(t) {
                        return b(t) === l;
                    }(t) && "IMG" === t.tagName && (J(t), function(t) {
                        F(t, function(t) {
                            D(t);
                        }), D(t);
                    }(t), function(t) {
                        F(t, function(t) {
                            T(t);
                        }), T(t);
                    }(t), w(t, e.class_loading), x(i, -1), m(t), I(e.callback_cancel, t, n, i));
                }(t, n, e, i), I(e.callback_exit, t, n, i));
            }(t.target, t, n, e);
        });
    }, nt = function(t) {
        return Array.prototype.slice.call(t);
    }, et = function(t) {
        return t.container.querySelectorAll(t.elements_selector);
    }, it = function(t) {
        return function(t) {
            return b(t) === f;
        }(t);
    }, ot = function(t, n) {
        return function(t) {
            return nt(t).filter(E);
        }(t || et(n));
    }, rt = function(t, e) {
        var o = c(t);
        this._settings = o, this.loadingCount = 0, function(t, n) {
            i && !Z(t) && (n._observer = new IntersectionObserver(function(e) {
                tt(e, t, n);
            }, function(t) {
                return {
                    root: t.container === document ? null : t.container,
                    rootMargin: t.thresholds || t.threshold + "px"
                };
            }(t)));
        }(o, this), function(t, e) {
            n && window.addEventListener("online", function() {
                !function(t, n) {
                    var e;
                    (e = et(t), nt(e).filter(it)).forEach(function(n) {
                        w(n, t.class_error), m(n);
                    }), n.update();
                }(t, e);
            });
        }(o, this), this.update(e);
    };
    return rt.prototype = {
        update: function(t) {
            var n, o, r = this._settings, a = ot(t, r);
            z(this, a.length), !e && i ? Z(r) ? function(t, n, e) {
                t.forEach(function(t) {
                    -1 !== Y.indexOf(t.tagName) && (t.setAttribute("loading", "lazy"), function(t, n, e) {
                        Q(t, n, e), S(t, n), h(t, _);
                    }(t, n, e));
                }), z(e, 0);
            }(a, r, this) : (o = a, function(t) {
                t.disconnect();
            }(n = this._observer), function(t, n) {
                n.forEach(function(n) {
                    t.observe(n);
                });
            }(n, o)) : this.loadAll(a);
        },
        destroy: function() {
            this._observer && this._observer.disconnect(), et(this._settings).forEach(function(t) {
                delete t.llOriginalAttrs;
            }), delete this._observer, delete this._settings, delete this.loadingCount, delete this.toLoadCount;
        },
        loadAll: function(t) {
            var n = this, e = this._settings;
            ot(t, e).forEach(function(t) {
                O(t, n), X(t, e, n);
            });
        }
    }, rt.load = function(t, n) {
        var e = c(n);
        X(t, e);
    }, rt.resetStatus = function(t) {
        m(t);
    }, n && function(t, n) {
        if (n) {
            if (n.length) for(var e, i = 0; e = n[i]; i += 1)s(t, e);
            else s(t, n);
        }
    }(rt, window.lazyLoadOptions), rt;
});


function $6e2cf81170476d5a$export$635e15bbd66f01ea(target, evtName, data) {
    const event = new CustomEvent(evtName, {
        detail: data
    });
    target.dispatchEvent(event);
}
const $6e2cf81170476d5a$var$Events = {
    AJAX_UPDATE: 'ajaxUpdate',
    TRIGGER_LOAD_LAZY: 'triggerLoadLazy',
    HEADER_MOUSELEAVE: 'headerMouseLeave'
};
var $6e2cf81170476d5a$export$2e2bcd8739ae039 = $6e2cf81170476d5a$var$Events;


const $b46c9c560a3e2aaa$var$LAZY_CLASS = '.lazy';
const $b46c9c560a3e2aaa$var$callback_loaded = (el)=>{
    const mediaParentEl = el.closest('.media');
    if (mediaParentEl) mediaParentEl.classList.add('loaded');
};
const $b46c9c560a3e2aaa$var$lazyLoadInstance = new (0, (/*@__PURE__*/$parcel$interopDefault($7ad1c2c397dfc980$exports)))({
    elements_selector: $b46c9c560a3e2aaa$var$LAZY_CLASS,
    thresholds: '50% 100%',
    unobserve_entered: true,
    cancel_on_exit: false,
    callback_loaded: $b46c9c560a3e2aaa$var$callback_loaded
});
// after updating elements' innerHTML, this needs to be fired to observe the new DOM elements.
document.body.addEventListener((0, $6e2cf81170476d5a$export$2e2bcd8739ae039).AJAX_UPDATE, (e)=>{
    if ($b46c9c560a3e2aaa$var$lazyLoadInstance) $b46c9c560a3e2aaa$var$lazyLoadInstance.update();
});
document.body.addEventListener((0, $6e2cf81170476d5a$export$2e2bcd8739ae039).TRIGGER_LOAD_LAZY, (e)=>{
    const { el: el } = e.detail;
    if (!el) return;
    let elsToLoad = [];
    const els = [].concat(el);
    els.forEach((el)=>{
        if (el.classList.contains($b46c9c560a3e2aaa$var$LAZY_CLASS)) elsToLoad = elsToLoad.concat([
            el
        ]);
        else elsToLoad = elsToLoad.concat([
            ...el.querySelectorAll($b46c9c560a3e2aaa$var$LAZY_CLASS)
        ]);
    });
    elsToLoad.forEach((imgEl)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($7ad1c2c397dfc980$exports))).load(imgEl, {
            unobserve_entered: true,
            cancel_on_exit: false,
            callback_loaded: $b46c9c560a3e2aaa$var$callback_loaded
        });
    });
});


function $dfa0449af776674b$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $dfa0449af776674b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.6.0
 * https://greensock.com
 *
 * @license Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $dfa0449af776674b$export$4922bee768729a77 = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, $dfa0449af776674b$var$_defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, $dfa0449af776674b$var$_suppressOverwrites, $dfa0449af776674b$var$_bigNum = 1e8, $dfa0449af776674b$var$_tinyNum = 1 / $dfa0449af776674b$var$_bigNum, $dfa0449af776674b$var$_2PI = Math.PI * 2, $dfa0449af776674b$var$_HALF_PI = $dfa0449af776674b$var$_2PI / 4, $dfa0449af776674b$var$_gsID = 0, $dfa0449af776674b$var$_sqrt = Math.sqrt, $dfa0449af776674b$var$_cos = Math.cos, $dfa0449af776674b$var$_sin = Math.sin, $dfa0449af776674b$export$f664476fd67145ca = function _isString(value) {
    return typeof value === "string";
}, $dfa0449af776674b$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $dfa0449af776674b$var$_isNumber = function _isNumber(value) {
    return typeof value === "number";
}, $dfa0449af776674b$export$a8178c063a9fd3a1 = function _isUndefined(value) {
    return typeof value === "undefined";
}, $dfa0449af776674b$var$_isObject = function _isObject(value) {
    return typeof value === "object";
}, $dfa0449af776674b$var$_isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, $dfa0449af776674b$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $dfa0449af776674b$var$_isFuncOrString = function _isFuncOrString(value) {
    return $dfa0449af776674b$var$_isFunction(value) || $dfa0449af776674b$export$f664476fd67145ca(value);
}, $dfa0449af776674b$var$_isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
$dfa0449af776674b$var$_isArray = Array.isArray, $dfa0449af776674b$var$_strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
$dfa0449af776674b$export$b9d44bb6523120d6 = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
$dfa0449af776674b$export$65c88bbd597e7b0a = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, $dfa0449af776674b$var$_complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
$dfa0449af776674b$export$5a680e28b0b61bc = /[+-]=-?[.\d]+/, $dfa0449af776674b$var$_delimitedValueExp = /[#\-+.]*\b[a-z\d-=+%.]+/gi, $dfa0449af776674b$var$_unitExp = /[\d.+\-=]+(?:e[-+]\d*)*/i, $dfa0449af776674b$var$_globalTimeline, $dfa0449af776674b$var$_win, $dfa0449af776674b$var$_coreInitted, $dfa0449af776674b$var$_doc, $dfa0449af776674b$var$_globals = {}, $dfa0449af776674b$var$_installScope = {}, $dfa0449af776674b$var$_coreReady, $dfa0449af776674b$var$_install = function _install(scope) {
    return ($dfa0449af776674b$var$_installScope = $dfa0449af776674b$var$_merge(scope, $dfa0449af776674b$var$_globals)) && $dfa0449af776674b$export$99ee26438460406a;
}, $dfa0449af776674b$export$7fb54635790b59a5 = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, $dfa0449af776674b$var$_warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, $dfa0449af776674b$var$_addGlobal = function _addGlobal(name, obj) {
    return name && ($dfa0449af776674b$var$_globals[name] = obj) && $dfa0449af776674b$var$_installScope && ($dfa0449af776674b$var$_installScope[name] = obj) || $dfa0449af776674b$var$_globals;
}, $dfa0449af776674b$var$_emptyFunc = function _emptyFunc() {
    return 0;
}, $dfa0449af776674b$var$_reservedProps = {}, $dfa0449af776674b$var$_lazyTweens = [], $dfa0449af776674b$var$_lazyLookup = {}, $dfa0449af776674b$var$_lastRenderedFrame, $dfa0449af776674b$export$d305d8ec5d7c26b8 = {}, $dfa0449af776674b$var$_effects = {}, $dfa0449af776674b$var$_nextGCFrame = 30, $dfa0449af776674b$var$_harnessPlugins = [], $dfa0449af776674b$var$_callbackNames = "", $dfa0449af776674b$var$_harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    $dfa0449af776674b$var$_isObject(target) || $dfa0449af776674b$var$_isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = $dfa0449af776674b$var$_harnessPlugins.length;
        while(i-- && !$dfa0449af776674b$var$_harnessPlugins[i].targetTest(target));
        harnessPlugin = $dfa0449af776674b$var$_harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new $dfa0449af776674b$export$cf10981d5419cad5(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, $dfa0449af776674b$export$8b9be379d2de2a39 = function _getCache(target) {
    return target._gsap || $dfa0449af776674b$var$_harness($dfa0449af776674b$export$45b10814cc054894(target))[0]._gsap;
}, $dfa0449af776674b$export$51d6bbe898aef1f9 = function _getProperty(target, property, v) {
    return (v = target[property]) && $dfa0449af776674b$var$_isFunction(v) ? target[property]() : $dfa0449af776674b$export$a8178c063a9fd3a1(v) && target.getAttribute && target.getAttribute(property) || v;
}, $dfa0449af776674b$export$f9000b814859f126 = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
$dfa0449af776674b$export$9c8d725d65e13f94 = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, $dfa0449af776674b$var$_arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, $dfa0449af776674b$var$_parseVars = function _parseVars(params, type, parent) {
    //reads the arguments passed to one of the key methods and figures out if the user is defining things with the OLD/legacy syntax where the duration is the 2nd parameter, and then it adjusts things accordingly and spits back the corrected vars object (with the duration added if necessary, as well as runBackwards or startAt or immediateRender). type 0 = to()/staggerTo(), 1 = from()/staggerFrom(), 2 = fromTo()/staggerFromTo()
    var isLegacy = $dfa0449af776674b$var$_isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars;
    isLegacy && (vars.duration = params[1]);
    vars.parent = parent;
    if (type) {
        irVars = vars;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = $dfa0449af776674b$var$_isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = $dfa0449af776674b$var$_isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return vars;
}, $dfa0449af776674b$var$_lazyRender = function _lazyRender() {
    var l = $dfa0449af776674b$var$_lazyTweens.length, a = $dfa0449af776674b$var$_lazyTweens.slice(0), i, tween;
    $dfa0449af776674b$var$_lazyLookup = {};
    $dfa0449af776674b$var$_lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, $dfa0449af776674b$var$_lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    $dfa0449af776674b$var$_lazyTweens.length && $dfa0449af776674b$var$_lazyRender();
    animation.render(time, suppressEvents, force);
    $dfa0449af776674b$var$_lazyTweens.length && $dfa0449af776674b$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, $dfa0449af776674b$var$_numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match($dfa0449af776674b$var$_delimitedValueExp).length < 2 ? n : $dfa0449af776674b$export$f664476fd67145ca(value) ? value.trim() : value;
}, $dfa0449af776674b$var$_passThrough = function _passThrough(p) {
    return p;
}, $dfa0449af776674b$export$dc2b19673bb53610 = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, $dfa0449af776674b$var$_setKeyframeDefaults = function _setKeyframeDefaults(obj, defaults) {
    for(var p in defaults)p in obj || p === "duration" || p === "ease" || (obj[p] = defaults[p]);
}, $dfa0449af776674b$var$_merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, $dfa0449af776674b$var$_mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = $dfa0449af776674b$var$_isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, $dfa0449af776674b$var$_copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, $dfa0449af776674b$var$_inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || $dfa0449af776674b$var$_globalTimeline, func = vars.keyframes ? $dfa0449af776674b$var$_setKeyframeDefaults : $dfa0449af776674b$export$dc2b19673bb53610;
    if ($dfa0449af776674b$var$_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, $dfa0449af776674b$var$_arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, $dfa0449af776674b$var$_addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, $dfa0449af776674b$export$cd008aa6cd8844e3 = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, $dfa0449af776674b$var$_removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove(child);
    child._act = 0;
}, $dfa0449af776674b$var$_uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, $dfa0449af776674b$var$_recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, $dfa0449af776674b$var$_hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, $dfa0449af776674b$var$_elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? $dfa0449af776674b$var$_animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
$dfa0449af776674b$var$_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
}, $dfa0449af776674b$var$_parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, $dfa0449af776674b$var$_setEnd = function _setEnd(animation) {
    return animation._end = $dfa0449af776674b$export$9c8d725d65e13f94(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || $dfa0449af776674b$var$_tinyNum) || 0));
}, $dfa0449af776674b$var$_alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = $dfa0449af776674b$export$9c8d725d65e13f94(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        $dfa0449af776674b$var$_setEnd(animation);
        parent._dirty || $dfa0449af776674b$var$_uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ $dfa0449af776674b$var$_postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || child._initted && !child._dur) {
        //in case, for example, the _start is moved on a tween that has already rendered. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning.
        t = $dfa0449af776674b$var$_parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || $dfa0449af776674b$var$_clamp(0, child.totalDuration(), t) - child._tTime > $dfa0449af776674b$var$_tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if ($dfa0449af776674b$var$_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -$dfa0449af776674b$var$_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, $dfa0449af776674b$var$_addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && $dfa0449af776674b$var$_removeFromParent(child);
    child._start = $dfa0449af776674b$export$9c8d725d65e13f94(position + child._delay);
    child._end = $dfa0449af776674b$export$9c8d725d65e13f94(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    $dfa0449af776674b$var$_addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    timeline._recent = child;
    skipChecks || $dfa0449af776674b$var$_postAddChecks(timeline, child);
    return timeline;
}, $dfa0449af776674b$var$_scrollTrigger = function _scrollTrigger(animation, trigger) {
    return ($dfa0449af776674b$var$_globals.ScrollTrigger || $dfa0449af776674b$export$7fb54635790b59a5("scrollTrigger", trigger)) && $dfa0449af776674b$var$_globals.ScrollTrigger.create(trigger, animation);
}, $dfa0449af776674b$var$_attemptInitTween = function _attemptInitTween(tween, totalTime, force, suppressEvents) {
    $dfa0449af776674b$var$_initTween(tween, totalTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && $dfa0449af776674b$var$_lastRenderedFrame !== $dfa0449af776674b$export$762ed8fbedb691e3.frame) {
        $dfa0449af776674b$var$_lazyTweens.push(tween);
        tween._lazy = [
            totalTime,
            suppressEvents
        ];
        return 1;
    }
}, $dfa0449af776674b$var$_parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
$dfa0449af776674b$var$_renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && $dfa0449af776674b$var$_parentPlayheadIsBeforeStart(tween) || (tween._ts < 0 || tween._dp._ts < 0) && tween.data !== "isFromStart" && tween.data !== "isStart") ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = $dfa0449af776674b$var$_clamp(0, tween._tDur, totalTime);
        iteration = $dfa0449af776674b$var$_animationCycle(tTime, repeatDelay);
        prevIteration = $dfa0449af776674b$var$_animationCycle(tween._tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== prevIteration) {
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || force || tween._zTime === $dfa0449af776674b$var$_tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && $dfa0449af776674b$var$_attemptInitTween(tween, totalTime, force, suppressEvents)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? $dfa0449af776674b$var$_tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        suppressEvents || $dfa0449af776674b$var$_callback(tween, "onStart");
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        tween._startAt && totalTime < 0 && tween._startAt.render(totalTime, true, true);
        tween._onUpdate && !suppressEvents && $dfa0449af776674b$var$_callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && $dfa0449af776674b$var$_callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && $dfa0449af776674b$var$_removeFromParent(tween, 1);
            if (!suppressEvents) {
                $dfa0449af776674b$var$_callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, $dfa0449af776674b$var$_findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (!child._dur && child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (!child._dur && child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, $dfa0449af776674b$var$_setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = $dfa0449af776674b$export$9c8d725d65e13f94(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : $dfa0449af776674b$export$9c8d725d65e13f94(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress && !leavePlayhead ? $dfa0449af776674b$var$_alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress) : animation.parent && $dfa0449af776674b$var$_setEnd(animation);
    skipUncache || $dfa0449af776674b$var$_uncache(animation.parent, animation);
    return animation;
}, $dfa0449af776674b$var$_onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof $dfa0449af776674b$export$e6a97ba2cae5bb94 ? $dfa0449af776674b$var$_uncache(animation) : $dfa0449af776674b$var$_setDuration(animation, animation._dur);
}, $dfa0449af776674b$var$_zeroPosition = {
    _start: 0,
    endTime: $dfa0449af776674b$var$_emptyFunc
}, $dfa0449af776674b$var$_parsePosition = function _parsePosition(animation, position) {
    var labels = animation.labels, recent = animation._recent || $dfa0449af776674b$var$_zeroPosition, clippedDuration = animation.duration() >= $dfa0449af776674b$var$_bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset;
    if ($dfa0449af776674b$export$f664476fd67145ca(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        i = position.charAt(0);
        if (i === "<" || i === ">") return (i === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0);
        i = position.indexOf("=");
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = +(position.charAt(i - 1) + position.substr(i + 1));
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1)) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, $dfa0449af776674b$var$_conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, $dfa0449af776674b$var$_clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, $dfa0449af776674b$export$65f2564e9a9b9222 = function getUnit(value) {
    if (typeof value !== "string") return "";
    var v = $dfa0449af776674b$var$_unitExp.exec(value);
    return v ? value.substr(v.index + v[0].length) : "";
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
$dfa0449af776674b$export$7d15b64cf5a3a4c4 = function clamp(min, max, value) {
    return $dfa0449af776674b$var$_conditionalReturn(value, function(v) {
        return $dfa0449af776674b$var$_clamp(min, max, v);
    });
}, $dfa0449af776674b$var$_slice = [].slice, $dfa0449af776674b$var$_isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && $dfa0449af776674b$var$_isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && $dfa0449af776674b$var$_isObject(value[0])) && !value.nodeType && value !== $dfa0449af776674b$var$_win;
}, $dfa0449af776674b$var$_flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return $dfa0449af776674b$export$f664476fd67145ca(value) && !leaveStrings || $dfa0449af776674b$var$_isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, $dfa0449af776674b$export$45b10814cc054894(value)) : accumulator.push(value);
    }) || accumulator;
}, //takes any value and returns an array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
$dfa0449af776674b$export$45b10814cc054894 = function toArray(value, leaveStrings) {
    return $dfa0449af776674b$export$f664476fd67145ca(value) && !leaveStrings && ($dfa0449af776674b$var$_coreInitted || !$dfa0449af776674b$var$_wake()) ? $dfa0449af776674b$var$_slice.call($dfa0449af776674b$var$_doc.querySelectorAll(value), 0) : $dfa0449af776674b$var$_isArray(value) ? $dfa0449af776674b$var$_flatten(value, leaveStrings) : $dfa0449af776674b$var$_isArrayLike(value) ? $dfa0449af776674b$var$_slice.call(value, 0) : value ? [
        value
    ] : [];
}, $dfa0449af776674b$export$448332262467e042 = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = Math.floor(Math.random() * i), v = a[--i], a[i] = a[j], a[j] = v); return a;
//for distributing values across an array. Can accept a number, a function or (most commonly) a function which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array. Recognizes the following
$dfa0449af776674b$export$f02a9ddbe4480f19 = function distribute(v) {
    if ($dfa0449af776674b$var$_isFunction(v)) return v;
    var vars = $dfa0449af776674b$var$_isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = $dfa0449af776674b$var$_parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if ($dfa0449af776674b$export$f664476fd67145ca(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                $dfa0449af776674b$var$_bigNum
            ])[1];
            if (!wrapAt) {
                max = -$dfa0449af776674b$var$_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = $dfa0449af776674b$var$_bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? $dfa0449af776674b$var$_sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && $dfa0449af776674b$export$448332262467e042(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = $dfa0449af776674b$export$65f2564e9a9b9222(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? $dfa0449af776674b$var$_invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return $dfa0449af776674b$export$9c8d725d65e13f94(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, $dfa0449af776674b$export$dd12390e6b265a17 = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = v < 1 ? Math.pow(10, (v + "").length - 2) : 1; //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed()
    return function(raw) {
        var n = Math.round(parseFloat(raw) / v) * v * p;
        return (n - n % 1) / p + ($dfa0449af776674b$var$_isNumber(raw) ? 0 : $dfa0449af776674b$export$65f2564e9a9b9222(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, $dfa0449af776674b$export$51a0620f7a28532b = function snap(snapTo, value) {
    var isArray = $dfa0449af776674b$var$_isArray(snapTo), radius, is2D;
    if (!isArray && $dfa0449af776674b$var$_isObject(snapTo)) {
        radius = isArray = snapTo.radius || $dfa0449af776674b$var$_bigNum;
        if (snapTo.values) {
            snapTo = $dfa0449af776674b$export$45b10814cc054894(snapTo.values);
            if (is2D = !$dfa0449af776674b$var$_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = $dfa0449af776674b$export$dd12390e6b265a17(snapTo.increment);
    }
    return $dfa0449af776674b$var$_conditionalReturn(value, !isArray ? $dfa0449af776674b$export$dd12390e6b265a17(snapTo) : $dfa0449af776674b$var$_isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = $dfa0449af776674b$var$_bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || $dfa0449af776674b$var$_isNumber(raw) ? closest : closest + $dfa0449af776674b$export$65f2564e9a9b9222(raw);
    });
}, $dfa0449af776674b$export$4385e60b38654f68 = function random(min, max, roundingIncrement, returnFunction) {
    return $dfa0449af776674b$var$_conditionalReturn($dfa0449af776674b$var$_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return $dfa0449af776674b$var$_isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, $dfa0449af776674b$export$a4627e546088548d = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, $dfa0449af776674b$export$d7502930aa5492de = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || $dfa0449af776674b$export$65f2564e9a9b9222(value));
    };
}, $dfa0449af776674b$export$a3295358bff77e = function normalize(min, max, value) {
    return $dfa0449af776674b$export$f65a7599bbc6b121(min, max, 0, 1, value);
}, $dfa0449af776674b$var$_wrapArray = function _wrapArray(a, wrapper, value) {
    return $dfa0449af776674b$var$_conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, $dfa0449af776674b$export$4997ffc0176396a6 = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return $dfa0449af776674b$var$_isArray(min) ? $dfa0449af776674b$var$_wrapArray(min, wrap(0, min.length), max) : $dfa0449af776674b$var$_conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, $dfa0449af776674b$export$cfc0b067273edc55 = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return $dfa0449af776674b$var$_isArray(min) ? $dfa0449af776674b$var$_wrapArray(min, wrapYoyo(0, min.length - 1), max) : $dfa0449af776674b$var$_conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, $dfa0449af776674b$export$d5962a97e3cde94d = function _replaceRandom(value) {
    //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
    var prev = 0, s = "", i, nums, end, isArray;
    while(~(i = value.indexOf("random(", prev))){
        end = value.indexOf(")", i);
        isArray = value.charAt(i + 7) === "[";
        nums = value.substr(i + 7, end - i - 7).match(isArray ? $dfa0449af776674b$var$_delimitedValueExp : $dfa0449af776674b$var$_strictNumExp);
        s += value.substr(prev, i - prev) + $dfa0449af776674b$export$4385e60b38654f68(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
    }
    return s + value.substr(prev, value.length - prev);
}, $dfa0449af776674b$export$f65a7599bbc6b121 = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return $dfa0449af776674b$var$_conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, $dfa0449af776674b$export$89e29e4ab65e70a9 = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = $dfa0449af776674b$export$f664476fd67145ca(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if ($dfa0449af776674b$var$_isArray(start) && !$dfa0449af776674b$var$_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = $dfa0449af776674b$var$_merge($dfa0449af776674b$var$_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)$dfa0449af776674b$var$_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return $dfa0449af776674b$var$_renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return $dfa0449af776674b$var$_conditionalReturn(progress, func);
}, $dfa0449af776674b$var$_getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = $dfa0449af776674b$var$_bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, $dfa0449af776674b$var$_callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], params, scope;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && $dfa0449af776674b$var$_lazyTweens.length && $dfa0449af776674b$var$_lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    return params ? callback.apply(scope, params) : callback.call(scope);
}, $dfa0449af776674b$var$_interrupt = function _interrupt(animation) {
    $dfa0449af776674b$var$_removeFromParent(animation);
    animation.progress() < 1 && $dfa0449af776674b$var$_callback(animation, "onInterrupt");
    return animation;
}, $dfa0449af776674b$var$_quickTween, $dfa0449af776674b$var$_createPlugin = function _createPlugin(config) {
    config = !config.name && config["default"] || config; //UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    var name = config.name, isFunc = $dfa0449af776674b$var$_isFunction(config), Plugin = name && !isFunc && config.init ? function() {
        this._props = [];
    } : config, //in case someone passes in an object that's not a plugin, like CustomEase
    instanceDefaults = {
        init: $dfa0449af776674b$var$_emptyFunc,
        render: $dfa0449af776674b$var$_renderPropTweens,
        add: $dfa0449af776674b$var$_addPropTween,
        kill: $dfa0449af776674b$var$_killPropTweensOf,
        modifier: $dfa0449af776674b$var$_addPluginModifier,
        rawVars: 0
    }, statics = {
        targetTest: 0,
        get: 0,
        getSetter: $dfa0449af776674b$export$d60fbc1e0278aaf0,
        aliases: {},
        register: 0
    };
    $dfa0449af776674b$var$_wake();
    if (config !== Plugin) {
        if ($dfa0449af776674b$export$d305d8ec5d7c26b8[name]) return;
        $dfa0449af776674b$export$dc2b19673bb53610(Plugin, $dfa0449af776674b$export$dc2b19673bb53610($dfa0449af776674b$var$_copyExcluding(config, instanceDefaults), statics)); //static methods
        $dfa0449af776674b$var$_merge(Plugin.prototype, $dfa0449af776674b$var$_merge(instanceDefaults, $dfa0449af776674b$var$_copyExcluding(config, statics))); //instance methods
        $dfa0449af776674b$export$d305d8ec5d7c26b8[Plugin.prop = name] = Plugin;
        if (config.targetTest) {
            $dfa0449af776674b$var$_harnessPlugins.push(Plugin);
            $dfa0449af776674b$var$_reservedProps[name] = 1;
        }
        name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
    }
    $dfa0449af776674b$var$_addGlobal(name, Plugin);
    config.register && config.register($dfa0449af776674b$export$99ee26438460406a, Plugin, $dfa0449af776674b$export$3a67f7f44b1e838a);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ $dfa0449af776674b$var$_255 = 255, $dfa0449af776674b$var$_colorLookup = {
    aqua: [
        0,
        $dfa0449af776674b$var$_255,
        $dfa0449af776674b$var$_255
    ],
    lime: [
        0,
        $dfa0449af776674b$var$_255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        $dfa0449af776674b$var$_255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        $dfa0449af776674b$var$_255,
        $dfa0449af776674b$var$_255,
        $dfa0449af776674b$var$_255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        $dfa0449af776674b$var$_255,
        $dfa0449af776674b$var$_255,
        0
    ],
    orange: [
        $dfa0449af776674b$var$_255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        $dfa0449af776674b$var$_255,
        0,
        0
    ],
    pink: [
        $dfa0449af776674b$var$_255,
        192,
        203
    ],
    cyan: [
        0,
        $dfa0449af776674b$var$_255,
        $dfa0449af776674b$var$_255
    ],
    transparent: [
        $dfa0449af776674b$var$_255,
        $dfa0449af776674b$var$_255,
        $dfa0449af776674b$var$_255,
        0
    ]
}, $dfa0449af776674b$var$_hue = function _hue(h, m1, m2) {
    h = h < 0 ? h + 1 : h > 1 ? h - 1 : h;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * $dfa0449af776674b$var$_255 + .5 | 0;
}, $dfa0449af776674b$export$73d6f35be992df24 = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? $dfa0449af776674b$var$_colorLookup.black : $dfa0449af776674b$var$_isNumber(v) ? [
        v >> 16,
        v >> 8 & $dfa0449af776674b$var$_255,
        v & $dfa0449af776674b$var$_255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if ($dfa0449af776674b$var$_colorLookup[v]) a = $dfa0449af776674b$var$_colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & $dfa0449af776674b$var$_255,
                    a & $dfa0449af776674b$var$_255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & $dfa0449af776674b$var$_255,
                v & $dfa0449af776674b$var$_255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match($dfa0449af776674b$var$_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = $dfa0449af776674b$var$_hue(h + 1 / 3, r, g);
                a[1] = $dfa0449af776674b$var$_hue(h, r, g);
                a[2] = $dfa0449af776674b$var$_hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match($dfa0449af776674b$export$b9d44bb6523120d6);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match($dfa0449af776674b$var$_strictNumExp) || $dfa0449af776674b$var$_colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / $dfa0449af776674b$var$_255;
        g = a[1] / $dfa0449af776674b$var$_255;
        b = a[2] / $dfa0449af776674b$var$_255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, $dfa0449af776674b$var$_colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split($dfa0449af776674b$var$_colorExp).forEach(function(v) {
        var a = v.match($dfa0449af776674b$export$65c88bbd597e7b0a) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, $dfa0449af776674b$var$_formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match($dfa0449af776674b$var$_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = $dfa0449af776674b$export$73d6f35be992df24(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = $dfa0449af776674b$var$_colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace($dfa0449af776674b$var$_colorExp, "1").split($dfa0449af776674b$export$65c88bbd597e7b0a);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split($dfa0449af776674b$var$_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, $dfa0449af776674b$var$_colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in $dfa0449af776674b$var$_colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), $dfa0449af776674b$var$_hslExp = /hsl[a]?\(/, $dfa0449af776674b$export$7eb2e5eb5eeb96a4 = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    $dfa0449af776674b$var$_colorExp.lastIndex = 0;
    if ($dfa0449af776674b$var$_colorExp.test(combined)) {
        toHSL = $dfa0449af776674b$var$_hslExp.test(combined);
        a[1] = $dfa0449af776674b$var$_formatColors(a[1], toHSL);
        a[0] = $dfa0449af776674b$var$_formatColors(a[0], toHSL, $dfa0449af776674b$var$_colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ $dfa0449af776674b$var$_tickerActive, $dfa0449af776674b$export$762ed8fbedb691e3 = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if ($dfa0449af776674b$var$_coreReady) {
                if (!$dfa0449af776674b$var$_coreInitted && $dfa0449af776674b$var$_windowExists()) {
                    $dfa0449af776674b$var$_win = $dfa0449af776674b$var$_coreInitted = window;
                    $dfa0449af776674b$var$_doc = $dfa0449af776674b$var$_win.document || {};
                    $dfa0449af776674b$var$_globals.gsap = $dfa0449af776674b$export$99ee26438460406a;
                    ($dfa0449af776674b$var$_win.gsapVersions || ($dfa0449af776674b$var$_win.gsapVersions = [])).push($dfa0449af776674b$export$99ee26438460406a.version);
                    $dfa0449af776674b$var$_install($dfa0449af776674b$var$_installScope || $dfa0449af776674b$var$_win.GreenSockGlobals || !$dfa0449af776674b$var$_win.gsap && $dfa0449af776674b$var$_win || {});
                    _raf = $dfa0449af776674b$var$_win.requestAnimationFrame;
                }
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                $dfa0449af776674b$var$_tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? $dfa0449af776674b$var$_win.cancelAnimationFrame : clearTimeout)(_id);
            $dfa0449af776674b$var$_tickerActive = 0;
            _req = $dfa0449af776674b$var$_emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || 1 / $dfa0449af776674b$var$_tinyNum; //zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback) {
            _listeners.indexOf(callback) < 0 && _listeners.push(callback);
            $dfa0449af776674b$var$_wake();
        },
        remove: function remove(callback) {
            var i;
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), $dfa0449af776674b$var$_wake = function _wake() {
    return !$dfa0449af776674b$var$_tickerActive && $dfa0449af776674b$export$762ed8fbedb691e3.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ $dfa0449af776674b$var$_easeMap = {}, $dfa0449af776674b$var$_customEaseExp = /^[\d.\-M][\d.\-,\s]/, $dfa0449af776674b$var$_quotesExp = /["']/g, $dfa0449af776674b$var$_parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace($dfa0449af776674b$var$_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, $dfa0449af776674b$var$_valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, $dfa0449af776674b$var$_configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = $dfa0449af776674b$var$_easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        $dfa0449af776674b$var$_parseObjectInString(split[1])
    ] : $dfa0449af776674b$var$_valueInParentheses(name).split(",").map($dfa0449af776674b$var$_numericIfPossible)) : $dfa0449af776674b$var$_easeMap._CE && $dfa0449af776674b$var$_customEaseExp.test(name) ? $dfa0449af776674b$var$_easeMap._CE("", name) : ease;
}, $dfa0449af776674b$var$_invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
$dfa0449af776674b$var$_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof $dfa0449af776674b$export$e6a97ba2cae5bb94) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, $dfa0449af776674b$var$_parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : ($dfa0449af776674b$var$_isFunction(ease) ? ease : $dfa0449af776674b$var$_easeMap[ease] || $dfa0449af776674b$var$_configEaseFromString(ease)) || defaultEase;
}, $dfa0449af776674b$var$_insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    $dfa0449af776674b$export$f9000b814859f126(names, function(name) {
        $dfa0449af776674b$var$_easeMap[name] = $dfa0449af776674b$var$_globals[name] = ease;
        $dfa0449af776674b$var$_easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)$dfa0449af776674b$var$_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = $dfa0449af776674b$var$_easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, $dfa0449af776674b$var$_easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, $dfa0449af776674b$var$_configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / $dfa0449af776674b$var$_2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * $dfa0449af776674b$var$_sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $dfa0449af776674b$var$_easeInOutFromOut(easeOut);
    p2 = $dfa0449af776674b$var$_2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, $dfa0449af776674b$var$_configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : $dfa0449af776674b$var$_easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
$dfa0449af776674b$export$f9000b814859f126("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    $dfa0449af776674b$var$_insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
$dfa0449af776674b$var$_easeMap.Linear.easeNone = $dfa0449af776674b$var$_easeMap.none = $dfa0449af776674b$var$_easeMap.Linear.easeIn;
$dfa0449af776674b$var$_insertEase("Elastic", $dfa0449af776674b$var$_configElastic("in"), $dfa0449af776674b$var$_configElastic("out"), $dfa0449af776674b$var$_configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    $dfa0449af776674b$var$_insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
$dfa0449af776674b$var$_insertEase("Expo", function(p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
$dfa0449af776674b$var$_insertEase("Circ", function(p) {
    return -($dfa0449af776674b$var$_sqrt(1 - p * p) - 1);
});
$dfa0449af776674b$var$_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -$dfa0449af776674b$var$_cos(p * $dfa0449af776674b$var$_HALF_PI) + 1;
});
$dfa0449af776674b$var$_insertEase("Back", $dfa0449af776674b$var$_configBack("in"), $dfa0449af776674b$var$_configBack("out"), $dfa0449af776674b$var$_configBack());
$dfa0449af776674b$var$_easeMap.SteppedEase = $dfa0449af776674b$var$_easeMap.steps = $dfa0449af776674b$var$_globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - $dfa0449af776674b$var$_tinyNum;
        return function(p) {
            return ((p2 * $dfa0449af776674b$var$_clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
$dfa0449af776674b$var$_defaults.ease = $dfa0449af776674b$var$_easeMap["quad.out"];
$dfa0449af776674b$export$f9000b814859f126("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return $dfa0449af776674b$var$_callbackNames += name + "," + name + "Params,";
});
var $dfa0449af776674b$export$cf10981d5419cad5 = function GSCache(target, harness) {
    this.id = $dfa0449af776674b$var$_gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : $dfa0449af776674b$export$51d6bbe898aef1f9;
    this.set = harness ? harness.getSetter : $dfa0449af776674b$export$d60fbc1e0278aaf0;
};
var $dfa0449af776674b$export$c35d437ae5945fcd = /*#__PURE__*/ function() {
    function Animation(vars, time) {
        var parent = vars.parent || $dfa0449af776674b$var$_globalTimeline;
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        $dfa0449af776674b$var$_setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        $dfa0449af776674b$var$_tickerActive || $dfa0449af776674b$export$762ed8fbedb691e3.wake();
        parent && $dfa0449af776674b$var$_addToTimeline(parent, this, time || time === 0 ? time : parent._time, 1);
        vars.reversed && this.reverse();
        vars.paused && this.paused(true);
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return $dfa0449af776674b$var$_setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        $dfa0449af776674b$var$_wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            $dfa0449af776674b$var$_alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || $dfa0449af776674b$var$_postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            $dfa0449af776674b$var$_addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === $dfa0449af776674b$var$_tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            $dfa0449af776674b$var$_lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + $dfa0449af776674b$var$_elapsedCycleDuration(this)) % this._dur || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + $dfa0449af776674b$var$_elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? $dfa0449af776674b$var$_animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value) {
        if (!arguments.length) return this._rts === -$dfa0449af776674b$var$_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? $dfa0449af776674b$var$_parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -$dfa0449af776674b$var$_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        return $dfa0449af776674b$var$_recacheAncestors(this.totalTime($dfa0449af776674b$var$_clamp(-this._delay, this._tDur, tTime), true));
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                $dfa0449af776674b$var$_wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && (this._tTime -= $dfa0449af776674b$var$_tinyNum) && Math.abs(this._zTime) !== $dfa0449af776674b$var$_tinyNum); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = value;
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && $dfa0449af776674b$var$_addToTimeline(parent, this, value - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + ($dfa0449af776674b$var$_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detatched parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : $dfa0449af776674b$var$_parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (animation._ts || 1);
            animation = animation._dp;
        }
        return time;
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return $dfa0449af776674b$var$_onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            this._rDelay = value;
            return $dfa0449af776674b$var$_onUpdateTotalDuration(this);
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime($dfa0449af776674b$var$_parsePosition(this, position), $dfa0449af776674b$var$_isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        return this.play().totalTime(includeDelay ? -this._delay : 0, $dfa0449af776674b$var$_isNotFalse(suppressEvents));
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -$dfa0449af776674b$var$_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -$dfa0449af776674b$var$_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - $dfa0449af776674b$var$_tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
            var f = $dfa0449af776674b$var$_isFunction(onFulfilled) ? onFulfilled : $dfa0449af776674b$var$_passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                $dfa0449af776674b$var$_isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        $dfa0449af776674b$var$_interrupt(this);
    };
    return Animation;
}();
$dfa0449af776674b$export$dc2b19673bb53610($dfa0449af776674b$export$c35d437ae5945fcd.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -$dfa0449af776674b$var$_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var $dfa0449af776674b$export$e6a97ba2cae5bb94 = /*#__PURE__*/ function(_Animation) {
    $dfa0449af776674b$var$_inheritsLoose(Timeline, _Animation);
    function Timeline(vars, time) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars, time) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = $dfa0449af776674b$var$_isNotFalse(vars.sortChildren);
        _this.parent && $dfa0449af776674b$var$_postAddChecks(_this.parent, $dfa0449af776674b$var$_assertThisInitialized(_this));
        vars.scrollTrigger && $dfa0449af776674b$var$_scrollTrigger($dfa0449af776674b$var$_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        new $dfa0449af776674b$export$208a41d6b4e37b97(targets, $dfa0449af776674b$var$_parseVars(arguments, 0, this), $dfa0449af776674b$var$_parsePosition(this, $dfa0449af776674b$var$_isNumber(vars) ? arguments[3] : position));
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        new $dfa0449af776674b$export$208a41d6b4e37b97(targets, $dfa0449af776674b$var$_parseVars(arguments, 1, this), $dfa0449af776674b$var$_parsePosition(this, $dfa0449af776674b$var$_isNumber(vars) ? arguments[3] : position));
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        new $dfa0449af776674b$export$208a41d6b4e37b97(targets, $dfa0449af776674b$var$_parseVars(arguments, 2, this), $dfa0449af776674b$var$_parsePosition(this, $dfa0449af776674b$var$_isNumber(fromVars) ? arguments[4] : position));
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        $dfa0449af776674b$var$_inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new $dfa0449af776674b$export$208a41d6b4e37b97(targets, vars, $dfa0449af776674b$var$_parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return $dfa0449af776674b$var$_addToTimeline(this, $dfa0449af776674b$export$208a41d6b4e37b97.delayedCall(0, callback, params), $dfa0449af776674b$var$_parsePosition(this, position));
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new $dfa0449af776674b$export$208a41d6b4e37b97(targets, vars, $dfa0449af776674b$var$_parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        $dfa0449af776674b$var$_inheritDefaults(vars).immediateRender = $dfa0449af776674b$var$_isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        $dfa0449af776674b$var$_inheritDefaults(toVars).immediateRender = $dfa0449af776674b$var$_isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = this !== $dfa0449af776674b$var$_globalTimeline && totalTime > tDur - $dfa0449af776674b$var$_tinyNum && totalTime >= 0 ? tDur : totalTime < $dfa0449af776674b$var$_tinyNum ? 0 : totalTime, crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $dfa0449af776674b$export$9c8d725d65e13f94(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = $dfa0449af776674b$var$_animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://greensock.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : dur;
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : $dfa0449af776674b$export$9c8d725d65e13f94(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    !suppressEvents && this.parent && $dfa0449af776674b$var$_callback(this, "onRepeat");
                    this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
                    if (prevTime !== this._time || prevPaused !== !this._ts) return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    $dfa0449af776674b$var$_propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = $dfa0449af776674b$var$_findNextPauseTween(this, $dfa0449af776674b$export$9c8d725d65e13f94(prevTime), $dfa0449af776674b$export$9c8d725d65e13f94(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            !prevTime && (time || !dur && totalTime >= 0) && !suppressEvents && $dfa0449af776674b$var$_callback(this, "onStart");
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -$dfa0449af776674b$var$_tinyNum); // it didn't finish rendering, so flag zTime as negative so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -$dfa0449af776674b$var$_tinyNum : $dfa0449af776674b$var$_tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -$dfa0449af776674b$var$_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    $dfa0449af776674b$var$_setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && $dfa0449af776674b$var$_callback(this, "onUpdate", true);
            if (tTime === tDur && tDur >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && $dfa0449af776674b$var$_removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime)) {
                            $dfa0449af776674b$var$_callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        $dfa0449af776674b$var$_isNumber(position) || (position = $dfa0449af776674b$var$_parsePosition(this, position));
        if (!(child instanceof $dfa0449af776674b$export$c35d437ae5945fcd)) {
            if ($dfa0449af776674b$var$_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if ($dfa0449af776674b$export$f664476fd67145ca(child)) return this.addLabel(child, position);
            if ($dfa0449af776674b$var$_isFunction(child)) child = $dfa0449af776674b$export$208a41d6b4e37b97.delayedCall(0, child);
            else return this;
        }
        return this !== child ? $dfa0449af776674b$var$_addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -$dfa0449af776674b$var$_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof $dfa0449af776674b$export$208a41d6b4e37b97) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if ($dfa0449af776674b$export$f664476fd67145ca(child)) return this.removeLabel(child);
        if ($dfa0449af776674b$var$_isFunction(child)) return this.killTweensOf(child);
        $dfa0449af776674b$export$cd008aa6cd8844e3(this, child);
        if (child === this._recent) this._recent = this._last;
        return $dfa0449af776674b$var$_uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = $dfa0449af776674b$export$9c8d725d65e13f94($dfa0449af776674b$export$762ed8fbedb691e3.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = $dfa0449af776674b$var$_parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = $dfa0449af776674b$export$208a41d6b4e37b97.delayedCall(0, callback || $dfa0449af776674b$var$_emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return $dfa0449af776674b$var$_addToTimeline(this, t, $dfa0449af776674b$var$_parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = $dfa0449af776674b$var$_parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") $dfa0449af776674b$var$_removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)$dfa0449af776674b$var$_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = $dfa0449af776674b$export$45b10814cc054894(targets), child = this._first, isGlobalTime = $dfa0449af776674b$var$_isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof $dfa0449af776674b$export$208a41d6b4e37b97) {
                if ($dfa0449af776674b$var$_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!$dfa0449af776674b$var$_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = $dfa0449af776674b$var$_parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, tween = $dfa0449af776674b$export$208a41d6b4e37b97.to(tl, $dfa0449af776674b$export$dc2b19673bb53610({
            ease: "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || $dfa0449af776674b$var$_tinyNum,
            onStart: function onStart() {
                tl.pause();
                var duration = vars.duration || Math.abs((endTime - tl._time) / tl.timeScale());
                tween._dur !== duration && $dfa0449af776674b$var$_setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, $dfa0449af776674b$export$dc2b19673bb53610({
            startAt: {
                time: $dfa0449af776674b$var$_parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return $dfa0449af776674b$var$_getLabelInDirection(this, $dfa0449af776674b$var$_parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return $dfa0449af776674b$var$_getLabelInDirection(this, $dfa0449af776674b$var$_parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + $dfa0449af776674b$var$_tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return $dfa0449af776674b$var$_uncache(this);
    };
    _proto2.invalidate = function invalidate() {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate();
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return $dfa0449af776674b$var$_uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = $dfa0449af776674b$var$_bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    $dfa0449af776674b$var$_addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += start / self._ts;
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            $dfa0449af776674b$var$_setDuration(self, self === $dfa0449af776674b$var$_globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if ($dfa0449af776674b$var$_globalTimeline._ts) {
            $dfa0449af776674b$var$_lazySafeRender($dfa0449af776674b$var$_globalTimeline, $dfa0449af776674b$var$_parentToChildTotalTime(time, $dfa0449af776674b$var$_globalTimeline));
            $dfa0449af776674b$var$_lastRenderedFrame = $dfa0449af776674b$export$762ed8fbedb691e3.frame;
        }
        if ($dfa0449af776674b$export$762ed8fbedb691e3.frame >= $dfa0449af776674b$var$_nextGCFrame) {
            $dfa0449af776674b$var$_nextGCFrame += $dfa0449af776674b$export$4922bee768729a77.autoSleep || 120;
            var child = $dfa0449af776674b$var$_globalTimeline._first;
            if (!child || !child._ts) {
                if ($dfa0449af776674b$export$4922bee768729a77.autoSleep && $dfa0449af776674b$export$762ed8fbedb691e3._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || $dfa0449af776674b$export$762ed8fbedb691e3.sleep();
                }
            }
        }
    };
    return Timeline;
}($dfa0449af776674b$export$c35d437ae5945fcd);
$dfa0449af776674b$export$dc2b19673bb53610($dfa0449af776674b$export$e6a97ba2cae5bb94.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var $dfa0449af776674b$var$_addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new $dfa0449af776674b$export$3a67f7f44b1e838a(this._pt, target, prop, 0, 1, $dfa0449af776674b$export$c5bc8e04394ecb2, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = $dfa0449af776674b$export$d5962a97e3cde94d(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match($dfa0449af776674b$var$_complexStringNumExp) || [];
    while(result = $dfa0449af776674b$var$_complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? parseFloat(endNum.substr(2)) * (endNum.charAt(0) === "-" ? -1 : 1) : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = $dfa0449af776674b$var$_complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if ($dfa0449af776674b$export$5a680e28b0b61bc.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, $dfa0449af776674b$var$_addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam) {
    $dfa0449af776674b$var$_isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !$dfa0449af776674b$var$_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !$dfa0449af776674b$var$_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !$dfa0449af776674b$var$_isFunction(currentValue) ? $dfa0449af776674b$var$_setterPlain : funcParam ? $dfa0449af776674b$var$_setterFuncWithParam : $dfa0449af776674b$var$_setterFunc, pt;
    if ($dfa0449af776674b$export$f664476fd67145ca(end)) {
        if (~end.indexOf("random(")) end = $dfa0449af776674b$export$d5962a97e3cde94d(end);
        if (end.charAt(1) === "=") end = parseFloat(parsedStart) + parseFloat(end.substr(2)) * (end.charAt(0) === "-" ? -1 : 1) + ($dfa0449af776674b$export$65f2564e9a9b9222(parsedStart) || 0);
    }
    if (parsedStart !== end) {
        if (!isNaN(parsedStart * end)) {
            pt = new $dfa0449af776674b$export$3a67f7f44b1e838a(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? $dfa0449af776674b$var$_renderBoolean : $dfa0449af776674b$var$_renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && $dfa0449af776674b$export$7fb54635790b59a5(prop, end);
        return $dfa0449af776674b$var$_addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || $dfa0449af776674b$export$4922bee768729a77.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
$dfa0449af776674b$var$_processVars = function _processVars(vars, index, target, targets, tween) {
    $dfa0449af776674b$var$_isFunction(vars) && (vars = $dfa0449af776674b$var$_parseFuncOrString(vars, tween, index, target, targets));
    if (!$dfa0449af776674b$var$_isObject(vars) || vars.style && vars.nodeType || $dfa0449af776674b$var$_isArray(vars) || $dfa0449af776674b$var$_isTypedArray(vars)) return $dfa0449af776674b$export$f664476fd67145ca(vars) ? $dfa0449af776674b$var$_parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = $dfa0449af776674b$var$_parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, $dfa0449af776674b$export$5c457b74208010cf = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if ($dfa0449af776674b$export$d305d8ec5d7c26b8[property] && (plugin = new $dfa0449af776674b$export$d305d8ec5d7c26b8[property]()).init(target, plugin.rawVars ? vars[property] : $dfa0449af776674b$var$_processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new $dfa0449af776674b$export$3a67f7f44b1e838a(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== $dfa0449af776674b$var$_quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, $dfa0449af776674b$var$_overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
$dfa0449af776674b$var$_initTween = function _initTween(tween, time) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, onUpdateParams = vars.onUpdateParams, callbackScope = vars.callbackScope, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.parent._targets : targets, autoOverwrite = tween._overwrite === "auto" && !$dfa0449af776674b$var$_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = $dfa0449af776674b$var$_parseEase(ease, $dfa0449af776674b$var$_defaults.ease);
    tween._yEase = yoyoEase ? $dfa0449af776674b$var$_invertEase($dfa0449af776674b$var$_parseEase(yoyoEase === true ? ease : yoyoEase, $dfa0449af776674b$var$_defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    if (!tl) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? $dfa0449af776674b$export$8b9be379d2de2a39(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = $dfa0449af776674b$var$_copyExcluding(vars, $dfa0449af776674b$var$_reservedProps);
        prevStartAt && prevStartAt.render(-1, true).kill();
        if (startAt) {
            $dfa0449af776674b$var$_removeFromParent(tween._startAt = $dfa0449af776674b$export$208a41d6b4e37b97.set(targets, $dfa0449af776674b$export$dc2b19673bb53610({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: $dfa0449af776674b$var$_isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate,
                onUpdateParams: onUpdateParams,
                callbackScope: callbackScope,
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            if (immediateRender) {
                if (time > 0) autoRevert || (tween._startAt = 0); //tweens that render immediately (like most from() and fromTo() tweens) shouldn't revert when their parent timeline's playhead goes backward past the startTime because the initial render could have happened anytime and it shouldn't be directly correlated to this tween's startTime. Imagine setting up a complex animation where the beginning states of various objects are rendered immediately but the tween doesn't happen for quite some time - if we revert to the starting values as soon as the playhead goes backward past the tween's startTime, it will throw things off visually. Reversion should only happen in Timeline instances where immediateRender was false or when autoRevert is explicitly set to true.
                else if (dur && !(time < 0 && prevStartAt)) {
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) {
            //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
            if (prevStartAt) !autoRevert && (tween._startAt = 0);
            else {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = $dfa0449af776674b$export$dc2b19673bb53610({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && $dfa0449af776674b$var$_isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y:gsap.utils.wrap([-100,100])})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                $dfa0449af776674b$var$_removeFromParent(tween._startAt = $dfa0449af776674b$export$208a41d6b4e37b97.set(targets, p));
                if (!immediateRender) _initTween(tween._startAt, $dfa0449af776674b$var$_tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = 0;
        lazy = dur && $dfa0449af776674b$var$_isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || $dfa0449af776674b$var$_harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            $dfa0449af776674b$var$_lazyLookup[gsData.id] && $dfa0449af776674b$var$_lazyTweens.length && $dfa0449af776674b$var$_lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new $dfa0449af776674b$export$3a67f7f44b1e838a(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if ($dfa0449af776674b$export$d305d8ec5d7c26b8[p] && (plugin = $dfa0449af776674b$export$5c457b74208010cf(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = $dfa0449af776674b$var$_addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                $dfa0449af776674b$var$_overwritingTween = tween;
                $dfa0449af776674b$var$_globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(0)); //Also make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                $dfa0449af776674b$var$_overwritingTween = 0;
            }
            tween._pt && lazy && ($dfa0449af776674b$var$_lazyLookup[gsData.id] = 1);
        }
        hasPriority && $dfa0449af776674b$export$eed5824f53346d57(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
}, $dfa0449af776674b$var$_addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? $dfa0449af776674b$export$8b9be379d2de2a39(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = $dfa0449af776674b$var$_merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, $dfa0449af776674b$var$_parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return $dfa0449af776674b$var$_isFunction(value) ? value.call(tween, i, target, targets) : $dfa0449af776674b$export$f664476fd67145ca(value) && ~value.indexOf("random(") ? $dfa0449af776674b$export$d5962a97e3cde94d(value) : value;
}, $dfa0449af776674b$var$_staggerTweenProps = $dfa0449af776674b$var$_callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase", $dfa0449af776674b$var$_staggerPropsToSkip = ($dfa0449af776674b$var$_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger").split(",");
var $dfa0449af776674b$export$208a41d6b4e37b97 = /*#__PURE__*/ function(_Animation2) {
    $dfa0449af776674b$var$_inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, time, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            time.duration = vars;
            vars = time;
            time = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : $dfa0449af776674b$var$_inheritDefaults(vars), time) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = _this3.parent, parsedTargets = ($dfa0449af776674b$var$_isArray(targets) || $dfa0449af776674b$var$_isTypedArray(targets) ? $dfa0449af776674b$var$_isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : $dfa0449af776674b$export$45b10814cc054894(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? $dfa0449af776674b$var$_harness(parsedTargets) : $dfa0449af776674b$var$_warn("GSAP target " + targets + " not found. https://greensock.com", !$dfa0449af776674b$export$4922bee768729a77.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || $dfa0449af776674b$var$_isFuncOrString(duration) || $dfa0449af776674b$var$_isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new $dfa0449af776674b$export$e6a97ba2cae5bb94({
                data: "nested",
                defaults: defaults || {}
            });
            tl.kill();
            tl.parent = tl._dp = $dfa0449af776674b$var$_assertThisInitialized(_this3);
            tl._start = 0;
            if (keyframes) {
                $dfa0449af776674b$export$dc2b19673bb53610(tl.vars.defaults, {
                    ease: "none"
                });
                keyframes.forEach(function(frame) {
                    return tl.to(parsedTargets, frame, ">");
                });
            } else {
                l = parsedTargets.length;
                staggerFunc = stagger ? $dfa0449af776674b$export$f02a9ddbe4480f19(stagger) : $dfa0449af776674b$var$_emptyFunc;
                if ($dfa0449af776674b$var$_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~$dfa0449af776674b$var$_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = {};
                    for(p in vars)if ($dfa0449af776674b$var$_staggerPropsToSkip.indexOf(p) < 0) copy[p] = vars[p];
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && $dfa0449af776674b$var$_merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +$dfa0449af776674b$var$_parseFuncOrString(duration, $dfa0449af776674b$var$_assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+$dfa0449af776674b$var$_parseFuncOrString(delay, $dfa0449af776674b$var$_assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc(i, curTarget, parsedTargets));
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !$dfa0449af776674b$var$_suppressOverwrites) {
            $dfa0449af776674b$var$_overwritingTween = $dfa0449af776674b$var$_assertThisInitialized(_this3);
            $dfa0449af776674b$var$_globalTimeline.killTweensOf(parsedTargets);
            $dfa0449af776674b$var$_overwritingTween = 0;
        }
        parent && $dfa0449af776674b$var$_postAddChecks(parent, $dfa0449af776674b$var$_assertThisInitialized(_this3));
        if (immediateRender || !duration && !keyframes && _this3._start === $dfa0449af776674b$export$9c8d725d65e13f94(parent._time) && $dfa0449af776674b$var$_isNotFalse(immediateRender) && $dfa0449af776674b$var$_hasNoPausedAncestors($dfa0449af776674b$var$_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -$dfa0449af776674b$var$_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay)); //in case delay is negative
        }
        scrollTrigger && $dfa0449af776674b$var$_scrollTrigger($dfa0449af776674b$var$_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, tTime = totalTime > tDur - $dfa0449af776674b$var$_tinyNum && totalTime >= 0 ? tDur : totalTime < $dfa0449af776674b$var$_tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) $dfa0449af776674b$var$_renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== totalTime < 0) {
            //this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = $dfa0449af776674b$export$9c8d725d65e13f94(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    iteration = ~~(tTime / cycleDuration);
                    if (iteration && iteration === tTime / cycleDuration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = $dfa0449af776674b$var$_animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted) //could be during the repeatDelay part. No need to render and fire callbacks.
                return this;
                if (iteration !== prevIteration) {
                    timeline && this._yEase && $dfa0449af776674b$var$_propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render($dfa0449af776674b$export$9c8d725d65e13f94(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if ($dfa0449af776674b$var$_attemptInitTween(this, totalTime < 0 ? totalTime : time, force, suppressEvents)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            time && !prevTime && !suppressEvents && $dfa0449af776674b$var$_callback(this, "onStart");
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -$dfa0449af776674b$var$_tinyNum : timeline._dur * ratio, suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                totalTime < 0 && this._startAt && this._startAt.render(totalTime, true, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                $dfa0449af776674b$var$_callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && $dfa0449af776674b$var$_callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                totalTime < 0 && this._startAt && !this._onUpdate && this._startAt.render(totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && $dfa0449af776674b$var$_removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    $dfa0449af776674b$var$_callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate() {
        this._pt = this._op = this._startAt = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate();
        return _Animation2.prototype.invalidate.call(this);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            return this.parent ? $dfa0449af776674b$var$_interrupt(this) : this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, $dfa0449af776674b$var$_overwritingTween && $dfa0449af776674b$var$_overwritingTween.vars.overwrite !== true)._first || $dfa0449af776674b$var$_interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && $dfa0449af776674b$var$_setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? $dfa0449af776674b$export$45b10814cc054894(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && $dfa0449af776674b$var$_arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return $dfa0449af776674b$var$_interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if ($dfa0449af776674b$export$f664476fd67145ca(vars)) {
                p = {};
                $dfa0449af776674b$export$f9000b814859f126(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = $dfa0449af776674b$var$_addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) $dfa0449af776674b$export$cd008aa6cd8844e3(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && $dfa0449af776674b$var$_interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return new Tween(targets, $dfa0449af776674b$var$_parseVars(arguments, 1));
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        });
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return new Tween(targets, $dfa0449af776674b$var$_parseVars(arguments, 2));
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return $dfa0449af776674b$var$_globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}($dfa0449af776674b$export$c35d437ae5945fcd);
$dfa0449af776674b$export$dc2b19673bb53610($dfa0449af776674b$export$208a41d6b4e37b97.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
$dfa0449af776674b$export$f9000b814859f126("staggerTo,staggerFrom,staggerFromTo", function(name) {
    $dfa0449af776674b$export$208a41d6b4e37b97[name] = function() {
        var tl = new $dfa0449af776674b$export$e6a97ba2cae5bb94(), params = $dfa0449af776674b$var$_slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var $dfa0449af776674b$var$_setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, $dfa0449af776674b$var$_setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, $dfa0449af776674b$var$_setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, $dfa0449af776674b$var$_setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, $dfa0449af776674b$export$d60fbc1e0278aaf0 = function _getSetter(target, property) {
    return $dfa0449af776674b$var$_isFunction(target[property]) ? $dfa0449af776674b$var$_setterFunc : $dfa0449af776674b$export$a8178c063a9fd3a1(target[property]) && target.setAttribute ? $dfa0449af776674b$var$_setterAttribute : $dfa0449af776674b$var$_setterPlain;
}, $dfa0449af776674b$var$_renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000, data);
}, $dfa0449af776674b$var$_renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, $dfa0449af776674b$export$c5bc8e04394ecb2 = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, $dfa0449af776674b$var$_renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, $dfa0449af776674b$var$_addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, $dfa0449af776674b$var$_killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) $dfa0449af776674b$export$cd008aa6cd8844e3(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, $dfa0449af776674b$var$_setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, $dfa0449af776674b$export$eed5824f53346d57 = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var $dfa0449af776674b$export$3a67f7f44b1e838a = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || $dfa0449af776674b$var$_renderPlain;
        this.d = data || this;
        this.set = setter || $dfa0449af776674b$var$_setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = $dfa0449af776674b$var$_setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
$dfa0449af776674b$export$f9000b814859f126($dfa0449af776674b$var$_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return $dfa0449af776674b$var$_reservedProps[name] = 1;
});
$dfa0449af776674b$var$_globals.TweenMax = $dfa0449af776674b$var$_globals.TweenLite = $dfa0449af776674b$export$208a41d6b4e37b97;
$dfa0449af776674b$var$_globals.TimelineLite = $dfa0449af776674b$var$_globals.TimelineMax = $dfa0449af776674b$export$e6a97ba2cae5bb94;
$dfa0449af776674b$var$_globalTimeline = new $dfa0449af776674b$export$e6a97ba2cae5bb94({
    sortChildren: false,
    defaults: $dfa0449af776674b$var$_defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
$dfa0449af776674b$export$4922bee768729a77.stringFilter = $dfa0449af776674b$export$7eb2e5eb5eeb96a4;
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var $dfa0449af776674b$var$_gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return $dfa0449af776674b$var$_createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new $dfa0449af776674b$export$e6a97ba2cae5bb94(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return $dfa0449af776674b$var$_globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        $dfa0449af776674b$export$f664476fd67145ca(target) && (target = $dfa0449af776674b$export$45b10814cc054894(target)[0]); //in case selector text or an array is passed in
        var getter = $dfa0449af776674b$export$8b9be379d2de2a39(target || {}).get, format = unit ? $dfa0449af776674b$var$_passThrough : $dfa0449af776674b$var$_numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format(($dfa0449af776674b$export$d305d8ec5d7c26b8[property] && $dfa0449af776674b$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache));
        } : format(($dfa0449af776674b$export$d305d8ec5d7c26b8[property] && $dfa0449af776674b$export$d305d8ec5d7c26b8[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = $dfa0449af776674b$export$45b10814cc054894(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return $dfa0449af776674b$export$99ee26438460406a.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = $dfa0449af776674b$export$d305d8ec5d7c26b8[property], cache = $dfa0449af776674b$export$8b9be379d2de2a39(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            $dfa0449af776674b$var$_quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, $dfa0449af776674b$var$_quickTween, 0, [
                target
            ]);
            p.render(1, p);
            $dfa0449af776674b$var$_quickTween._pt && $dfa0449af776674b$var$_renderPropTweens(1, $dfa0449af776674b$var$_quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    isTweening: function isTweening(targets) {
        return $dfa0449af776674b$var$_globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = $dfa0449af776674b$var$_parseEase(value.ease, $dfa0449af776674b$var$_defaults.ease));
        return $dfa0449af776674b$var$_mergeDeep($dfa0449af776674b$var$_defaults, value || {});
    },
    config: function config(value) {
        return $dfa0449af776674b$var$_mergeDeep($dfa0449af776674b$export$4922bee768729a77, value || {});
    },
    registerEffect: function registerEffect(_ref2) {
        var name = _ref2.name, effect = _ref2.effect, plugins = _ref2.plugins, defaults = _ref2.defaults, extendTimeline = _ref2.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !$dfa0449af776674b$export$d305d8ec5d7c26b8[pluginName] && !$dfa0449af776674b$var$_globals[pluginName] && $dfa0449af776674b$var$_warn(name + " effect requires " + pluginName + " plugin.");
        });
        $dfa0449af776674b$var$_effects[name] = function(targets, vars, tl) {
            return effect($dfa0449af776674b$export$45b10814cc054894(targets), $dfa0449af776674b$export$dc2b19673bb53610(vars || {}, defaults), tl);
        };
        if (extendTimeline) $dfa0449af776674b$export$e6a97ba2cae5bb94.prototype[name] = function(targets, vars, position) {
            return this.add($dfa0449af776674b$var$_effects[name](targets, $dfa0449af776674b$var$_isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        $dfa0449af776674b$var$_easeMap[name] = $dfa0449af776674b$var$_parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? $dfa0449af776674b$var$_parseEase(ease, defaultEase) : $dfa0449af776674b$var$_easeMap;
    },
    getById: function getById(id) {
        return $dfa0449af776674b$var$_globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new $dfa0449af776674b$export$e6a97ba2cae5bb94(vars), child, next;
        tl.smoothChildTiming = $dfa0449af776674b$var$_isNotFalse(vars.smoothChildTiming);
        $dfa0449af776674b$var$_globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = $dfa0449af776674b$var$_globalTimeline._time;
        child = $dfa0449af776674b$var$_globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof $dfa0449af776674b$export$208a41d6b4e37b97 && child.vars.onComplete === child._targets[0])) $dfa0449af776674b$var$_addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        $dfa0449af776674b$var$_addToTimeline($dfa0449af776674b$var$_globalTimeline, tl, 0);
        return tl;
    },
    utils: {
        wrap: $dfa0449af776674b$export$4997ffc0176396a6,
        wrapYoyo: $dfa0449af776674b$export$cfc0b067273edc55,
        distribute: $dfa0449af776674b$export$f02a9ddbe4480f19,
        random: $dfa0449af776674b$export$4385e60b38654f68,
        snap: $dfa0449af776674b$export$51a0620f7a28532b,
        normalize: $dfa0449af776674b$export$a3295358bff77e,
        getUnit: $dfa0449af776674b$export$65f2564e9a9b9222,
        clamp: $dfa0449af776674b$export$7d15b64cf5a3a4c4,
        splitColor: $dfa0449af776674b$export$73d6f35be992df24,
        toArray: $dfa0449af776674b$export$45b10814cc054894,
        mapRange: $dfa0449af776674b$export$f65a7599bbc6b121,
        pipe: $dfa0449af776674b$export$a4627e546088548d,
        unitize: $dfa0449af776674b$export$d7502930aa5492de,
        interpolate: $dfa0449af776674b$export$89e29e4ab65e70a9,
        shuffle: $dfa0449af776674b$export$448332262467e042
    },
    install: $dfa0449af776674b$var$_install,
    effects: $dfa0449af776674b$var$_effects,
    ticker: $dfa0449af776674b$export$762ed8fbedb691e3,
    updateRoot: $dfa0449af776674b$export$e6a97ba2cae5bb94.updateRoot,
    plugins: $dfa0449af776674b$export$d305d8ec5d7c26b8,
    globalTimeline: $dfa0449af776674b$var$_globalTimeline,
    core: {
        PropTween: $dfa0449af776674b$export$3a67f7f44b1e838a,
        globals: $dfa0449af776674b$var$_addGlobal,
        Tween: $dfa0449af776674b$export$208a41d6b4e37b97,
        Timeline: $dfa0449af776674b$export$e6a97ba2cae5bb94,
        Animation: $dfa0449af776674b$export$c35d437ae5945fcd,
        getCache: $dfa0449af776674b$export$8b9be379d2de2a39,
        _removeLinkedListItem: $dfa0449af776674b$export$cd008aa6cd8844e3,
        suppressOverwrites: function suppressOverwrites(value) {
            return $dfa0449af776674b$var$_suppressOverwrites = value;
        }
    }
};
$dfa0449af776674b$export$f9000b814859f126("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return $dfa0449af776674b$var$_gsap[name] = $dfa0449af776674b$export$208a41d6b4e37b97[name];
});
$dfa0449af776674b$export$762ed8fbedb691e3.add($dfa0449af776674b$export$e6a97ba2cae5bb94.updateRoot);
$dfa0449af776674b$var$_quickTween = $dfa0449af776674b$var$_gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var $dfa0449af776674b$var$_getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, $dfa0449af776674b$var$_addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = $dfa0449af776674b$var$_getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, $dfa0449af776674b$var$_buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if ($dfa0449af776674b$export$f664476fd67145ca(vars)) {
                    temp = {};
                    $dfa0449af776674b$export$f9000b814859f126(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                $dfa0449af776674b$var$_addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var $dfa0449af776674b$export$99ee26438460406a = $dfa0449af776674b$var$_gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt;
        for(p in vars){
            pt = this.add(target, "setAttribute", (target.getAttribute(p) || 0) + "", vars[p], index, targets, 0, 0, p);
            pt && (pt.op = p);
            this._props.push(p);
        }
    }
}, {
    name: "endArray",
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i]);
    }
}, $dfa0449af776674b$var$_buildModifierPlugin("roundProps", $dfa0449af776674b$export$dd12390e6b265a17), $dfa0449af776674b$var$_buildModifierPlugin("modifiers"), $dfa0449af776674b$var$_buildModifierPlugin("snap", $dfa0449af776674b$export$51a0620f7a28532b)) || $dfa0449af776674b$var$_gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
$dfa0449af776674b$export$208a41d6b4e37b97.version = $dfa0449af776674b$export$e6a97ba2cae5bb94.version = $dfa0449af776674b$export$99ee26438460406a.version = "3.6.0";
$dfa0449af776674b$var$_coreReady = 1;
if ($dfa0449af776674b$var$_windowExists()) $dfa0449af776674b$var$_wake();
var $dfa0449af776674b$export$2fae1e8613537d5f = $dfa0449af776674b$var$_easeMap.Power0, $dfa0449af776674b$export$5d84ab4efbecec39 = $dfa0449af776674b$var$_easeMap.Power1, $dfa0449af776674b$export$d8c694b7490ad65d = $dfa0449af776674b$var$_easeMap.Power2, $dfa0449af776674b$export$acebdf2b184a0b6f = $dfa0449af776674b$var$_easeMap.Power3, $dfa0449af776674b$export$42e40a141003d2f0 = $dfa0449af776674b$var$_easeMap.Power4, $dfa0449af776674b$export$cff00ccf6e2392de = $dfa0449af776674b$var$_easeMap.Linear, $dfa0449af776674b$export$7005c9eb6671414d = $dfa0449af776674b$var$_easeMap.Quad, $dfa0449af776674b$export$755261d5a1567778 = $dfa0449af776674b$var$_easeMap.Cubic, $dfa0449af776674b$export$daf531446cad3d2a = $dfa0449af776674b$var$_easeMap.Quart, $dfa0449af776674b$export$4c407d38ce8ad8cc = $dfa0449af776674b$var$_easeMap.Quint, $dfa0449af776674b$export$f301627d437cff88 = $dfa0449af776674b$var$_easeMap.Strong, $dfa0449af776674b$export$56ebabebb04a9ca9 = $dfa0449af776674b$var$_easeMap.Elastic, $dfa0449af776674b$export$25e48ac541203d4a = $dfa0449af776674b$var$_easeMap.Back, $dfa0449af776674b$export$f7a11c7543d81853 = $dfa0449af776674b$var$_easeMap.SteppedEase, $dfa0449af776674b$export$d20e79fdc3899e95 = $dfa0449af776674b$var$_easeMap.Bounce, $dfa0449af776674b$export$bed2d20ad96b784c = $dfa0449af776674b$var$_easeMap.Sine, $dfa0449af776674b$export$41e9d1ff1a2fb15a = $dfa0449af776674b$var$_easeMap.Expo, $dfa0449af776674b$export$ce49a57dd865b86c = $dfa0449af776674b$var$_easeMap.Circ;


/*!
 * CSSPlugin 3.6.0
 * https://greensock.com
 *
 * Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ 
var $4e9a29239fe287df$var$_win, $4e9a29239fe287df$var$_doc, $4e9a29239fe287df$var$_docElement, $4e9a29239fe287df$var$_pluginInitted, $4e9a29239fe287df$var$_tempDiv, $4e9a29239fe287df$var$_tempDivStyler, $4e9a29239fe287df$var$_recentSetterPlugin, $4e9a29239fe287df$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $4e9a29239fe287df$var$_transformProps = {}, $4e9a29239fe287df$var$_RAD2DEG = 180 / Math.PI, $4e9a29239fe287df$var$_DEG2RAD = Math.PI / 180, $4e9a29239fe287df$var$_atan2 = Math.atan2, $4e9a29239fe287df$var$_bigNum = 1e8, $4e9a29239fe287df$var$_capsExp = /([A-Z])/g, $4e9a29239fe287df$var$_horizontalExp = /(?:left|right|width|margin|padding|x)/i, $4e9a29239fe287df$var$_complexExp = /[\s,\(]\S/, $4e9a29239fe287df$var$_propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, $4e9a29239fe287df$var$_renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $4e9a29239fe287df$var$_renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, $4e9a29239fe287df$var$_renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
$4e9a29239fe287df$var$_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, $4e9a29239fe287df$var$_renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, $4e9a29239fe287df$var$_renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, $4e9a29239fe287df$var$_setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, $4e9a29239fe287df$var$_setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, $4e9a29239fe287df$var$_setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, $4e9a29239fe287df$var$_setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, $4e9a29239fe287df$var$_setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, $4e9a29239fe287df$var$_setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, $4e9a29239fe287df$var$_transformProp = "transform", $4e9a29239fe287df$var$_transformOriginProp = $4e9a29239fe287df$var$_transformProp + "Origin", $4e9a29239fe287df$var$_supports3D, $4e9a29239fe287df$export$a232bb0480ae674a = function _createElement(type, ns) {
    var e = $4e9a29239fe287df$var$_doc.createElementNS ? $4e9a29239fe287df$var$_doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : $4e9a29239fe287df$var$_doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e.style ? e : $4e9a29239fe287df$var$_doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://greensock.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, $4e9a29239fe287df$var$_getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace($4e9a29239fe287df$var$_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, $4e9a29239fe287df$export$8cbef5dd49a09c8b(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, $4e9a29239fe287df$var$_prefixes = "O,Moz,ms,Ms,Webkit".split(","), $4e9a29239fe287df$export$8cbef5dd49a09c8b = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || $4e9a29239fe287df$var$_tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !($4e9a29239fe287df$var$_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? $4e9a29239fe287df$var$_prefixes[i] : "") + property;
}, $4e9a29239fe287df$var$_initCore = function _initCore() {
    if ($4e9a29239fe287df$var$_windowExists() && window.document) {
        $4e9a29239fe287df$var$_win = window;
        $4e9a29239fe287df$var$_doc = $4e9a29239fe287df$var$_win.document;
        $4e9a29239fe287df$var$_docElement = $4e9a29239fe287df$var$_doc.documentElement;
        $4e9a29239fe287df$var$_tempDiv = $4e9a29239fe287df$export$a232bb0480ae674a("div") || {
            style: {}
        };
        $4e9a29239fe287df$var$_tempDivStyler = $4e9a29239fe287df$export$a232bb0480ae674a("div");
        $4e9a29239fe287df$var$_transformProp = $4e9a29239fe287df$export$8cbef5dd49a09c8b($4e9a29239fe287df$var$_transformProp);
        $4e9a29239fe287df$var$_transformOriginProp = $4e9a29239fe287df$var$_transformProp + "Origin";
        $4e9a29239fe287df$var$_tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        $4e9a29239fe287df$var$_supports3D = !!$4e9a29239fe287df$export$8cbef5dd49a09c8b("perspective");
        $4e9a29239fe287df$var$_pluginInitted = 1;
    }
}, $4e9a29239fe287df$var$_getBBoxHack = function _getBBoxHack(swapIfPossible) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var svg = $4e9a29239fe287df$export$a232bb0480ae674a("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
    $4e9a29239fe287df$var$_docElement.appendChild(svg);
    svg.appendChild(this);
    this.style.display = "block";
    if (swapIfPossible) try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox; //store the original
        this.getBBox = _getBBoxHack;
    } catch (e) {}
    else if (this._gsapBBox) bbox = this._gsapBBox();
    if (oldParent) {
        if (oldSibling) oldParent.insertBefore(this, oldSibling);
        else oldParent.appendChild(this);
    }
    $4e9a29239fe287df$var$_docElement.removeChild(svg);
    this.style.cssText = oldCSS;
    return bbox;
}, $4e9a29239fe287df$var$_getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, $4e9a29239fe287df$export$41bc7c2d1e04f11b = function _getBBox(target) {
    var bounds;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = $4e9a29239fe287df$var$_getBBoxHack.call(target, true);
    }
    bounds && (bounds.width || bounds.height) || target.getBBox === $4e9a29239fe287df$var$_getBBoxHack || (bounds = $4e9a29239fe287df$var$_getBBoxHack.call(target, true)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +$4e9a29239fe287df$var$_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +$4e9a29239fe287df$var$_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, $4e9a29239fe287df$var$_isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && $4e9a29239fe287df$export$41bc7c2d1e04f11b(e));
}, //reports if the element is an SVG on which getBBox() actually works
$4e9a29239fe287df$var$_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style;
        if (property in $4e9a29239fe287df$var$_transformProps && property !== $4e9a29239fe287df$var$_transformOriginProp) property = $4e9a29239fe287df$var$_transformProp;
        if (style.removeProperty) {
            if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(property.replace($4e9a29239fe287df$var$_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, $4e9a29239fe287df$var$_addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, $dfa0449af776674b$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? $4e9a29239fe287df$var$_renderNonTweeningValueOnlyAtEnd : $4e9a29239fe287df$var$_renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, $4e9a29239fe287df$var$_nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
$4e9a29239fe287df$var$_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = $4e9a29239fe287df$var$_tempDiv.style, horizontal = $4e9a29239fe287df$var$_horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || $4e9a29239fe287df$var$_nonConvertibleUnits[unit] || $4e9a29239fe287df$var$_nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && $4e9a29239fe287df$var$_isSVG(target);
    if ((toPercent || curUnit === "%") && ($4e9a29239fe287df$var$_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, $dfa0449af776674b$export$9c8d725d65e13f94)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === $4e9a29239fe287df$var$_doc || !parent.appendChild) parent = $4e9a29239fe287df$var$_doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, $dfa0449af776674b$export$762ed8fbedb691e3).time) return (0, $dfa0449af776674b$export$9c8d725d65e13f94)(curValue / cache.width * amount);
    else {
        (toPercent || curUnit === "%") && (style.position = $4e9a29239fe287df$var$_getComputedProperty(target, "position"));
        parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
        parent.appendChild($4e9a29239fe287df$var$_tempDiv);
        px = $4e9a29239fe287df$var$_tempDiv[measureProperty];
        parent.removeChild($4e9a29239fe287df$var$_tempDiv);
        style.position = "absolute";
        if (horizontal && toPercent) {
            cache = (0, $dfa0449af776674b$export$8b9be379d2de2a39)(parent);
            cache.time = (0, $dfa0449af776674b$export$762ed8fbedb691e3).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, $dfa0449af776674b$export$9c8d725d65e13f94)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, $4e9a29239fe287df$var$_get = function _get(target, property, unit, uncache) {
    var value;
    $4e9a29239fe287df$var$_pluginInitted || $4e9a29239fe287df$var$_initCore();
    if (property in $4e9a29239fe287df$var$_propertyAliases && property !== "transform") {
        property = $4e9a29239fe287df$var$_propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if ($4e9a29239fe287df$var$_transformProps[property] && property !== "transform") {
        value = $4e9a29239fe287df$var$_parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : $4e9a29239fe287df$var$_firstTwoOnly($4e9a29239fe287df$var$_getComputedProperty(target, $4e9a29239fe287df$var$_transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = $4e9a29239fe287df$var$_specialProps[property] && $4e9a29239fe287df$var$_specialProps[property](target, property, unit) || $4e9a29239fe287df$var$_getComputedProperty(target, property) || (0, $dfa0449af776674b$export$51d6bbe898aef1f9)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? $4e9a29239fe287df$var$_convertToUnit(target, property, value, unit) + unit : value;
}, $4e9a29239fe287df$var$_tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    //note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://greensock.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = $4e9a29239fe287df$export$8cbef5dd49a09c8b(prop, target, 1), s = p && $4e9a29239fe287df$var$_getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = $4e9a29239fe287df$var$_getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://greensock.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, $dfa0449af776674b$export$3a67f7f44b1e838a)(this._pt, target.style, prop, 0, 1, (0, $dfa0449af776674b$export$c5bc8e04394ecb2)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, relative, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (end === "auto") {
        target.style[prop] = end;
        end = $4e9a29239fe287df$var$_getComputedProperty(target, prop) || end;
        target.style[prop] = start;
    }
    a = [
        start,
        end
    ];
    (0, $dfa0449af776674b$export$7eb2e5eb5eeb96a4)(a); //pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, $dfa0449af776674b$export$65c88bbd597e7b0a)) || [];
    endValues = end.match((0, $dfa0449af776674b$export$65c88bbd597e7b0a)) || [];
    if (endValues.length) {
        while(result = (0, $dfa0449af776674b$export$65c88bbd597e7b0a).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                relative = endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
                if (relative) endValue = endValue.substr(2);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, $dfa0449af776674b$export$65c88bbd597e7b0a).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, $dfa0449af776674b$export$4922bee768729a77).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = $4e9a29239fe287df$var$_convertToUnit(target, prop, startValue, endUnit) || 0;
                 //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: relative ? relative * endNum : endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? $4e9a29239fe287df$var$_renderNonTweeningValueOnlyAtEnd : $4e9a29239fe287df$var$_renderNonTweeningValue;
    (0, $dfa0449af776674b$export$5a680e28b0b61bc).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, $4e9a29239fe287df$var$_keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, $4e9a29239fe287df$var$_convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = $4e9a29239fe287df$var$_keywordToPercent[x] || x;
    split[1] = $4e9a29239fe287df$var$_keywordToPercent[y] || y;
    return split.join(" ");
}, $4e9a29239fe287df$var$_renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if ($4e9a29239fe287df$var$_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? $4e9a29239fe287df$var$_transformOriginProp : $4e9a29239fe287df$var$_transformProp;
                }
                $4e9a29239fe287df$var$_removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            $4e9a29239fe287df$var$_removeProperty(target, $4e9a29239fe287df$var$_transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                $4e9a29239fe287df$var$_parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
$4e9a29239fe287df$var$_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, $dfa0449af776674b$export$3a67f7f44b1e838a)(plugin._pt, target, property, 0, 0, $4e9a29239fe287df$var$_renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ $4e9a29239fe287df$var$_identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], $4e9a29239fe287df$var$_rotationalProperties = {}, $4e9a29239fe287df$var$_isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, $4e9a29239fe287df$var$_getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = $4e9a29239fe287df$var$_getComputedProperty(target, $4e9a29239fe287df$var$_transformProp);
    return $4e9a29239fe287df$var$_isNullTransform(matrixString) ? $4e9a29239fe287df$var$_identity2DMatrix : matrixString.substr(7).match((0, $dfa0449af776674b$export$b9d44bb6523120d6)).map((0, $dfa0449af776674b$export$9c8d725d65e13f94));
}, $4e9a29239fe287df$var$_getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, $dfa0449af776674b$export$8b9be379d2de2a39)(target), style = target.style, matrix = $4e9a29239fe287df$var$_getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? $4e9a29239fe287df$var$_identity2DMatrix : matrix;
    } else if (matrix === $4e9a29239fe287df$var$_identity2DMatrix && !target.offsetParent && target !== $4e9a29239fe287df$var$_docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375
            addedToDOM = 1; //flag
            nextSibling = target.nextSibling;
            $4e9a29239fe287df$var$_docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = $4e9a29239fe287df$var$_getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : $4e9a29239fe287df$var$_removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : $4e9a29239fe287df$var$_docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, $4e9a29239fe287df$var$_applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || $4e9a29239fe287df$var$_getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = $4e9a29239fe287df$export$41bc7c2d1e04f11b(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
    } else if (matrix !== $4e9a29239fe287df$var$_identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y;
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[$4e9a29239fe287df$var$_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        $4e9a29239fe287df$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        $4e9a29239fe287df$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        $4e9a29239fe287df$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        $4e9a29239fe287df$var$_addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, $4e9a29239fe287df$var$_parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, $dfa0449af776674b$export$cf10981d5419cad5)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", origin = $4e9a29239fe287df$var$_getComputedProperty(target, $4e9a29239fe287df$var$_transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && $4e9a29239fe287df$var$_isSVG(target));
    matrix = $4e9a29239fe287df$var$_getMatrix(target, cache.svg);
    if (cache.svg) {
        t1 = !cache.uncache && target.getAttribute("data-svg-origin");
        $4e9a29239fe287df$var$_applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== $4e9a29239fe287df$var$_identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? $4e9a29239fe287df$var$_atan2(b, a) * $4e9a29239fe287df$var$_RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? $4e9a29239fe287df$var$_atan2(c, d) * $4e9a29239fe287df$var$_RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.cos(skewX * $4e9a29239fe287df$var$_DEG2RAD));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = $4e9a29239fe287df$var$_atan2(a32, a33);
            rotationX = angle * $4e9a29239fe287df$var$_RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = $4e9a29239fe287df$var$_atan2(-c, a33);
            rotationY = angle * $4e9a29239fe287df$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = $4e9a29239fe287df$var$_atan2(b, a);
            rotation = angle * $4e9a29239fe287df$var$_RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = $4e9a29239fe287df$var$_atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * $4e9a29239fe287df$var$_RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !$4e9a29239fe287df$var$_isNullTransform($4e9a29239fe287df$var$_getComputedProperty(target, $4e9a29239fe287df$var$_transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    cache.x = x - ((cache.xPercent = x && (cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(scaleX);
    cache.scaleY = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(scaleY);
    cache.rotation = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(rotation) + deg;
    cache.rotationX = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(rotationX) + deg;
    cache.rotationY = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) style[$4e9a29239fe287df$var$_transformOriginProp] = $4e9a29239fe287df$var$_firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, $dfa0449af776674b$export$4922bee768729a77).force3D;
    cache.renderTransform = cache.svg ? $4e9a29239fe287df$var$_renderSVGTransforms : $4e9a29239fe287df$var$_supports3D ? $4e9a29239fe287df$var$_renderCSSTransforms : $4e9a29239fe287df$var$_renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, $4e9a29239fe287df$var$_firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
$4e9a29239fe287df$var$_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, $dfa0449af776674b$export$65f2564e9a9b9222)(start);
    return (0, $dfa0449af776674b$export$9c8d725d65e13f94)(parseFloat(start) + parseFloat($4e9a29239fe287df$var$_convertToUnit(target, "x", value + "px", unit))) + unit;
}, $4e9a29239fe287df$var$_renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    $4e9a29239fe287df$var$_renderCSSTransforms(ratio, cache);
}, $4e9a29239fe287df$var$_zeroDeg = "0deg", $4e9a29239fe287df$var$_zeroPx = "0px", $4e9a29239fe287df$var$_endParenthesis = ") ", $4e9a29239fe287df$var$_renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== $4e9a29239fe287df$var$_zeroDeg || rotationY !== $4e9a29239fe287df$var$_zeroDeg)) {
        var angle = parseFloat(rotationY) * $4e9a29239fe287df$var$_DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * $4e9a29239fe287df$var$_DEG2RAD;
        cos = Math.cos(angle);
        x = $4e9a29239fe287df$var$_addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = $4e9a29239fe287df$var$_addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = $4e9a29239fe287df$var$_addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== $4e9a29239fe287df$var$_zeroPx) transforms += "perspective(" + transformPerspective + $4e9a29239fe287df$var$_endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== $4e9a29239fe287df$var$_zeroPx || y !== $4e9a29239fe287df$var$_zeroPx || z !== $4e9a29239fe287df$var$_zeroPx) transforms += z !== $4e9a29239fe287df$var$_zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + $4e9a29239fe287df$var$_endParenthesis;
    if (rotation !== $4e9a29239fe287df$var$_zeroDeg) transforms += "rotate(" + rotation + $4e9a29239fe287df$var$_endParenthesis;
    if (rotationY !== $4e9a29239fe287df$var$_zeroDeg) transforms += "rotateY(" + rotationY + $4e9a29239fe287df$var$_endParenthesis;
    if (rotationX !== $4e9a29239fe287df$var$_zeroDeg) transforms += "rotateX(" + rotationX + $4e9a29239fe287df$var$_endParenthesis;
    if (skewX !== $4e9a29239fe287df$var$_zeroDeg || skewY !== $4e9a29239fe287df$var$_zeroDeg) transforms += "skew(" + skewX + ", " + skewY + $4e9a29239fe287df$var$_endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + $4e9a29239fe287df$var$_endParenthesis;
    target.style[$4e9a29239fe287df$var$_transformProp] = transforms || "translate(0, 0)";
}, $4e9a29239fe287df$var$_renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= $4e9a29239fe287df$var$_DEG2RAD;
        skewX *= $4e9a29239fe287df$var$_DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= $4e9a29239fe287df$var$_DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(a11);
        a21 = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(a21);
        a12 = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(a12);
        a22 = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = $4e9a29239fe287df$var$_convertToUnit(target, "x", x, "px");
        ty = $4e9a29239fe287df$var$_convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(tx + xPercent / 100 * temp.width);
        ty = (0, $dfa0449af776674b$export$9c8d725d65e13f94)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[$4e9a29239fe287df$var$_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the  transform attribute changes!)
}, $4e9a29239fe287df$var$_addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue, relative) {
    var cap = 360, isString = (0, $dfa0449af776674b$export$f664476fd67145ca)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? $4e9a29239fe287df$var$_RAD2DEG : 1), change = relative ? endNum * relative : endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * $4e9a29239fe287df$var$_bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * $4e9a29239fe287df$var$_bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, $dfa0449af776674b$export$3a67f7f44b1e838a)(plugin._pt, target, property, startNum, change, $4e9a29239fe287df$var$_renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, $4e9a29239fe287df$var$_addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var style = $4e9a29239fe287df$var$_tempDivStyler.style, startCache = target._gsap, exclude = "perspective,force3D,transformOrigin,svgOrigin", endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    style.cssText = getComputedStyle(target).cssText + ";position:absolute;display:block;"; //%-based translations will fail unless we set the width/height to match the original target (and padding/borders can affect it)
    style[$4e9a29239fe287df$var$_transformProp] = transforms;
    $4e9a29239fe287df$var$_doc.body.appendChild($4e9a29239fe287df$var$_tempDivStyler);
    endCache = $4e9a29239fe287df$var$_parseTransform($4e9a29239fe287df$var$_tempDivStyler, 1);
    for(p in $4e9a29239fe287df$var$_transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, $dfa0449af776674b$export$65f2564e9a9b9222)(startValue);
            endUnit = (0, $dfa0449af776674b$export$65f2564e9a9b9222)(endValue);
            startNum = startUnit !== endUnit ? $4e9a29239fe287df$var$_convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, $dfa0449af776674b$export$3a67f7f44b1e838a)(plugin._pt, startCache, p, startNum, endNum - startNum, $4e9a29239fe287df$var$_renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    $4e9a29239fe287df$var$_doc.body.removeChild($4e9a29239fe287df$var$_tempDivStyler);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, $dfa0449af776674b$export$f9000b814859f126)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    $4e9a29239fe287df$var$_specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return $4e9a29239fe287df$var$_get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var $4e9a29239fe287df$export$855822f522f18eef = {
    name: "css",
    register: $4e9a29239fe287df$var$_initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority;
        $4e9a29239fe287df$var$_pluginInitted || $4e9a29239fe287df$var$_initCore();
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, $dfa0449af776674b$export$d305d8ec5d7c26b8)[p] && (0, $dfa0449af776674b$export$5c457b74208010cf)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = $4e9a29239fe287df$var$_specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, $dfa0449af776674b$export$d5962a97e3cde94d)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                startUnit = (0, $dfa0449af776674b$export$65f2564e9a9b9222)(startValue);
                endUnit = (0, $dfa0449af776674b$export$65f2564e9a9b9222)(endValue);
                endUnit ? startUnit !== endUnit && (startValue = $4e9a29239fe287df$var$_convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    p in (0, $dfa0449af776674b$export$4922bee768729a77).units && !(0, $dfa0449af776674b$export$65f2564e9a9b9222)(startValue) && (startValue += (0, $dfa0449af776674b$export$4922bee768729a77).units[p]); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = $4e9a29239fe287df$var$_get(target, p)); // can't work with relative values
                } else startValue = $4e9a29239fe287df$var$_get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in $4e9a29239fe287df$var$_propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && $4e9a29239fe287df$var$_get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        $4e9a29239fe287df$var$_addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = $4e9a29239fe287df$var$_propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in $4e9a29239fe287df$var$_transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || $4e9a29239fe287df$var$_parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, $dfa0449af776674b$export$3a67f7f44b1e838a)(this._pt, style, $4e9a29239fe287df$var$_transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, $dfa0449af776674b$export$3a67f7f44b1e838a)(this._pt, cache, "scaleY", cache.scaleY, relative ? relative * endNum : endNum - cache.scaleY);
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        endValue = $4e9a29239fe287df$var$_convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) $4e9a29239fe287df$var$_applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && $4e9a29239fe287df$var$_addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            $4e9a29239fe287df$var$_addNonTweeningPT(this, style, p, $4e9a29239fe287df$var$_firstTwoOnly(startValue), $4e9a29239fe287df$var$_firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        $4e9a29239fe287df$var$_applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in $4e9a29239fe287df$var$_rotationalProperties) {
                        $4e9a29239fe287df$var$_addRotationalPropTween(this, cache, p, startNum, endValue, relative);
                        continue;
                    } else if (p === "smoothOrigin") {
                        $4e9a29239fe287df$var$_addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        $4e9a29239fe287df$var$_addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = $4e9a29239fe287df$export$8cbef5dd49a09c8b(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !$4e9a29239fe287df$var$_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, $dfa0449af776674b$export$65f2564e9a9b9222)(endValue) || (p in (0, $dfa0449af776674b$export$4922bee768729a77).units ? (0, $dfa0449af776674b$export$4922bee768729a77).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = $4e9a29239fe287df$var$_convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, $dfa0449af776674b$export$3a67f7f44b1e838a)(this._pt, isTransformRelated ? cache : style, p, startNum, relative ? relative * endNum : endNum - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? $4e9a29239fe287df$var$_renderRoundedCSSProp : $4e9a29239fe287df$var$_renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (startUnit !== endUnit) {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = $4e9a29239fe287df$var$_renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, target[p], endValue, index, targets);
                    else {
                        (0, $dfa0449af776674b$export$7fb54635790b59a5)(p, endValue);
                        continue;
                    }
                } else $4e9a29239fe287df$var$_tweenComplexCSSString.call(this, target, p, startValue, endValue);
                props.push(p);
            }
        }
        hasPriority && (0, $dfa0449af776674b$export$eed5824f53346d57)(this);
    },
    get: $4e9a29239fe287df$var$_get,
    aliases: $4e9a29239fe287df$var$_propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = $4e9a29239fe287df$var$_propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in $4e9a29239fe287df$var$_transformProps && property !== $4e9a29239fe287df$var$_transformOriginProp && (target._gsap.x || $4e9a29239fe287df$var$_get(target, "x")) ? plugin && $4e9a29239fe287df$var$_recentSetterPlugin === plugin ? property === "scale" ? $4e9a29239fe287df$var$_setterScale : $4e9a29239fe287df$var$_setterTransform : ($4e9a29239fe287df$var$_recentSetterPlugin = plugin || {}, property === "scale" ? $4e9a29239fe287df$var$_setterScaleWithRender : $4e9a29239fe287df$var$_setterTransformWithRender) : target.style && !(0, $dfa0449af776674b$export$a8178c063a9fd3a1)(target.style[property]) ? $4e9a29239fe287df$var$_setterCSSStyle : ~property.indexOf("-") ? $4e9a29239fe287df$var$_setterCSSProp : (0, $dfa0449af776674b$export$d60fbc1e0278aaf0)(target, property);
    },
    core: {
        _removeProperty: $4e9a29239fe287df$var$_removeProperty,
        _getMatrix: $4e9a29239fe287df$var$_getMatrix
    }
};
(0, $dfa0449af776674b$export$99ee26438460406a).utils.checkPrefix = $4e9a29239fe287df$export$8cbef5dd49a09c8b;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, $dfa0449af776674b$export$f9000b814859f126)(positionAndScale + "," + rotation + "," + others, function(name) {
        $4e9a29239fe287df$var$_transformProps[name] = 1;
    });
    (0, $dfa0449af776674b$export$f9000b814859f126)(rotation, function(name) {
        (0, $dfa0449af776674b$export$4922bee768729a77).units[name] = "deg";
        $4e9a29239fe287df$var$_rotationalProperties[name] = 1;
    });
    $4e9a29239fe287df$var$_propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, $dfa0449af776674b$export$f9000b814859f126)(aliases, function(name) {
        var split = name.split(":");
        $4e9a29239fe287df$var$_propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, $dfa0449af776674b$export$f9000b814859f126)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, $dfa0449af776674b$export$4922bee768729a77).units[name] = "px";
});
(0, $dfa0449af776674b$export$99ee26438460406a).registerPlugin($4e9a29239fe287df$export$855822f522f18eef);


var $9770947dcdc34a25$export$99ee26438460406a = (0, $dfa0449af776674b$export$99ee26438460406a).registerPlugin((0, $4e9a29239fe287df$export$855822f522f18eef)) || (0, $dfa0449af776674b$export$99ee26438460406a), // to protect from tree shaking
$9770947dcdc34a25$export$7b23975ad686bf91 = $9770947dcdc34a25$export$99ee26438460406a.core.Tween;


/*!
 * ScrollToPlugin 3.6.0
 * https://greensock.com
 *
 * @license Copyright 2008-2021, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var $bf620ba41a414798$var$gsap, $bf620ba41a414798$var$_coreInitted, $bf620ba41a414798$var$_window, $bf620ba41a414798$var$_docEl, $bf620ba41a414798$var$_body, $bf620ba41a414798$var$_toArray, $bf620ba41a414798$var$_config, $bf620ba41a414798$var$_windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, $bf620ba41a414798$var$_getGSAP = function _getGSAP() {
    return $bf620ba41a414798$var$gsap || $bf620ba41a414798$var$_windowExists() && ($bf620ba41a414798$var$gsap = window.gsap) && $bf620ba41a414798$var$gsap.registerPlugin && $bf620ba41a414798$var$gsap;
}, $bf620ba41a414798$var$_isString = function _isString(value) {
    return typeof value === "string";
}, $bf620ba41a414798$var$_isFunction = function _isFunction(value) {
    return typeof value === "function";
}, $bf620ba41a414798$var$_max = function _max(element, axis) {
    var dim = axis === "x" ? "Width" : "Height", scroll = "scroll" + dim, client = "client" + dim;
    return element === $bf620ba41a414798$var$_window || element === $bf620ba41a414798$var$_docEl || element === $bf620ba41a414798$var$_body ? Math.max($bf620ba41a414798$var$_docEl[scroll], $bf620ba41a414798$var$_body[scroll]) - ($bf620ba41a414798$var$_window["inner" + dim] || $bf620ba41a414798$var$_docEl[client] || $bf620ba41a414798$var$_body[client]) : element[scroll] - element["offset" + dim];
}, $bf620ba41a414798$var$_buildGetter = function _buildGetter(e, axis) {
    //pass in an element and an axis ("x" or "y") and it'll return a getter function for the scroll position of that element (like scrollTop or scrollLeft, although if the element is the window, it'll use the pageXOffset/pageYOffset or the documentElement's scrollTop/scrollLeft or document.body's. Basically this streamlines things and makes a very fast getter across browsers.
    var p = "scroll" + (axis === "x" ? "Left" : "Top");
    if (e === $bf620ba41a414798$var$_window) {
        if (e.pageXOffset != null) p = "page" + axis.toUpperCase() + "Offset";
        else e = $bf620ba41a414798$var$_docEl[p] != null ? $bf620ba41a414798$var$_docEl : $bf620ba41a414798$var$_body;
    }
    return function() {
        return e[p];
    };
}, $bf620ba41a414798$var$_clean = function _clean(value, index, target, targets) {
    $bf620ba41a414798$var$_isFunction(value) && (value = value(index, target, targets));
    if (typeof value !== "object") return $bf620ba41a414798$var$_isString(value) && value !== "max" && value.charAt(1) !== "=" ? {
        x: value,
        y: value
    } : {
        y: value
    }; //if we don't receive an object as the parameter, assume the user intends "y".
    else if (value.nodeType) return {
        y: value,
        x: value
    };
    else {
        var result = {}, p;
        for(p in value)p !== "onAutoKill" && (result[p] = $bf620ba41a414798$var$_isFunction(value[p]) ? value[p](index, target, targets) : value[p]);
        return result;
    }
}, $bf620ba41a414798$var$_getOffset = function _getOffset(element, container) {
    element = $bf620ba41a414798$var$_toArray(element)[0];
    if (!element || !element.getBoundingClientRect) return console.warn("scrollTo target doesn't exist. Using 0") || {
        x: 0,
        y: 0
    };
    var rect = element.getBoundingClientRect(), isRoot = !container || container === $bf620ba41a414798$var$_window || container === $bf620ba41a414798$var$_body, cRect = isRoot ? {
        top: $bf620ba41a414798$var$_docEl.clientTop - ($bf620ba41a414798$var$_window.pageYOffset || $bf620ba41a414798$var$_docEl.scrollTop || $bf620ba41a414798$var$_body.scrollTop || 0),
        left: $bf620ba41a414798$var$_docEl.clientLeft - ($bf620ba41a414798$var$_window.pageXOffset || $bf620ba41a414798$var$_docEl.scrollLeft || $bf620ba41a414798$var$_body.scrollLeft || 0)
    } : container.getBoundingClientRect(), offsets = {
        x: rect.left - cRect.left,
        y: rect.top - cRect.top
    };
    if (!isRoot && container) {
        //only add the current scroll position if it's not the window/body.
        offsets.x += $bf620ba41a414798$var$_buildGetter(container, "x")();
        offsets.y += $bf620ba41a414798$var$_buildGetter(container, "y")();
    }
    return offsets;
}, $bf620ba41a414798$var$_parseVal = function _parseVal(value, target, axis, currentVal, offset) {
    return !isNaN(value) && typeof value !== "object" ? parseFloat(value) - offset : $bf620ba41a414798$var$_isString(value) && value.charAt(1) === "=" ? parseFloat(value.substr(2)) * (value.charAt(0) === "-" ? -1 : 1) + currentVal - offset : value === "max" ? $bf620ba41a414798$var$_max(target, axis) - offset : Math.min($bf620ba41a414798$var$_max(target, axis), $bf620ba41a414798$var$_getOffset(value, target)[axis] - offset);
}, $bf620ba41a414798$var$_initCore = function _initCore() {
    $bf620ba41a414798$var$gsap = $bf620ba41a414798$var$_getGSAP();
    if ($bf620ba41a414798$var$_windowExists() && $bf620ba41a414798$var$gsap && document.body) {
        $bf620ba41a414798$var$_window = window;
        $bf620ba41a414798$var$_body = document.body;
        $bf620ba41a414798$var$_docEl = document.documentElement;
        $bf620ba41a414798$var$_toArray = $bf620ba41a414798$var$gsap.utils.toArray;
        $bf620ba41a414798$var$gsap.config({
            autoKillThreshold: 7
        });
        $bf620ba41a414798$var$_config = $bf620ba41a414798$var$gsap.config();
        $bf620ba41a414798$var$_coreInitted = 1;
    }
};
var $bf620ba41a414798$export$6953cc323644330b = {
    version: "3.6.0",
    name: "scrollTo",
    rawVars: 1,
    register: function register(core) {
        $bf620ba41a414798$var$gsap = core;
        $bf620ba41a414798$var$_initCore();
    },
    init: function init(target, value, tween, index, targets) {
        $bf620ba41a414798$var$_coreInitted || $bf620ba41a414798$var$_initCore();
        var data = this;
        data.isWin = target === $bf620ba41a414798$var$_window;
        data.target = target;
        data.tween = tween;
        value = $bf620ba41a414798$var$_clean(value, index, target, targets);
        data.vars = value;
        data.autoKill = !!value.autoKill;
        data.getX = $bf620ba41a414798$var$_buildGetter(target, "x");
        data.getY = $bf620ba41a414798$var$_buildGetter(target, "y");
        data.x = data.xPrev = data.getX();
        data.y = data.yPrev = data.getY();
        if (value.x != null) {
            data.add(data, "x", data.x, $bf620ba41a414798$var$_parseVal(value.x, target, "x", data.x, value.offsetX || 0), index, targets, Math.round);
            data._props.push("scrollTo_x");
        } else data.skipX = 1;
        if (value.y != null) {
            data.add(data, "y", data.y, $bf620ba41a414798$var$_parseVal(value.y, target, "y", data.y, value.offsetY || 0), index, targets, Math.round);
            data._props.push("scrollTo_y");
        } else data.skipY = 1;
    },
    render: function render(ratio, data) {
        var pt = data._pt, target = data.target, tween = data.tween, autoKill = data.autoKill, xPrev = data.xPrev, yPrev = data.yPrev, isWin = data.isWin, x, y, yDif, xDif, threshold;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        x = isWin || !data.skipX ? data.getX() : xPrev;
        y = isWin || !data.skipY ? data.getY() : yPrev;
        yDif = y - yPrev;
        xDif = x - xPrev;
        threshold = $bf620ba41a414798$var$_config.autoKillThreshold;
        if (data.x < 0) //can't scroll to a position less than 0! Might happen if someone uses a Back.easeOut or Elastic.easeOut when scrolling back to the top of the page (for example)
        data.x = 0;
        if (data.y < 0) data.y = 0;
        if (autoKill) {
            //note: iOS has a bug that throws off the scroll by several pixels, so we need to check if it's within 7 pixels of the previous one that we set instead of just looking for an exact match.
            if (!data.skipX && (xDif > threshold || xDif < -threshold) && x < $bf620ba41a414798$var$_max(target, "x")) data.skipX = 1; //if the user scrolls separately, we should stop tweening!
            if (!data.skipY && (yDif > threshold || yDif < -threshold) && y < $bf620ba41a414798$var$_max(target, "y")) data.skipY = 1; //if the user scrolls separately, we should stop tweening!
            if (data.skipX && data.skipY) {
                tween.kill();
                data.vars.onAutoKill && data.vars.onAutoKill.apply(tween, data.vars.onAutoKillParams || []);
            }
        }
        if (isWin) $bf620ba41a414798$var$_window.scrollTo(!data.skipX ? data.x : x, !data.skipY ? data.y : y);
        else {
            data.skipY || (target.scrollTop = data.y);
            data.skipX || (target.scrollLeft = data.x);
        }
        data.xPrev = data.x;
        data.yPrev = data.y;
    },
    kill: function kill(property) {
        var both = property === "scrollTo";
        if (both || property === "scrollTo_x") this.skipX = 1;
        if (both || property === "scrollTo_y") this.skipY = 1;
    }
};
$bf620ba41a414798$export$6953cc323644330b.max = $bf620ba41a414798$var$_max;
$bf620ba41a414798$export$6953cc323644330b.getOffset = $bf620ba41a414798$var$_getOffset;
$bf620ba41a414798$export$6953cc323644330b.buildGetter = $bf620ba41a414798$var$_buildGetter;
$bf620ba41a414798$var$_getGSAP() && $bf620ba41a414798$var$gsap.registerPlugin($bf620ba41a414798$export$6953cc323644330b);


(0, $9770947dcdc34a25$export$99ee26438460406a).registerPlugin((0, $bf620ba41a414798$export$6953cc323644330b));
const $382c4d8c0e5280a0$var$allPageHashLinks = document.querySelectorAll('a[href^="#"]');
const $382c4d8c0e5280a0$var$handleHashNavigation = (e)=>{
    e.preventDefault();
    (0, $9770947dcdc34a25$export$99ee26438460406a).to(window, {
        duration: 1,
        ease: 'power1.out',
        scrollTo: {
            y: e.currentTarget.getAttribute('href'),
            autoKill: false
        }
    });
};
$382c4d8c0e5280a0$var$allPageHashLinks.forEach((a)=>a.addEventListener('click', $382c4d8c0e5280a0$var$handleHashNavigation));


// Register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
var $c9c796b51b0d3b07$var$isLocalhost = function() {
    return Boolean(window.location.hostname === 'localhost' || // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' || // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
};
var $c9c796b51b0d3b07$var$waitWindowLoad;
// https://github.com/yyx990803/register-service-worker/pull/33#discussion_r394181861
if (typeof window !== 'undefined') {
    // Typically, a browser that supports `serviceWorker` should also have supported
    // `Promise`. But as this package can be used in environments without service
    // worker support (in that case it would do nothing), there's a chance that
    // `Promise` does not exist. So we must check for its existence first.
    if (typeof Promise !== 'undefined') $c9c796b51b0d3b07$var$waitWindowLoad = new Promise(function(resolve) {
        return window.addEventListener('load', resolve);
    });
    else $c9c796b51b0d3b07$var$waitWindowLoad = {
        then: function(cb) {
            return window.addEventListener('load', cb);
        }
    };
}
function $c9c796b51b0d3b07$export$6503ec6e8aabbaf(swUrl, hooks) {
    if (hooks === void 0) hooks = {};
    var registrationOptions = hooks.registrationOptions;
    if (registrationOptions === void 0) registrationOptions = {};
    delete hooks.registrationOptions;
    var emit1 = function(hook) {
        var args = [], len = arguments.length - 1;
        while(len-- > 0)args[len] = arguments[len + 1];
        if (hooks && hooks[hook]) hooks[hook].apply(hooks, args);
    };
    if ('serviceWorker' in navigator) $c9c796b51b0d3b07$var$waitWindowLoad.then(function() {
        if ($c9c796b51b0d3b07$var$isLocalhost()) {
            // This is running on localhost. Lets check if a service worker still exists or not.
            $c9c796b51b0d3b07$var$checkValidServiceWorker(swUrl, emit1, registrationOptions);
            navigator.serviceWorker.ready.then(function(registration) {
                emit1('ready', registration);
            }).catch(function(error) {
                return $c9c796b51b0d3b07$var$handleError(emit1, error);
            });
        } else {
            // Is not local host. Just register service worker
            $c9c796b51b0d3b07$var$registerValidSW(swUrl, emit1, registrationOptions);
            navigator.serviceWorker.ready.then(function(registration) {
                emit1('ready', registration);
            }).catch(function(error) {
                return $c9c796b51b0d3b07$var$handleError(emit1, error);
            });
        }
    });
}
function $c9c796b51b0d3b07$var$handleError(emit1, error) {
    if (!navigator.onLine) emit1('offline');
    emit1('error', error);
}
function $c9c796b51b0d3b07$var$registerValidSW(swUrl, emit1, registrationOptions) {
    navigator.serviceWorker.register(swUrl, registrationOptions).then(function(registration) {
        emit1('registered', registration);
        if (registration.waiting) {
            emit1('updated', registration);
            return;
        }
        registration.onupdatefound = function() {
            emit1('updatefound', registration);
            var installingWorker = registration.installing;
            installingWorker.onstatechange = function() {
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) // At this point, the old content will have been purged and
                    // the fresh content will have been added to the cache.
                    // It's the perfect time to display a "New content is
                    // available; please refresh." message in your web app.
                    emit1('updated', registration);
                    else // At this point, everything has been precached.
                    // It's the perfect time to display a
                    // "Content is cached for offline use." message.
                    emit1('cached', registration);
                }
            };
        };
    }).catch(function(error) {
        return $c9c796b51b0d3b07$var$handleError(emit1, error);
    });
}
function $c9c796b51b0d3b07$var$checkValidServiceWorker(swUrl, emit1, registrationOptions) {
    // Check if the service worker can be found.
    fetch(swUrl).then(function(response) {
        // Ensure service worker exists, and that we really are getting a JS file.
        if (response.status === 404) {
            // No service worker found.
            emit1('error', new Error("Service worker not found at " + swUrl));
            $c9c796b51b0d3b07$export$d07f55d4c15c0440();
        } else if (response.headers.get('content-type').indexOf('javascript') === -1) {
            emit1('error', new Error("Expected " + swUrl + " to have javascript content-type, " + "but received " + response.headers.get('content-type')));
            $c9c796b51b0d3b07$export$d07f55d4c15c0440();
        } else // Service worker found. Proceed as normal.
        $c9c796b51b0d3b07$var$registerValidSW(swUrl, emit1, registrationOptions);
    }).catch(function(error) {
        return $c9c796b51b0d3b07$var$handleError(emit1, error);
    });
}
function $c9c796b51b0d3b07$export$d07f55d4c15c0440() {
    if ('serviceWorker' in navigator) navigator.serviceWorker.ready.then(function(registration) {
        registration.unregister();
    }).catch(function(error) {
        return $c9c796b51b0d3b07$var$handleError(emit, error);
    });
}


(0, $c9c796b51b0d3b07$export$6503ec6e8aabbaf)('/service-worker.js', {
    registrationOptions: {
        scope: './'
    },
    ready (registration) {
        console.log('Service worker is active.');
    },
    registered (registration) {
        console.log('Service worker has been registered.');
    },
    cached (registration) {
        console.log('Content has been cached for offline use.');
    },
    updatefound (registration) {
        console.log('New content is downloading.');
    },
    updated (registration) {
        console.log('New content is available; please refresh.');
    },
    offline () {
        console.log('No internet connection found. App is running in offline mode.');
    },
    error (error) {
        console.error('Error during service worker registration:', error);
    }
});


const $6a2fb6de0d762e8e$export$9fd24a634729c672 = (str)=>{
    return str.replace(/\W+/g, '-').replace(/([a-z\d])([A-Z])/g, '$1-$2');
};
const $6a2fb6de0d762e8e$export$9a00dee1beb8f576 = (str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
};
const $6a2fb6de0d762e8e$export$ccab7a0ef1eb8a1d = (str)=>{
    return str.replace(/\W+(.)/g, (x, chr)=>{
        return chr.toUpperCase();
    });
};
const $6a2fb6de0d762e8e$export$53a29ee4f7f84d31 = (str)=>{
    return str.toLowerCase().replace(/ /g, '-').replace(/&/g, 'and');
};


const $89b02536cc73a9df$export$3d232af6e6cfbfaf = (fn)=>{
    let ticking = false;
    return ()=>{
        if (!ticking) {
            window.requestAnimationFrame(()=>{
                fn();
                ticking = false;
            });
            ticking = true;
        }
    };
};
function $89b02536cc73a9df$export$bdd553fddd433dcb(fn) {
    return setTimeout(fn, 0);
}
function $89b02536cc73a9df$export$d2de3aaeafa91619(fn) {
    const f = function(...args) {
        if (f.called) return f.value;
        f.called = true;
        return f.value = fn.apply(this, args);
    };
    f.called = false;
    return f;
}
function $89b02536cc73a9df$export$8793edee2d425525() {}


class $fb95888796e08f9b$export$55ae5207ce896a6b {
    constructor(el, componentName){
        this.el = el;
        this.componentName = componentName;
        this.refs = {};
        this.requiredRefs = [];
        this.baseInit();
    }
    baseInit() {
        this.populateRefsObject();
        this.checkRequiredRefs();
        // module animations
        const revealAnimations = this.revealAnimations; // in child class through property getter (get revealAnimations() {})
        if (revealAnimations && revealAnimations.length) {
            const doOnInViewport = new Map();
            revealAnimations.forEach(({ targets: targets, onInViewport: onInViewport })=>{
                const targetsArr = [].concat(targets.length ? [
                    ...targets
                ] : targets); // can be multiple, convert all to array
                targetsArr.forEach((el)=>{
                    doOnInViewport.set(el, (0, $89b02536cc73a9df$export$d2de3aaeafa91619)((triggeredEl)=>{
                        if (onInViewport) onInViewport(triggeredEl);
                    }));
                });
            });
            this._observer = new IntersectionObserver((targets)=>{
                targets.forEach((triggeredEntry)=>{
                    if (triggeredEntry.isIntersecting) {
                        const { target: target } = triggeredEntry;
                        target.classList.add('is-seen');
                        doOnInViewport.get(target)(target);
                        this._observer.unobserve(target);
                    }
                });
            }, {
                threshold: 0.15
            });
            doOnInViewport.forEach((callback, el)=>this._observer.observe(el));
        }
    }
    populateRefsObject() {
        const attribute = `data-ref-${this.componentName}`;
        this.el.querySelectorAll(`[${attribute}]`).forEach((refElement)=>{
            const attributeValue = (0, $6a2fb6de0d762e8e$export$ccab7a0ef1eb8a1d)(refElement.getAttribute(attribute));
            if (!this.refs[attributeValue]) this.refs[attributeValue] = refElement;
            else if (!this.refs[attributeValue].length) this.refs[attributeValue] = [
                this.refs[attributeValue],
                refElement
            ];
            else this.refs[attributeValue].push(refElement);
        });
    }
    checkRequiredRefs = ()=>{
        if (this.requiredRefs && this.requiredRefs.length) this.requiredRefs.forEach((key)=>{
            if (!(key in this.refs)) throw new ReferenceError(`Reference ${key} in component ${this.componentName} could not be found.`);
        });
    };
    cleanup() {
    // Override this function in your classes as required
    }
}



var $ac0af11aed6320f0$exports = {};
/*! PhotoSwipe - v4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) define(factory);
    else $ac0af11aed6320f0$exports = factory();
})($ac0af11aed6320f0$exports, function() {
    'use strict';
    var PhotoSwipe = function(template, UiClass, items, options) {
        /*>>framework-bridge*/ /**
 *
 * Set of generic functions used by gallery.
 * 
 * You're free to modify anything here as long as functionality is kept.
 * 
 */ var framework = {
            features: null,
            bind: function(target, type, listener, unbind) {
                var methodName = (unbind ? 'remove' : 'add') + 'EventListener';
                type = type.split(' ');
                for(var i = 0; i < type.length; i++)if (type[i]) target[methodName](type[i], listener, false);
            },
            isArray: function(obj) {
                return obj instanceof Array;
            },
            createEl: function(classes, tag) {
                var el = document.createElement(tag || 'div');
                if (classes) el.className = classes;
                return el;
            },
            getScrollY: function() {
                var yOffset = window.pageYOffset;
                return yOffset !== undefined ? yOffset : document.documentElement.scrollTop;
            },
            unbind: function(target, type, listener) {
                framework.bind(target, type, listener, true);
            },
            removeClass: function(el, className) {
                var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
                el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
            },
            addClass: function(el, className) {
                if (!framework.hasClass(el, className)) el.className += (el.className ? ' ' : '') + className;
            },
            hasClass: function(el, className) {
                return el.className && new RegExp('(^|\\s)' + className + '(\\s|$)').test(el.className);
            },
            getChildByClass: function(parentEl, childClassName) {
                var node = parentEl.firstChild;
                while(node){
                    if (framework.hasClass(node, childClassName)) return node;
                    node = node.nextSibling;
                }
            },
            arraySearch: function(array, value, key) {
                var i = array.length;
                while(i--){
                    if (array[i][key] === value) return i;
                }
                return -1;
            },
            extend: function(o1, o2, preventOverwrite) {
                for(var prop in o2)if (o2.hasOwnProperty(prop)) {
                    if (preventOverwrite && o1.hasOwnProperty(prop)) continue;
                    o1[prop] = o2[prop];
                }
            },
            easing: {
                sine: {
                    out: function(k) {
                        return Math.sin(k * (Math.PI / 2));
                    },
                    inOut: function(k) {
                        return -(Math.cos(Math.PI * k) - 1) / 2;
                    }
                },
                cubic: {
                    out: function(k) {
                        return --k * k * k + 1;
                    }
                }
            },
            /**
	 * 
	 * @return {object}
	 * 
	 * {
	 *  raf : request animation frame function
	 *  caf : cancel animation frame function
	 *  transfrom : transform property key (with vendor), or null if not supported
	 *  oldIE : IE8 or below
	 * }
	 * 
	 */ detectFeatures: function() {
                if (framework.features) return framework.features;
                var helperEl = framework.createEl(), helperStyle = helperEl.style, vendor = '', features = {};
                // IE8 and below
                features.oldIE = document.all && !document.addEventListener;
                features.touch = 'ontouchstart' in window;
                if (window.requestAnimationFrame) {
                    features.raf = window.requestAnimationFrame;
                    features.caf = window.cancelAnimationFrame;
                }
                features.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled;
                // fix false-positive detection of old Android in new IE
                // (IE11 ua string contains "Android 4.0")
                if (!features.pointerEvent) {
                    var ua = navigator.userAgent;
                    // Detect if device is iPhone or iPod and if it's older than iOS 8
                    // http://stackoverflow.com/a/14223920
                    // 
                    // This detection is made because of buggy top/bottom toolbars
                    // that don't trigger window.resize event.
                    // For more info refer to _isFixedPosition variable in core.js
                    if (/iP(hone|od)/.test(navigator.platform)) {
                        var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                        if (v && v.length > 0) {
                            v = parseInt(v[1], 10);
                            if (v >= 1 && v < 8) features.isOldIOSPhone = true;
                        }
                    }
                    // Detect old Android (before KitKat)
                    // due to bugs related to position:fixed
                    // http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript
                    var match = ua.match(/Android\s([0-9\.]*)/);
                    var androidversion = match ? match[1] : 0;
                    androidversion = parseFloat(androidversion);
                    if (androidversion >= 1) {
                        if (androidversion < 4.4) features.isOldAndroid = true; // for fixed position bug & performance
                        features.androidVersion = androidversion; // for touchend bug
                    }
                    features.isMobileOpera = /opera mini|opera mobi/i.test(ua);
                // p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
                }
                var styleChecks = [
                    'transform',
                    'perspective',
                    'animationName'
                ], vendors = [
                    '',
                    'webkit',
                    'Moz',
                    'ms',
                    'O'
                ], styleCheckItem, styleName;
                for(var i = 0; i < 4; i++){
                    vendor = vendors[i];
                    for(var a = 0; a < 3; a++){
                        styleCheckItem = styleChecks[a];
                        // uppercase first letter of property name, if vendor is present
                        styleName = vendor + (vendor ? styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) : styleCheckItem);
                        if (!features[styleCheckItem] && styleName in helperStyle) features[styleCheckItem] = styleName;
                    }
                    if (vendor && !features.raf) {
                        vendor = vendor.toLowerCase();
                        features.raf = window[vendor + 'RequestAnimationFrame'];
                        if (features.raf) features.caf = window[vendor + 'CancelAnimationFrame'] || window[vendor + 'CancelRequestAnimationFrame'];
                    }
                }
                if (!features.raf) {
                    var lastTime = 0;
                    features.raf = function(fn) {
                        var currTime = new Date().getTime();
                        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
                        var id = window.setTimeout(function() {
                            fn(currTime + timeToCall);
                        }, timeToCall);
                        lastTime = currTime + timeToCall;
                        return id;
                    };
                    features.caf = function(id) {
                        clearTimeout(id);
                    };
                }
                // Detect SVG support
                features.svg = !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;
                framework.features = features;
                return features;
            }
        };
        framework.detectFeatures();
        // Override addEventListener for old versions of IE
        if (framework.features.oldIE) framework.bind = function(target, type, listener, unbind) {
            type = type.split(' ');
            var methodName = (unbind ? 'detach' : 'attach') + 'Event', evName, _handleEv = function() {
                listener.handleEvent.call(listener);
            };
            for(var i = 0; i < type.length; i++){
                evName = type[i];
                if (evName) {
                    if (typeof listener === 'object' && listener.handleEvent) {
                        if (!unbind) listener['oldIE' + evName] = _handleEv;
                        else {
                            if (!listener['oldIE' + evName]) return false;
                        }
                        target[methodName]('on' + evName, listener['oldIE' + evName]);
                    } else target[methodName]('on' + evName, listener);
                }
            }
        };
        /*>>framework-bridge*/ /*>>core*/ //function(template, UiClass, items, options)
        var self = this;
        /**
 * Static vars, don't change unless you know what you're doing.
 */ var DOUBLE_TAP_RADIUS = 25, NUM_HOLDERS = 3;
        /**
 * Options
 */ var _options = {
            allowPanToNext: true,
            spacing: 0.12,
            bgOpacity: 1,
            mouseUsed: false,
            loop: true,
            pinchToClose: true,
            closeOnScroll: true,
            closeOnVerticalDrag: true,
            verticalDragRange: 0.75,
            hideAnimationDuration: 333,
            showAnimationDuration: 333,
            showHideOpacity: false,
            focus: true,
            escKey: true,
            arrowKeys: true,
            mainScrollEndFriction: 0.35,
            panEndFriction: 0.35,
            isClickableElement: function(el) {
                return el.tagName === 'A';
            },
            getDoubleTapZoom: function(isMouseClick, item) {
                if (isMouseClick) return 1;
                else return item.initialZoomLevel < 0.7 ? 1 : 1.33;
            },
            maxSpreadZoom: 1.33,
            modal: true,
            // not fully implemented yet
            scaleMode: 'fit' // TODO
        };
        framework.extend(_options, options);
        /**
 * Private helper variables & functions
 */ var _getEmptyPoint = function() {
            return {
                x: 0,
                y: 0
            };
        };
        var _isOpen, _isDestroying, _closedByScroll, _currentItemIndex, _containerStyle, _containerShiftIndex, _currPanDist = _getEmptyPoint(), _startPanOffset = _getEmptyPoint(), _panOffset = _getEmptyPoint(), _upMoveEvents, _downEvents, _globalEventHandlers, _viewportSize = {}, _currZoomLevel, _startZoomLevel, _translatePrefix, _translateSufix, _updateSizeInterval, _itemsNeedUpdate, _currPositionIndex = 0, _offset = {}, _slideSize = _getEmptyPoint(), _itemHolders, _prevItemIndex, _indexDiff = 0, _dragStartEvent, _dragMoveEvent, _dragEndEvent, _dragCancelEvent, _transformKey, _pointerEventEnabled, _isFixedPosition = true, _likelyTouchDevice, _modules = [], _requestAF, _cancelAF, _initalClassName, _initalWindowScrollY, _oldIE, _currentWindowScrollY, _features, _windowVisibleSize = {}, _renderMaxResolution = false, _orientationChangeTimeout, // Registers PhotoSWipe module (History, Controller ...)
        _registerModule = function(name, module1) {
            framework.extend(self, module1.publicMethods);
            _modules.push(name);
        }, _getLoopedId = function(index) {
            var numSlides = _getNumItems();
            if (index > numSlides - 1) return index - numSlides;
            else if (index < 0) return numSlides + index;
            return index;
        }, // Micro bind/trigger
        _listeners = {}, _listen = function(name, fn) {
            if (!_listeners[name]) _listeners[name] = [];
            return _listeners[name].push(fn);
        }, _shout = function(name) {
            var listeners = _listeners[name];
            if (listeners) {
                var args = Array.prototype.slice.call(arguments);
                args.shift();
                for(var i = 0; i < listeners.length; i++)listeners[i].apply(self, args);
            }
        }, _getCurrentTime = function() {
            return new Date().getTime();
        }, _applyBgOpacity = function(opacity) {
            _bgOpacity = opacity;
            self.bg.style.opacity = opacity * _options.bgOpacity;
        }, _applyZoomTransform = function(styleObj, x, y, zoom, item) {
            if (!_renderMaxResolution || item && item !== self.currItem) zoom = zoom / (item ? item.fitRatio : self.currItem.fitRatio);
            styleObj[_transformKey] = _translatePrefix + x + 'px, ' + y + 'px' + _translateSufix + ' scale(' + zoom + ')';
        }, _applyCurrentZoomPan = function(allowRenderResolution) {
            if (_currZoomElementStyle) {
                if (allowRenderResolution) {
                    if (_currZoomLevel > self.currItem.fitRatio) {
                        if (!_renderMaxResolution) {
                            _setImageSize(self.currItem, false, true);
                            _renderMaxResolution = true;
                        }
                    } else if (_renderMaxResolution) {
                        _setImageSize(self.currItem);
                        _renderMaxResolution = false;
                    }
                }
                _applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel);
            }
        }, _applyZoomPanToItem = function(item) {
            if (item.container) _applyZoomTransform(item.container.style, item.initialPosition.x, item.initialPosition.y, item.initialZoomLevel, item);
        }, _setTranslateX = function(x, elStyle) {
            elStyle[_transformKey] = _translatePrefix + x + 'px, 0px' + _translateSufix;
        }, _moveMainScroll = function(x, dragging) {
            if (!_options.loop && dragging) {
                var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x) / _slideSize.x, delta = Math.round(x - _mainScrollPos.x);
                if (newSlideIndexOffset < 0 && delta > 0 || newSlideIndexOffset >= _getNumItems() - 1 && delta < 0) x = _mainScrollPos.x + delta * _options.mainScrollEndFriction;
            }
            _mainScrollPos.x = x;
            _setTranslateX(x, _containerStyle);
        }, _calculatePanOffset = function(axis, zoomLevel) {
            var m = _midZoomPoint[axis] - _offset[axis];
            return _startPanOffset[axis] + _currPanDist[axis] + m - m * (zoomLevel / _startZoomLevel);
        }, _equalizePoints = function(p1, p2) {
            p1.x = p2.x;
            p1.y = p2.y;
            if (p2.id) p1.id = p2.id;
        }, _roundPoint = function(p) {
            p.x = Math.round(p.x);
            p.y = Math.round(p.y);
        }, _mouseMoveTimeout = null, _onFirstMouseMove = function() {
            // Wait until mouse move event is fired at least twice during 100ms
            // We do this, because some mobile browsers trigger it on touchstart
            if (_mouseMoveTimeout) {
                framework.unbind(document, 'mousemove', _onFirstMouseMove);
                framework.addClass(template, 'pswp--has_mouse');
                _options.mouseUsed = true;
                _shout('mouseUsed');
            }
            _mouseMoveTimeout = setTimeout(function() {
                _mouseMoveTimeout = null;
            }, 100);
        }, _bindEvents = function() {
            framework.bind(document, 'keydown', self);
            if (_features.transform) // don't bind click event in browsers that don't support transform (mostly IE8)
            framework.bind(self.scrollWrap, 'click', self);
            if (!_options.mouseUsed) framework.bind(document, 'mousemove', _onFirstMouseMove);
            framework.bind(window, 'resize scroll orientationchange', self);
            _shout('bindEvents');
        }, _unbindEvents = function() {
            framework.unbind(window, 'resize scroll orientationchange', self);
            framework.unbind(window, 'scroll', _globalEventHandlers.scroll);
            framework.unbind(document, 'keydown', self);
            framework.unbind(document, 'mousemove', _onFirstMouseMove);
            if (_features.transform) framework.unbind(self.scrollWrap, 'click', self);
            if (_isDragging) framework.unbind(window, _upMoveEvents, self);
            clearTimeout(_orientationChangeTimeout);
            _shout('unbindEvents');
        }, _calculatePanBounds = function(zoomLevel, update) {
            var bounds = _calculateItemSize(self.currItem, _viewportSize, zoomLevel);
            if (update) _currPanBounds = bounds;
            return bounds;
        }, _getMinZoomLevel = function(item) {
            if (!item) item = self.currItem;
            return item.initialZoomLevel;
        }, _getMaxZoomLevel = function(item) {
            if (!item) item = self.currItem;
            return item.w > 0 ? _options.maxSpreadZoom : 1;
        }, // Return true if offset is out of the bounds
        _modifyDestPanOffset = function(axis, destPanBounds, destPanOffset, destZoomLevel) {
            if (destZoomLevel === self.currItem.initialZoomLevel) {
                destPanOffset[axis] = self.currItem.initialPosition[axis];
                return true;
            } else {
                destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel);
                if (destPanOffset[axis] > destPanBounds.min[axis]) {
                    destPanOffset[axis] = destPanBounds.min[axis];
                    return true;
                } else if (destPanOffset[axis] < destPanBounds.max[axis]) {
                    destPanOffset[axis] = destPanBounds.max[axis];
                    return true;
                }
            }
            return false;
        }, _setupTransforms = function() {
            if (_transformKey) {
                // setup 3d transforms
                var allow3dTransform = _features.perspective && !_likelyTouchDevice;
                _translatePrefix = 'translate' + (allow3dTransform ? '3d(' : '(');
                _translateSufix = _features.perspective ? ', 0px)' : ')';
                return;
            }
            // Override zoom/pan/move functions in case old browser is used (most likely IE)
            // (so they use left/top/width/height, instead of CSS transform)
            _transformKey = 'left';
            framework.addClass(template, 'pswp--ie');
            _setTranslateX = function(x, elStyle) {
                elStyle.left = x + 'px';
            };
            _applyZoomPanToItem = function(item) {
                var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio, s = item.container.style, w = zoomRatio * item.w, h = zoomRatio * item.h;
                s.width = w + 'px';
                s.height = h + 'px';
                s.left = item.initialPosition.x + 'px';
                s.top = item.initialPosition.y + 'px';
            };
            _applyCurrentZoomPan = function() {
                if (_currZoomElementStyle) {
                    var s = _currZoomElementStyle, item = self.currItem, zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio, w = zoomRatio * item.w, h = zoomRatio * item.h;
                    s.width = w + 'px';
                    s.height = h + 'px';
                    s.left = _panOffset.x + 'px';
                    s.top = _panOffset.y + 'px';
                }
            };
        }, _onKeyDown = function(e) {
            var keydownAction = '';
            if (_options.escKey && e.keyCode === 27) keydownAction = 'close';
            else if (_options.arrowKeys) {
                if (e.keyCode === 37) keydownAction = 'prev';
                else if (e.keyCode === 39) keydownAction = 'next';
            }
            if (keydownAction) // don't do anything if special key pressed to prevent from overriding default browser actions
            // e.g. in Chrome on Mac cmd+arrow-left returns to previous page
            {
                if (!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey) {
                    if (e.preventDefault) e.preventDefault();
                    else e.returnValue = false;
                    self[keydownAction]();
                }
            }
        }, _onGlobalClick = function(e) {
            if (!e) return;
            // don't allow click event to pass through when triggering after drag or some other gesture
            if (_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) {
                e.preventDefault();
                e.stopPropagation();
            }
        }, _updatePageScrollOffset = function() {
            self.setScrollOffset(0, framework.getScrollY());
        };
        // Micro animation engine
        var _animations = {}, _numAnimations = 0, _stopAnimation = function(name) {
            if (_animations[name]) {
                if (_animations[name].raf) _cancelAF(_animations[name].raf);
                _numAnimations--;
                delete _animations[name];
            }
        }, _registerStartAnimation = function(name) {
            if (_animations[name]) _stopAnimation(name);
            if (!_animations[name]) {
                _numAnimations++;
                _animations[name] = {};
            }
        }, _stopAllAnimations = function() {
            for(var prop in _animations)if (_animations.hasOwnProperty(prop)) _stopAnimation(prop);
        }, _animateProp = function(name, b, endProp, d, easingFn, onUpdate, onComplete) {
            var startAnimTime = _getCurrentTime(), t;
            _registerStartAnimation(name);
            var animloop = function() {
                if (_animations[name]) {
                    t = _getCurrentTime() - startAnimTime; // time diff
                    //b - beginning (start prop)
                    //d - anim duration
                    if (t >= d) {
                        _stopAnimation(name);
                        onUpdate(endProp);
                        if (onComplete) onComplete();
                        return;
                    }
                    onUpdate((endProp - b) * easingFn(t / d) + b);
                    _animations[name].raf = _requestAF(animloop);
                }
            };
            animloop();
        };
        var publicMethods = {
            // make a few local variables and functions public
            shout: _shout,
            listen: _listen,
            viewportSize: _viewportSize,
            options: _options,
            isMainScrollAnimating: function() {
                return _mainScrollAnimating;
            },
            getZoomLevel: function() {
                return _currZoomLevel;
            },
            getCurrentIndex: function() {
                return _currentItemIndex;
            },
            isDragging: function() {
                return _isDragging;
            },
            isZooming: function() {
                return _isZooming;
            },
            setScrollOffset: function(x, y) {
                _offset.x = x;
                _currentWindowScrollY = _offset.y = y;
                _shout('updateScrollOffset', _offset);
            },
            applyZoomPan: function(zoomLevel, panX, panY, allowRenderResolution) {
                _panOffset.x = panX;
                _panOffset.y = panY;
                _currZoomLevel = zoomLevel;
                _applyCurrentZoomPan(allowRenderResolution);
            },
            init: function() {
                if (_isOpen || _isDestroying) return;
                var i;
                self.framework = framework; // basic functionality
                self.template = template; // root DOM element of PhotoSwipe
                self.bg = framework.getChildByClass(template, 'pswp__bg');
                _initalClassName = template.className;
                _isOpen = true;
                _features = framework.detectFeatures();
                _requestAF = _features.raf;
                _cancelAF = _features.caf;
                _transformKey = _features.transform;
                _oldIE = _features.oldIE;
                self.scrollWrap = framework.getChildByClass(template, 'pswp__scroll-wrap');
                self.container = framework.getChildByClass(self.scrollWrap, 'pswp__container');
                _containerStyle = self.container.style; // for fast access
                // Objects that hold slides (there are only 3 in DOM)
                self.itemHolders = _itemHolders = [
                    {
                        el: self.container.children[0],
                        wrap: 0,
                        index: -1
                    },
                    {
                        el: self.container.children[1],
                        wrap: 0,
                        index: -1
                    },
                    {
                        el: self.container.children[2],
                        wrap: 0,
                        index: -1
                    }
                ];
                // hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
                _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'none';
                _setupTransforms();
                // Setup global events
                _globalEventHandlers = {
                    resize: self.updateSize,
                    // Fixes: iOS 10.3 resize event
                    // does not update scrollWrap.clientWidth instantly after resize
                    // https://github.com/dimsemenov/PhotoSwipe/issues/1315
                    orientationchange: function() {
                        clearTimeout(_orientationChangeTimeout);
                        _orientationChangeTimeout = setTimeout(function() {
                            if (_viewportSize.x !== self.scrollWrap.clientWidth) self.updateSize();
                        }, 500);
                    },
                    scroll: _updatePageScrollOffset,
                    keydown: _onKeyDown,
                    click: _onGlobalClick
                };
                // disable show/hide effects on old browsers that don't support CSS animations or transforms, 
                // old IOS, Android and Opera mobile. Blackberry seems to work fine, even older models.
                var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
                if (!_features.animationName || !_features.transform || oldPhone) _options.showAnimationDuration = _options.hideAnimationDuration = 0;
                // init modules
                for(i = 0; i < _modules.length; i++)self['init' + _modules[i]]();
                // init
                if (UiClass) {
                    var ui = self.ui = new UiClass(self, framework);
                    ui.init();
                }
                _shout('firstUpdate');
                _currentItemIndex = _currentItemIndex || _options.index || 0;
                // validate index
                if (isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems()) _currentItemIndex = 0;
                self.currItem = _getItemAt(_currentItemIndex);
                if (_features.isOldIOSPhone || _features.isOldAndroid) _isFixedPosition = false;
                template.setAttribute('aria-hidden', 'false');
                if (_options.modal) {
                    if (!_isFixedPosition) {
                        template.style.position = 'absolute';
                        template.style.top = framework.getScrollY() + 'px';
                    } else template.style.position = 'fixed';
                }
                if (_currentWindowScrollY === undefined) {
                    _shout('initialLayout');
                    _currentWindowScrollY = _initalWindowScrollY = framework.getScrollY();
                }
                // add classes to root element of PhotoSwipe
                var rootClasses = 'pswp--open ';
                if (_options.mainClass) rootClasses += _options.mainClass + ' ';
                if (_options.showHideOpacity) rootClasses += 'pswp--animate_opacity ';
                rootClasses += _likelyTouchDevice ? 'pswp--touch' : 'pswp--notouch';
                rootClasses += _features.animationName ? ' pswp--css_animation' : '';
                rootClasses += _features.svg ? ' pswp--svg' : '';
                framework.addClass(template, rootClasses);
                self.updateSize();
                // initial update
                _containerShiftIndex = -1;
                _indexDiff = null;
                for(i = 0; i < NUM_HOLDERS; i++)_setTranslateX((i + _containerShiftIndex) * _slideSize.x, _itemHolders[i].el.style);
                if (!_oldIE) framework.bind(self.scrollWrap, _downEvents, self); // no dragging for old IE
                _listen('initialZoomInEnd', function() {
                    self.setContent(_itemHolders[0], _currentItemIndex - 1);
                    self.setContent(_itemHolders[2], _currentItemIndex + 1);
                    _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'block';
                    if (_options.focus) // focus causes layout, 
                    // which causes lag during the animation, 
                    // that's why we delay it untill the initial zoom transition ends
                    template.focus();
                    _bindEvents();
                });
                // set content for center slide (first time)
                self.setContent(_itemHolders[1], _currentItemIndex);
                self.updateCurrItem();
                _shout('afterInit');
                if (!_isFixedPosition) // On all versions of iOS lower than 8.0, we check size of viewport every second.
                // 
                // This is done to detect when Safari top & bottom bars appear, 
                // as this action doesn't trigger any events (like resize). 
                // 
                // On iOS8 they fixed this.
                // 
                // 10 Nov 2014: iOS 7 usage ~40%. iOS 8 usage 56%.
                _updateSizeInterval = setInterval(function() {
                    if (!_numAnimations && !_isDragging && !_isZooming && _currZoomLevel === self.currItem.initialZoomLevel) self.updateSize();
                }, 1000);
                framework.addClass(template, 'pswp--visible');
            },
            // Close the gallery, then destroy it
            close: function() {
                if (!_isOpen) return;
                _isOpen = false;
                _isDestroying = true;
                _shout('close');
                _unbindEvents();
                _showOrHide(self.currItem, null, true, self.destroy);
            },
            // destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
            destroy: function() {
                _shout('destroy');
                if (_showOrHideTimeout) clearTimeout(_showOrHideTimeout);
                template.setAttribute('aria-hidden', 'true');
                template.className = _initalClassName;
                if (_updateSizeInterval) clearInterval(_updateSizeInterval);
                framework.unbind(self.scrollWrap, _downEvents, self);
                // we unbind scroll event at the end, as closing animation may depend on it
                framework.unbind(window, 'scroll', self);
                _stopDragUpdateLoop();
                _stopAllAnimations();
                _listeners = null;
            },
            /**
	 * Pan image to position
	 * @param {Number} x     
	 * @param {Number} y     
	 * @param {Boolean} force Will ignore bounds if set to true.
	 */ panTo: function(x, y, force) {
                if (!force) {
                    if (x > _currPanBounds.min.x) x = _currPanBounds.min.x;
                    else if (x < _currPanBounds.max.x) x = _currPanBounds.max.x;
                    if (y > _currPanBounds.min.y) y = _currPanBounds.min.y;
                    else if (y < _currPanBounds.max.y) y = _currPanBounds.max.y;
                }
                _panOffset.x = x;
                _panOffset.y = y;
                _applyCurrentZoomPan();
            },
            handleEvent: function(e) {
                e = e || window.event;
                if (_globalEventHandlers[e.type]) _globalEventHandlers[e.type](e);
            },
            goTo: function(index) {
                index = _getLoopedId(index);
                var diff = index - _currentItemIndex;
                _indexDiff = diff;
                _currentItemIndex = index;
                self.currItem = _getItemAt(_currentItemIndex);
                _currPositionIndex -= diff;
                _moveMainScroll(_slideSize.x * _currPositionIndex);
                _stopAllAnimations();
                _mainScrollAnimating = false;
                self.updateCurrItem();
            },
            next: function() {
                self.goTo(_currentItemIndex + 1);
            },
            prev: function() {
                self.goTo(_currentItemIndex - 1);
            },
            // update current zoom/pan objects
            updateCurrZoomItem: function(emulateSetContent) {
                if (emulateSetContent) _shout('beforeChange', 0);
                // itemHolder[1] is middle (current) item
                if (_itemHolders[1].el.children.length) {
                    var zoomElement = _itemHolders[1].el.children[0];
                    if (framework.hasClass(zoomElement, 'pswp__zoom-wrap')) _currZoomElementStyle = zoomElement.style;
                    else _currZoomElementStyle = null;
                } else _currZoomElementStyle = null;
                _currPanBounds = self.currItem.bounds;
                _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
                _panOffset.x = _currPanBounds.center.x;
                _panOffset.y = _currPanBounds.center.y;
                if (emulateSetContent) _shout('afterChange');
            },
            invalidateCurrItems: function() {
                _itemsNeedUpdate = true;
                for(var i = 0; i < NUM_HOLDERS; i++)if (_itemHolders[i].item) _itemHolders[i].item.needsUpdate = true;
            },
            updateCurrItem: function(beforeAnimation) {
                if (_indexDiff === 0) return;
                var diffAbs = Math.abs(_indexDiff), tempHolder;
                if (beforeAnimation && diffAbs < 2) return;
                self.currItem = _getItemAt(_currentItemIndex);
                _renderMaxResolution = false;
                _shout('beforeChange', _indexDiff);
                if (diffAbs >= NUM_HOLDERS) {
                    _containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
                    diffAbs = NUM_HOLDERS;
                }
                for(var i = 0; i < diffAbs; i++)if (_indexDiff > 0) {
                    tempHolder = _itemHolders.shift();
                    _itemHolders[NUM_HOLDERS - 1] = tempHolder; // move first to last
                    _containerShiftIndex++;
                    _setTranslateX((_containerShiftIndex + 2) * _slideSize.x, tempHolder.el.style);
                    self.setContent(tempHolder, _currentItemIndex - diffAbs + i + 1 + 1);
                } else {
                    tempHolder = _itemHolders.pop();
                    _itemHolders.unshift(tempHolder); // move last to first
                    _containerShiftIndex--;
                    _setTranslateX(_containerShiftIndex * _slideSize.x, tempHolder.el.style);
                    self.setContent(tempHolder, _currentItemIndex + diffAbs - i - 1 - 1);
                }
                // reset zoom/pan on previous item
                if (_currZoomElementStyle && Math.abs(_indexDiff) === 1) {
                    var prevItem = _getItemAt(_prevItemIndex);
                    if (prevItem.initialZoomLevel !== _currZoomLevel) {
                        _calculateItemSize(prevItem, _viewportSize);
                        _setImageSize(prevItem);
                        _applyZoomPanToItem(prevItem);
                    }
                }
                // reset diff after update
                _indexDiff = 0;
                self.updateCurrZoomItem();
                _prevItemIndex = _currentItemIndex;
                _shout('afterChange');
            },
            updateSize: function(force) {
                if (!_isFixedPosition && _options.modal) {
                    var windowScrollY = framework.getScrollY();
                    if (_currentWindowScrollY !== windowScrollY) {
                        template.style.top = windowScrollY + 'px';
                        _currentWindowScrollY = windowScrollY;
                    }
                    if (!force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) return;
                    _windowVisibleSize.x = window.innerWidth;
                    _windowVisibleSize.y = window.innerHeight;
                    //template.style.width = _windowVisibleSize.x + 'px';
                    template.style.height = _windowVisibleSize.y + 'px';
                }
                _viewportSize.x = self.scrollWrap.clientWidth;
                _viewportSize.y = self.scrollWrap.clientHeight;
                _updatePageScrollOffset();
                _slideSize.x = _viewportSize.x + Math.round(_viewportSize.x * _options.spacing);
                _slideSize.y = _viewportSize.y;
                _moveMainScroll(_slideSize.x * _currPositionIndex);
                _shout('beforeResize'); // even may be used for example to switch image sources
                // don't re-calculate size on inital size update
                if (_containerShiftIndex !== undefined) {
                    var holder, item, hIndex;
                    for(var i = 0; i < NUM_HOLDERS; i++){
                        holder = _itemHolders[i];
                        _setTranslateX((i + _containerShiftIndex) * _slideSize.x, holder.el.style);
                        hIndex = _currentItemIndex + i - 1;
                        if (_options.loop && _getNumItems() > 2) hIndex = _getLoopedId(hIndex);
                        // update zoom level on items and refresh source (if needsUpdate)
                        item = _getItemAt(hIndex);
                        // re-render gallery item if `needsUpdate`,
                        // or doesn't have `bounds` (entirely new slide object)
                        if (item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds)) {
                            self.cleanSlide(item);
                            self.setContent(holder, hIndex);
                            // if "center" slide
                            if (i === 1) {
                                self.currItem = item;
                                self.updateCurrZoomItem(true);
                            }
                            item.needsUpdate = false;
                        } else if (holder.index === -1 && hIndex >= 0) // add content first time
                        self.setContent(holder, hIndex);
                        if (item && item.container) {
                            _calculateItemSize(item, _viewportSize);
                            _setImageSize(item);
                            _applyZoomPanToItem(item);
                        }
                    }
                    _itemsNeedUpdate = false;
                }
                _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
                _currPanBounds = self.currItem.bounds;
                if (_currPanBounds) {
                    _panOffset.x = _currPanBounds.center.x;
                    _panOffset.y = _currPanBounds.center.y;
                    _applyCurrentZoomPan(true);
                }
                _shout('resize');
            },
            // Zoom current item to
            zoomTo: function(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
                /*
			if(destZoomLevel === 'fit') {
				destZoomLevel = self.currItem.fitRatio;
			} else if(destZoomLevel === 'fill') {
				destZoomLevel = self.currItem.fillRatio;
			}
		*/ if (centerPoint) {
                    _startZoomLevel = _currZoomLevel;
                    _midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x;
                    _midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y;
                    _equalizePoints(_startPanOffset, _panOffset);
                }
                var destPanBounds = _calculatePanBounds(destZoomLevel, false), destPanOffset = {};
                _modifyDestPanOffset('x', destPanBounds, destPanOffset, destZoomLevel);
                _modifyDestPanOffset('y', destPanBounds, destPanOffset, destZoomLevel);
                var initialZoomLevel = _currZoomLevel;
                var initialPanOffset = {
                    x: _panOffset.x,
                    y: _panOffset.y
                };
                _roundPoint(destPanOffset);
                var onUpdate = function(now) {
                    if (now === 1) {
                        _currZoomLevel = destZoomLevel;
                        _panOffset.x = destPanOffset.x;
                        _panOffset.y = destPanOffset.y;
                    } else {
                        _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
                        _panOffset.x = (destPanOffset.x - initialPanOffset.x) * now + initialPanOffset.x;
                        _panOffset.y = (destPanOffset.y - initialPanOffset.y) * now + initialPanOffset.y;
                    }
                    if (updateFn) updateFn(now);
                    _applyCurrentZoomPan(now === 1);
                };
                if (speed) _animateProp('customZoomTo', 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate);
                else onUpdate(1);
            }
        };
        /*>>core*/ /*>>gestures*/ /**
 * Mouse/touch/pointer event handlers.
 * 
 * separated from @core.js for readability
 */ var MIN_SWIPE_DISTANCE = 30, DIRECTION_CHECK_OFFSET = 10; // amount of pixels to drag to determine direction of swipe
        var _gestureStartTime, _gestureCheckSpeedTime, // pool of objects that are used during dragging of zooming
        p = {}, p2 = {}, delta = {}, _currPoint = {}, _startPoint = {}, _currPointers = [], _startMainScrollPos = {}, _releaseAnimData, _posPoints = [], _tempPoint = {}, _isZoomingIn, _verticalDragInitiated, _oldAndroidTouchEndTimeout, _currZoomedItemIndex = 0, _centerPoint = _getEmptyPoint(), _lastReleaseTime = 0, _isDragging, _isMultitouch, _zoomStarted, _moved, _dragAnimFrame, _mainScrollShifted, _currentPoints, _isZooming, _currPointsDistance, _startPointsDistance, _currPanBounds, _mainScrollPos = _getEmptyPoint(), _currZoomElementStyle, _mainScrollAnimating, _midZoomPoint = _getEmptyPoint(), _currCenterPoint = _getEmptyPoint(), _direction, _isFirstMove, _opacityChanged, _bgOpacity, _wasOverInitialZoom, _isEqualPoints = function(p1, p2) {
            return p1.x === p2.x && p1.y === p2.y;
        }, _isNearbyPoints = function(touch0, touch1) {
            return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS;
        }, _calculatePointsDistance = function(p1, p2) {
            _tempPoint.x = Math.abs(p1.x - p2.x);
            _tempPoint.y = Math.abs(p1.y - p2.y);
            return Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y);
        }, _stopDragUpdateLoop = function() {
            if (_dragAnimFrame) {
                _cancelAF(_dragAnimFrame);
                _dragAnimFrame = null;
            }
        }, _dragUpdateLoop = function() {
            if (_isDragging) {
                _dragAnimFrame = _requestAF(_dragUpdateLoop);
                _renderMovement();
            }
        }, _canPan = function() {
            return !(_options.scaleMode === 'fit' && _currZoomLevel === self.currItem.initialZoomLevel);
        }, // find the closest parent DOM element
        _closestElement = function(el, fn) {
            if (!el || el === document) return false;
            // don't search elements above pswp__scroll-wrap
            if (el.getAttribute('class') && el.getAttribute('class').indexOf('pswp__scroll-wrap') > -1) return false;
            if (fn(el)) return el;
            return _closestElement(el.parentNode, fn);
        }, _preventObj = {}, _preventDefaultEventBehaviour = function(e, isDown) {
            _preventObj.prevent = !_closestElement(e.target, _options.isClickableElement);
            _shout('preventDragEvent', e, isDown, _preventObj);
            return _preventObj.prevent;
        }, _convertTouchToPoint = function(touch, p) {
            p.x = touch.pageX;
            p.y = touch.pageY;
            p.id = touch.identifier;
            return p;
        }, _findCenterOfPoints = function(p1, p2, pCenter) {
            pCenter.x = (p1.x + p2.x) * 0.5;
            pCenter.y = (p1.y + p2.y) * 0.5;
        }, _pushPosPoint = function(time, x, y) {
            if (time - _gestureCheckSpeedTime > 50) {
                var o = _posPoints.length > 2 ? _posPoints.shift() : {};
                o.x = x;
                o.y = y;
                _posPoints.push(o);
                _gestureCheckSpeedTime = time;
            }
        }, _calculateVerticalDragOpacityRatio = function() {
            var yOffset = _panOffset.y - self.currItem.initialPosition.y; // difference between initial and current position
            return 1 - Math.abs(yOffset / (_viewportSize.y / 2));
        }, // points pool, reused during touch events
        _ePoint1 = {}, _ePoint2 = {}, _tempPointsArr = [], _tempCounter, _getTouchPoints = function(e) {
            // clean up previous points, without recreating array
            while(_tempPointsArr.length > 0)_tempPointsArr.pop();
            if (!_pointerEventEnabled) {
                if (e.type.indexOf('touch') > -1) {
                    if (e.touches && e.touches.length > 0) {
                        _tempPointsArr[0] = _convertTouchToPoint(e.touches[0], _ePoint1);
                        if (e.touches.length > 1) _tempPointsArr[1] = _convertTouchToPoint(e.touches[1], _ePoint2);
                    }
                } else {
                    _ePoint1.x = e.pageX;
                    _ePoint1.y = e.pageY;
                    _ePoint1.id = '';
                    _tempPointsArr[0] = _ePoint1; //_ePoint1;
                }
            } else {
                _tempCounter = 0;
                // we can use forEach, as pointer events are supported only in modern browsers
                _currPointers.forEach(function(p) {
                    if (_tempCounter === 0) _tempPointsArr[0] = p;
                    else if (_tempCounter === 1) _tempPointsArr[1] = p;
                    _tempCounter++;
                });
            }
            return _tempPointsArr;
        }, _panOrMoveMainScroll = function(axis, delta) {
            var panFriction, overDiff = 0, newOffset = _panOffset[axis] + delta[axis], startOverDiff, dir = delta[axis] > 0, newMainScrollPosition = _mainScrollPos.x + delta.x, mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x, newPanPos, newMainScrollPos;
            // calculate fdistance over the bounds and friction
            if (newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis]) panFriction = _options.panEndFriction;
            else panFriction = 1;
            newOffset = _panOffset[axis] + delta[axis] * panFriction;
            // move main scroll or start panning
            if (_options.allowPanToNext || _currZoomLevel === self.currItem.initialZoomLevel) {
                if (!_currZoomElementStyle) newMainScrollPos = newMainScrollPosition;
                else if (_direction === 'h' && axis === 'x' && !_zoomStarted) {
                    if (dir) {
                        if (newOffset > _currPanBounds.min[axis]) {
                            panFriction = _options.panEndFriction;
                            overDiff = _currPanBounds.min[axis] - newOffset;
                            startOverDiff = _currPanBounds.min[axis] - _startPanOffset[axis];
                        }
                        // drag right
                        if ((startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1) {
                            newMainScrollPos = newMainScrollPosition;
                            if (mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x) newMainScrollPos = _startMainScrollPos.x;
                        } else if (_currPanBounds.min.x !== _currPanBounds.max.x) newPanPos = newOffset;
                    } else {
                        if (newOffset < _currPanBounds.max[axis]) {
                            panFriction = _options.panEndFriction;
                            overDiff = newOffset - _currPanBounds.max[axis];
                            startOverDiff = _startPanOffset[axis] - _currPanBounds.max[axis];
                        }
                        if ((startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1) {
                            newMainScrollPos = newMainScrollPosition;
                            if (mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x) newMainScrollPos = _startMainScrollPos.x;
                        } else if (_currPanBounds.min.x !== _currPanBounds.max.x) newPanPos = newOffset;
                    }
                }
                if (axis === 'x') {
                    if (newMainScrollPos !== undefined) {
                        _moveMainScroll(newMainScrollPos, true);
                        if (newMainScrollPos === _startMainScrollPos.x) _mainScrollShifted = false;
                        else _mainScrollShifted = true;
                    }
                    if (_currPanBounds.min.x !== _currPanBounds.max.x) {
                        if (newPanPos !== undefined) _panOffset.x = newPanPos;
                        else if (!_mainScrollShifted) _panOffset.x += delta.x * panFriction;
                    }
                    return newMainScrollPos !== undefined;
                }
            }
            if (!_mainScrollAnimating) {
                if (!_mainScrollShifted) {
                    if (_currZoomLevel > self.currItem.fitRatio) _panOffset[axis] += delta[axis] * panFriction;
                }
            }
        }, // Pointerdown/touchstart/mousedown handler
        _onDragStart = function(e) {
            // Allow dragging only via left mouse button.
            // As this handler is not added in IE8 - we ignore e.which
            // 
            // http://www.quirksmode.org/js/events_properties.html
            // https://developer.mozilla.org/en-US/docs/Web/API/event.button
            if (e.type === 'mousedown' && e.button > 0) return;
            if (_initialZoomRunning) {
                e.preventDefault();
                return;
            }
            if (_oldAndroidTouchEndTimeout && e.type === 'mousedown') return;
            if (_preventDefaultEventBehaviour(e, true)) e.preventDefault();
            _shout('pointerDown');
            if (_pointerEventEnabled) {
                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
                if (pointerIndex < 0) pointerIndex = _currPointers.length;
                _currPointers[pointerIndex] = {
                    x: e.pageX,
                    y: e.pageY,
                    id: e.pointerId
                };
            }
            var startPointsList = _getTouchPoints(e), numPoints = startPointsList.length;
            _currentPoints = null;
            _stopAllAnimations();
            // init drag
            if (!_isDragging || numPoints === 1) {
                _isDragging = _isFirstMove = true;
                framework.bind(window, _upMoveEvents, self);
                _isZoomingIn = _wasOverInitialZoom = _opacityChanged = _verticalDragInitiated = _mainScrollShifted = _moved = _isMultitouch = _zoomStarted = false;
                _direction = null;
                _shout('firstTouchStart', startPointsList);
                _equalizePoints(_startPanOffset, _panOffset);
                _currPanDist.x = _currPanDist.y = 0;
                _equalizePoints(_currPoint, startPointsList[0]);
                _equalizePoints(_startPoint, _currPoint);
                //_equalizePoints(_startMainScrollPos, _mainScrollPos);
                _startMainScrollPos.x = _slideSize.x * _currPositionIndex;
                _posPoints = [
                    {
                        x: _currPoint.x,
                        y: _currPoint.y
                    }
                ];
                _gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();
                //_mainScrollAnimationEnd(true);
                _calculatePanBounds(_currZoomLevel, true);
                // Start rendering
                _stopDragUpdateLoop();
                _dragUpdateLoop();
            }
            // init zoom
            if (!_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted) {
                _startZoomLevel = _currZoomLevel;
                _zoomStarted = false; // true if zoom changed at least once
                _isZooming = _isMultitouch = true;
                _currPanDist.y = _currPanDist.x = 0;
                _equalizePoints(_startPanOffset, _panOffset);
                _equalizePoints(p, startPointsList[0]);
                _equalizePoints(p2, startPointsList[1]);
                _findCenterOfPoints(p, p2, _currCenterPoint);
                _midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
                _midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
                _currPointsDistance = _startPointsDistance = _calculatePointsDistance(p, p2);
            }
        }, // Pointermove/touchmove/mousemove handler
        _onDragMove = function(e) {
            e.preventDefault();
            if (_pointerEventEnabled) {
                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
                if (pointerIndex > -1) {
                    var p = _currPointers[pointerIndex];
                    p.x = e.pageX;
                    p.y = e.pageY;
                }
            }
            if (_isDragging) {
                var touchesList = _getTouchPoints(e);
                if (!_direction && !_moved && !_isZooming) {
                    if (_mainScrollPos.x !== _slideSize.x * _currPositionIndex) // if main scroll position is shifted – direction is always horizontal
                    _direction = 'h';
                    else {
                        var diff = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
                        // check the direction of movement
                        if (Math.abs(diff) >= DIRECTION_CHECK_OFFSET) {
                            _direction = diff > 0 ? 'h' : 'v';
                            _currentPoints = touchesList;
                        }
                    }
                } else _currentPoints = touchesList;
            }
        }, // 
        _renderMovement = function() {
            if (!_currentPoints) return;
            var numPoints = _currentPoints.length;
            if (numPoints === 0) return;
            _equalizePoints(p, _currentPoints[0]);
            delta.x = p.x - _currPoint.x;
            delta.y = p.y - _currPoint.y;
            if (_isZooming && numPoints > 1) {
                // Handle behaviour for more than 1 point
                _currPoint.x = p.x;
                _currPoint.y = p.y;
                // check if one of two points changed
                if (!delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p2)) return;
                _equalizePoints(p2, _currentPoints[1]);
                if (!_zoomStarted) {
                    _zoomStarted = true;
                    _shout('zoomGestureStarted');
                }
                // Distance between two points
                var pointsDistance = _calculatePointsDistance(p, p2);
                var zoomLevel = _calculateZoomLevel(pointsDistance);
                // slightly over the of initial zoom level
                if (zoomLevel > self.currItem.initialZoomLevel + self.currItem.initialZoomLevel / 15) _wasOverInitialZoom = true;
                // Apply the friction if zoom level is out of the bounds
                var zoomFriction = 1, minZoomLevel = _getMinZoomLevel(), maxZoomLevel = _getMaxZoomLevel();
                if (zoomLevel < minZoomLevel) {
                    if (_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self.currItem.initialZoomLevel) {
                        // fade out background if zooming out
                        var minusDiff = minZoomLevel - zoomLevel;
                        var percent = 1 - minusDiff / (minZoomLevel / 1.2);
                        _applyBgOpacity(percent);
                        _shout('onPinchClose', percent);
                        _opacityChanged = true;
                    } else {
                        zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
                        if (zoomFriction > 1) zoomFriction = 1;
                        zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
                    }
                } else if (zoomLevel > maxZoomLevel) {
                    // 1.5 - extra zoom level above the max. E.g. if max is x6, real max 6 + 1.5 = 7.5
                    zoomFriction = (zoomLevel - maxZoomLevel) / (minZoomLevel * 6);
                    if (zoomFriction > 1) zoomFriction = 1;
                    zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
                }
                if (zoomFriction < 0) zoomFriction = 0;
                // distance between touch points after friction is applied
                _currPointsDistance = pointsDistance;
                // _centerPoint - The point in the middle of two pointers
                _findCenterOfPoints(p, p2, _centerPoint);
                // paning with two pointers pressed
                _currPanDist.x += _centerPoint.x - _currCenterPoint.x;
                _currPanDist.y += _centerPoint.y - _currCenterPoint.y;
                _equalizePoints(_currCenterPoint, _centerPoint);
                _panOffset.x = _calculatePanOffset('x', zoomLevel);
                _panOffset.y = _calculatePanOffset('y', zoomLevel);
                _isZoomingIn = zoomLevel > _currZoomLevel;
                _currZoomLevel = zoomLevel;
                _applyCurrentZoomPan();
            } else {
                // handle behaviour for one point (dragging or panning)
                if (!_direction) return;
                if (_isFirstMove) {
                    _isFirstMove = false;
                    // subtract drag distance that was used during the detection direction  
                    if (Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) delta.x -= _currentPoints[0].x - _startPoint.x;
                    if (Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) delta.y -= _currentPoints[0].y - _startPoint.y;
                }
                _currPoint.x = p.x;
                _currPoint.y = p.y;
                // do nothing if pointers position hasn't changed
                if (delta.x === 0 && delta.y === 0) return;
                if (_direction === 'v' && _options.closeOnVerticalDrag) {
                    if (!_canPan()) {
                        _currPanDist.y += delta.y;
                        _panOffset.y += delta.y;
                        var opacityRatio = _calculateVerticalDragOpacityRatio();
                        _verticalDragInitiated = true;
                        _shout('onVerticalDrag', opacityRatio);
                        _applyBgOpacity(opacityRatio);
                        _applyCurrentZoomPan();
                        return;
                    }
                }
                _pushPosPoint(_getCurrentTime(), p.x, p.y);
                _moved = true;
                _currPanBounds = self.currItem.bounds;
                var mainScrollChanged = _panOrMoveMainScroll('x', delta);
                if (!mainScrollChanged) {
                    _panOrMoveMainScroll('y', delta);
                    _roundPoint(_panOffset);
                    _applyCurrentZoomPan();
                }
            }
        }, // Pointerup/pointercancel/touchend/touchcancel/mouseup event handler
        _onDragRelease = function(e) {
            if (_features.isOldAndroid) {
                if (_oldAndroidTouchEndTimeout && e.type === 'mouseup') return;
                // on Android (v4.1, 4.2, 4.3 & possibly older) 
                // ghost mousedown/up event isn't preventable via e.preventDefault,
                // which causes fake mousedown event
                // so we block mousedown/up for 600ms
                if (e.type.indexOf('touch') > -1) {
                    clearTimeout(_oldAndroidTouchEndTimeout);
                    _oldAndroidTouchEndTimeout = setTimeout(function() {
                        _oldAndroidTouchEndTimeout = 0;
                    }, 600);
                }
            }
            _shout('pointerUp');
            if (_preventDefaultEventBehaviour(e, false)) e.preventDefault();
            var releasePoint;
            if (_pointerEventEnabled) {
                var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
                if (pointerIndex > -1) {
                    releasePoint = _currPointers.splice(pointerIndex, 1)[0];
                    if (navigator.msPointerEnabled) {
                        var MSPOINTER_TYPES = {
                            4: 'mouse',
                            2: 'touch',
                            3: 'pen' // event.MSPOINTER_TYPE_PEN
                        };
                        releasePoint.type = MSPOINTER_TYPES[e.pointerType];
                        if (!releasePoint.type) releasePoint.type = e.pointerType || 'mouse';
                    } else releasePoint.type = e.pointerType || 'mouse';
                }
            }
            var touchList = _getTouchPoints(e), gestureType, numPoints = touchList.length;
            if (e.type === 'mouseup') numPoints = 0;
            // Do nothing if there were 3 touch points or more
            if (numPoints === 2) {
                _currentPoints = null;
                return true;
            }
            // if second pointer released
            if (numPoints === 1) _equalizePoints(_startPoint, touchList[0]);
            // pointer hasn't moved, send "tap release" point
            if (numPoints === 0 && !_direction && !_mainScrollAnimating) {
                if (!releasePoint) {
                    if (e.type === 'mouseup') releasePoint = {
                        x: e.pageX,
                        y: e.pageY,
                        type: 'mouse'
                    };
                    else if (e.changedTouches && e.changedTouches[0]) releasePoint = {
                        x: e.changedTouches[0].pageX,
                        y: e.changedTouches[0].pageY,
                        type: 'touch'
                    };
                }
                _shout('touchRelease', e, releasePoint);
            }
            // Difference in time between releasing of two last touch points (zoom gesture)
            var releaseTimeDiff = -1;
            // Gesture completed, no pointers left
            if (numPoints === 0) {
                _isDragging = false;
                framework.unbind(window, _upMoveEvents, self);
                _stopDragUpdateLoop();
                if (_isZooming) // Two points released at the same time
                releaseTimeDiff = 0;
                else if (_lastReleaseTime !== -1) releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
            }
            _lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;
            if (releaseTimeDiff !== -1 && releaseTimeDiff < 150) gestureType = 'zoom';
            else gestureType = 'swipe';
            if (_isZooming && numPoints < 2) {
                _isZooming = false;
                // Only second point released
                if (numPoints === 1) gestureType = 'zoomPointerUp';
                _shout('zoomGestureEnded');
            }
            _currentPoints = null;
            if (!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated) // nothing to animate
            return;
            _stopAllAnimations();
            if (!_releaseAnimData) _releaseAnimData = _initDragReleaseAnimationData();
            _releaseAnimData.calculateSwipeSpeed('x');
            if (_verticalDragInitiated) {
                var opacityRatio = _calculateVerticalDragOpacityRatio();
                if (opacityRatio < _options.verticalDragRange) self.close();
                else {
                    var initalPanY = _panOffset.y, initialBgOpacity = _bgOpacity;
                    _animateProp('verticalDrag', 0, 1, 300, framework.easing.cubic.out, function(now) {
                        _panOffset.y = (self.currItem.initialPosition.y - initalPanY) * now + initalPanY;
                        _applyBgOpacity((1 - initialBgOpacity) * now + initialBgOpacity);
                        _applyCurrentZoomPan();
                    });
                    _shout('onVerticalDrag', 1);
                }
                return;
            }
            // main scroll 
            if ((_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
                var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
                if (itemChanged) return;
                gestureType = 'zoomPointerUp';
            }
            // prevent zoom/pan animation when main scroll animation runs
            if (_mainScrollAnimating) return;
            // Complete simple zoom gesture (reset zoom level if it's out of the bounds)  
            if (gestureType !== 'swipe') {
                _completeZoomGesture();
                return;
            }
            // Complete pan gesture if main scroll is not shifted, and it's possible to pan current image
            if (!_mainScrollShifted && _currZoomLevel > self.currItem.fitRatio) _completePanGesture(_releaseAnimData);
        }, // Returns object with data about gesture
        // It's created only once and then reused
        _initDragReleaseAnimationData = function() {
            // temp local vars
            var lastFlickDuration, tempReleasePos;
            // s = this
            var s = {
                lastFlickOffset: {},
                lastFlickDist: {},
                lastFlickSpeed: {},
                slowDownRatio: {},
                slowDownRatioReverse: {},
                speedDecelerationRatio: {},
                speedDecelerationRatioAbs: {},
                distanceOffset: {},
                backAnimDestination: {},
                backAnimStarted: {},
                calculateSwipeSpeed: function(axis) {
                    if (_posPoints.length > 1) {
                        lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50;
                        tempReleasePos = _posPoints[_posPoints.length - 2][axis];
                    } else {
                        lastFlickDuration = _getCurrentTime() - _gestureStartTime; // total gesture duration
                        tempReleasePos = _startPoint[axis];
                    }
                    s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
                    s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]);
                    if (s.lastFlickDist[axis] > 20) s.lastFlickSpeed[axis] = s.lastFlickOffset[axis] / lastFlickDuration;
                    else s.lastFlickSpeed[axis] = 0;
                    if (Math.abs(s.lastFlickSpeed[axis]) < 0.1) s.lastFlickSpeed[axis] = 0;
                    s.slowDownRatio[axis] = 0.95;
                    s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
                    s.speedDecelerationRatio[axis] = 1;
                },
                calculateOverBoundsAnimOffset: function(axis, speed) {
                    if (!s.backAnimStarted[axis]) {
                        if (_panOffset[axis] > _currPanBounds.min[axis]) s.backAnimDestination[axis] = _currPanBounds.min[axis];
                        else if (_panOffset[axis] < _currPanBounds.max[axis]) s.backAnimDestination[axis] = _currPanBounds.max[axis];
                        if (s.backAnimDestination[axis] !== undefined) {
                            s.slowDownRatio[axis] = 0.7;
                            s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
                            if (s.speedDecelerationRatioAbs[axis] < 0.05) {
                                s.lastFlickSpeed[axis] = 0;
                                s.backAnimStarted[axis] = true;
                                _animateProp('bounceZoomPan' + axis, _panOffset[axis], s.backAnimDestination[axis], speed || 300, framework.easing.sine.out, function(pos) {
                                    _panOffset[axis] = pos;
                                    _applyCurrentZoomPan();
                                });
                            }
                        }
                    }
                },
                // Reduces the speed by slowDownRatio (per 10ms)
                calculateAnimOffset: function(axis) {
                    if (!s.backAnimStarted[axis]) {
                        s.speedDecelerationRatio[axis] = s.speedDecelerationRatio[axis] * (s.slowDownRatio[axis] + s.slowDownRatioReverse[axis] - s.slowDownRatioReverse[axis] * s.timeDiff / 10);
                        s.speedDecelerationRatioAbs[axis] = Math.abs(s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]);
                        s.distanceOffset[axis] = s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis] * s.timeDiff;
                        _panOffset[axis] += s.distanceOffset[axis];
                    }
                },
                panAnimLoop: function() {
                    if (_animations.zoomPan) {
                        _animations.zoomPan.raf = _requestAF(s.panAnimLoop);
                        s.now = _getCurrentTime();
                        s.timeDiff = s.now - s.lastNow;
                        s.lastNow = s.now;
                        s.calculateAnimOffset('x');
                        s.calculateAnimOffset('y');
                        _applyCurrentZoomPan();
                        s.calculateOverBoundsAnimOffset('x');
                        s.calculateOverBoundsAnimOffset('y');
                        if (s.speedDecelerationRatioAbs.x < 0.05 && s.speedDecelerationRatioAbs.y < 0.05) {
                            // round pan position
                            _panOffset.x = Math.round(_panOffset.x);
                            _panOffset.y = Math.round(_panOffset.y);
                            _applyCurrentZoomPan();
                            _stopAnimation('zoomPan');
                            return;
                        }
                    }
                }
            };
            return s;
        }, _completePanGesture = function(animData) {
            // calculate swipe speed for Y axis (paanning)
            animData.calculateSwipeSpeed('y');
            _currPanBounds = self.currItem.bounds;
            animData.backAnimDestination = {};
            animData.backAnimStarted = {};
            // Avoid acceleration animation if speed is too low
            if (Math.abs(animData.lastFlickSpeed.x) <= 0.05 && Math.abs(animData.lastFlickSpeed.y) <= 0.05) {
                animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0;
                // Run pan drag release animation. E.g. if you drag image and release finger without momentum.
                animData.calculateOverBoundsAnimOffset('x');
                animData.calculateOverBoundsAnimOffset('y');
                return true;
            }
            // Animation loop that controls the acceleration after pan gesture ends
            _registerStartAnimation('zoomPan');
            animData.lastNow = _getCurrentTime();
            animData.panAnimLoop();
        }, _finishSwipeMainScrollGesture = function(gestureType, _releaseAnimData) {
            var itemChanged;
            if (!_mainScrollAnimating) _currZoomedItemIndex = _currentItemIndex;
            var itemsDiff;
            if (gestureType === 'swipe') {
                var totalShiftDist = _currPoint.x - _startPoint.x, isFastLastFlick = _releaseAnimData.lastFlickDist.x < 10;
                // if container is shifted for more than MIN_SWIPE_DISTANCE, 
                // and last flick gesture was in right direction
                if (totalShiftDist > MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData.lastFlickOffset.x > 20)) // go to prev item
                itemsDiff = -1;
                else if (totalShiftDist < -MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData.lastFlickOffset.x < -20)) // go to next item
                itemsDiff = 1;
            }
            var nextCircle;
            if (itemsDiff) {
                _currentItemIndex += itemsDiff;
                if (_currentItemIndex < 0) {
                    _currentItemIndex = _options.loop ? _getNumItems() - 1 : 0;
                    nextCircle = true;
                } else if (_currentItemIndex >= _getNumItems()) {
                    _currentItemIndex = _options.loop ? 0 : _getNumItems() - 1;
                    nextCircle = true;
                }
                if (!nextCircle || _options.loop) {
                    _indexDiff += itemsDiff;
                    _currPositionIndex -= itemsDiff;
                    itemChanged = true;
                }
            }
            var animateToX = _slideSize.x * _currPositionIndex;
            var animateToDist = Math.abs(animateToX - _mainScrollPos.x);
            var finishAnimDuration;
            if (!itemChanged && animateToX > _mainScrollPos.x !== _releaseAnimData.lastFlickSpeed.x > 0) // "return to current" duration, e.g. when dragging from slide 0 to -1
            finishAnimDuration = 333;
            else {
                finishAnimDuration = Math.abs(_releaseAnimData.lastFlickSpeed.x) > 0 ? animateToDist / Math.abs(_releaseAnimData.lastFlickSpeed.x) : 333;
                finishAnimDuration = Math.min(finishAnimDuration, 400);
                finishAnimDuration = Math.max(finishAnimDuration, 250);
            }
            if (_currZoomedItemIndex === _currentItemIndex) itemChanged = false;
            _mainScrollAnimating = true;
            _shout('mainScrollAnimStart');
            _animateProp('mainScroll', _mainScrollPos.x, animateToX, finishAnimDuration, framework.easing.cubic.out, _moveMainScroll, function() {
                _stopAllAnimations();
                _mainScrollAnimating = false;
                _currZoomedItemIndex = -1;
                if (itemChanged || _currZoomedItemIndex !== _currentItemIndex) self.updateCurrItem();
                _shout('mainScrollAnimComplete');
            });
            if (itemChanged) self.updateCurrItem(true);
            return itemChanged;
        }, _calculateZoomLevel = function(touchesDistance) {
            return 1 / _startPointsDistance * touchesDistance * _startZoomLevel;
        }, // Resets zoom if it's out of bounds
        _completeZoomGesture = function() {
            var destZoomLevel = _currZoomLevel, minZoomLevel = _getMinZoomLevel(), maxZoomLevel = _getMaxZoomLevel();
            if (_currZoomLevel < minZoomLevel) destZoomLevel = minZoomLevel;
            else if (_currZoomLevel > maxZoomLevel) destZoomLevel = maxZoomLevel;
            var destOpacity = 1, onUpdate, initialOpacity = _bgOpacity;
            if (_opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel) {
                //_closedByScroll = true;
                self.close();
                return true;
            }
            if (_opacityChanged) onUpdate = function(now) {
                _applyBgOpacity((destOpacity - initialOpacity) * now + initialOpacity);
            };
            self.zoomTo(destZoomLevel, 0, 200, framework.easing.cubic.out, onUpdate);
            return true;
        };
        _registerModule('Gestures', {
            publicMethods: {
                initGestures: function() {
                    // helper function that builds touch/pointer/mouse events
                    var addEventNames = function(pref, down, move, up, cancel) {
                        _dragStartEvent = pref + down;
                        _dragMoveEvent = pref + move;
                        _dragEndEvent = pref + up;
                        if (cancel) _dragCancelEvent = pref + cancel;
                        else _dragCancelEvent = '';
                    };
                    _pointerEventEnabled = _features.pointerEvent;
                    if (_pointerEventEnabled && _features.touch) // we don't need touch events, if browser supports pointer events
                    _features.touch = false;
                    if (_pointerEventEnabled) {
                        if (navigator.msPointerEnabled) // IE10 pointer events are case-sensitive
                        addEventNames('MSPointer', 'Down', 'Move', 'Up', 'Cancel');
                        else addEventNames('pointer', 'down', 'move', 'up', 'cancel');
                    } else if (_features.touch) {
                        addEventNames('touch', 'start', 'move', 'end', 'cancel');
                        _likelyTouchDevice = true;
                    } else addEventNames('mouse', 'down', 'move', 'up');
                    _upMoveEvents = _dragMoveEvent + ' ' + _dragEndEvent + ' ' + _dragCancelEvent;
                    _downEvents = _dragStartEvent;
                    if (_pointerEventEnabled && !_likelyTouchDevice) _likelyTouchDevice = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1;
                    // make variable public
                    self.likelyTouchDevice = _likelyTouchDevice;
                    _globalEventHandlers[_dragStartEvent] = _onDragStart;
                    _globalEventHandlers[_dragMoveEvent] = _onDragMove;
                    _globalEventHandlers[_dragEndEvent] = _onDragRelease; // the Kraken
                    if (_dragCancelEvent) _globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent];
                    // Bind mouse events on device with detected hardware touch support, in case it supports multiple types of input.
                    if (_features.touch) {
                        _downEvents += ' mousedown';
                        _upMoveEvents += ' mousemove mouseup';
                        _globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent];
                        _globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent];
                        _globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent];
                    }
                    if (!_likelyTouchDevice) // don't allow pan to next slide from zoomed state on Desktop
                    _options.allowPanToNext = false;
                }
            }
        });
        /*>>gestures*/ /*>>show-hide-transition*/ /**
 * show-hide-transition.js:
 *
 * Manages initial opening or closing transition.
 *
 * If you're not planning to use transition for gallery at all,
 * you may set options hideAnimationDuration and showAnimationDuration to 0,
 * and just delete startAnimation function.
 * 
 */ var _showOrHideTimeout, _showOrHide = function(item, img, out, completeFn) {
            if (_showOrHideTimeout) clearTimeout(_showOrHideTimeout);
            _initialZoomRunning = true;
            _initialContentSet = true;
            // dimensions of small thumbnail {x:,y:,w:}.
            // Height is optional, as calculated based on large image.
            var thumbBounds;
            if (item.initialLayout) {
                thumbBounds = item.initialLayout;
                item.initialLayout = null;
            } else thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
            var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration;
            var onComplete = function() {
                _stopAnimation('initialZoom');
                if (!out) {
                    _applyBgOpacity(1);
                    if (img) img.style.display = 'block';
                    framework.addClass(template, 'pswp--animated-in');
                    _shout('initialZoom' + (out ? 'OutEnd' : 'InEnd'));
                } else {
                    self.template.removeAttribute('style');
                    self.bg.removeAttribute('style');
                }
                if (completeFn) completeFn();
                _initialZoomRunning = false;
            };
            // if bounds aren't provided, just open gallery without animation
            if (!duration || !thumbBounds || thumbBounds.x === undefined) {
                _shout('initialZoom' + (out ? 'Out' : 'In'));
                _currZoomLevel = item.initialZoomLevel;
                _equalizePoints(_panOffset, item.initialPosition);
                _applyCurrentZoomPan();
                template.style.opacity = out ? 0 : 1;
                _applyBgOpacity(1);
                if (duration) setTimeout(function() {
                    onComplete();
                }, duration);
                else onComplete();
                return;
            }
            var startAnimation = function() {
                var closeWithRaf = _closedByScroll, fadeEverything = !self.currItem.src || self.currItem.loadError || _options.showHideOpacity;
                // apply hw-acceleration to image
                if (item.miniImg) item.miniImg.style.webkitBackfaceVisibility = 'hidden';
                if (!out) {
                    _currZoomLevel = thumbBounds.w / item.w;
                    _panOffset.x = thumbBounds.x;
                    _panOffset.y = thumbBounds.y - _initalWindowScrollY;
                    self[fadeEverything ? 'template' : 'bg'].style.opacity = 0.001;
                    _applyCurrentZoomPan();
                }
                _registerStartAnimation('initialZoom');
                if (out && !closeWithRaf) framework.removeClass(template, 'pswp--animated-in');
                if (fadeEverything) {
                    if (out) framework[(closeWithRaf ? 'remove' : 'add') + 'Class'](template, 'pswp--animate_opacity');
                    else setTimeout(function() {
                        framework.addClass(template, 'pswp--animate_opacity');
                    }, 30);
                }
                _showOrHideTimeout = setTimeout(function() {
                    _shout('initialZoom' + (out ? 'Out' : 'In'));
                    if (!out) {
                        // "in" animation always uses CSS transitions (instead of rAF).
                        // CSS transition work faster here, 
                        // as developer may also want to animate other things, 
                        // like ui on top of sliding area, which can be animated just via CSS
                        _currZoomLevel = item.initialZoomLevel;
                        _equalizePoints(_panOffset, item.initialPosition);
                        _applyCurrentZoomPan();
                        _applyBgOpacity(1);
                        if (fadeEverything) template.style.opacity = 1;
                        else _applyBgOpacity(1);
                        _showOrHideTimeout = setTimeout(onComplete, duration + 20);
                    } else {
                        // "out" animation uses rAF only when PhotoSwipe is closed by browser scroll, to recalculate position
                        var destZoomLevel = thumbBounds.w / item.w, initialPanOffset = {
                            x: _panOffset.x,
                            y: _panOffset.y
                        }, initialZoomLevel = _currZoomLevel, initalBgOpacity = _bgOpacity, onUpdate = function(now) {
                            if (now === 1) {
                                _currZoomLevel = destZoomLevel;
                                _panOffset.x = thumbBounds.x;
                                _panOffset.y = thumbBounds.y - _currentWindowScrollY;
                            } else {
                                _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
                                _panOffset.x = (thumbBounds.x - initialPanOffset.x) * now + initialPanOffset.x;
                                _panOffset.y = (thumbBounds.y - _currentWindowScrollY - initialPanOffset.y) * now + initialPanOffset.y;
                            }
                            _applyCurrentZoomPan();
                            if (fadeEverything) template.style.opacity = 1 - now;
                            else _applyBgOpacity(initalBgOpacity - now * initalBgOpacity);
                        };
                        if (closeWithRaf) _animateProp('initialZoom', 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete);
                        else {
                            onUpdate(1);
                            _showOrHideTimeout = setTimeout(onComplete, duration + 20);
                        }
                    }
                }, out ? 25 : 90); // Main purpose of this delay is to give browser time to paint and
            // create composite layers of PhotoSwipe UI parts (background, controls, caption, arrows).
            // Which avoids lag at the beginning of scale transition.
            };
            startAnimation();
        };
        /*>>show-hide-transition*/ /*>>items-controller*/ /**
*
* Controller manages gallery items, their dimensions, and their content.
* 
*/ var _items, _tempPanAreaSize = {}, _imagesToAppendPool = [], _initialContentSet, _initialZoomRunning, _controllerDefaultOptions = {
            index: 0,
            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
            forceProgressiveLoading: false,
            preload: [
                1,
                1
            ],
            getNumItemsFn: function() {
                return _items.length;
            }
        };
        var _getItemAt, _getNumItems, _initialIsLoop, _getZeroBounds = function() {
            return {
                center: {
                    x: 0,
                    y: 0
                },
                max: {
                    x: 0,
                    y: 0
                },
                min: {
                    x: 0,
                    y: 0
                }
            };
        }, _calculateSingleItemPanBounds = function(item, realPanElementW, realPanElementH) {
            var bounds = item.bounds;
            // position of element when it's centered
            bounds.center.x = Math.round((_tempPanAreaSize.x - realPanElementW) / 2);
            bounds.center.y = Math.round((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top;
            // maximum pan position
            bounds.max.x = realPanElementW > _tempPanAreaSize.x ? Math.round(_tempPanAreaSize.x - realPanElementW) : bounds.center.x;
            bounds.max.y = realPanElementH > _tempPanAreaSize.y ? Math.round(_tempPanAreaSize.y - realPanElementH) + item.vGap.top : bounds.center.y;
            // minimum pan position
            bounds.min.x = realPanElementW > _tempPanAreaSize.x ? 0 : bounds.center.x;
            bounds.min.y = realPanElementH > _tempPanAreaSize.y ? item.vGap.top : bounds.center.y;
        }, _calculateItemSize = function(item, viewportSize, zoomLevel) {
            if (item.src && !item.loadError) {
                var isInitial = !zoomLevel;
                if (isInitial) {
                    if (!item.vGap) item.vGap = {
                        top: 0,
                        bottom: 0
                    };
                    // allows overriding vertical margin for individual items
                    _shout('parseVerticalMargin', item);
                }
                _tempPanAreaSize.x = viewportSize.x;
                _tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom;
                if (isInitial) {
                    var hRatio = _tempPanAreaSize.x / item.w;
                    var vRatio = _tempPanAreaSize.y / item.h;
                    item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
                    //item.fillRatio = hRatio > vRatio ? hRatio : vRatio;
                    var scaleMode = _options.scaleMode;
                    if (scaleMode === 'orig') zoomLevel = 1;
                    else if (scaleMode === 'fit') zoomLevel = item.fitRatio;
                    if (zoomLevel > 1) zoomLevel = 1;
                    item.initialZoomLevel = zoomLevel;
                    if (!item.bounds) // reuse bounds object
                    item.bounds = _getZeroBounds();
                }
                if (!zoomLevel) return;
                _calculateSingleItemPanBounds(item, item.w * zoomLevel, item.h * zoomLevel);
                if (isInitial && zoomLevel === item.initialZoomLevel) item.initialPosition = item.bounds.center;
                return item.bounds;
            } else {
                item.w = item.h = 0;
                item.initialZoomLevel = item.fitRatio = 1;
                item.bounds = _getZeroBounds();
                item.initialPosition = item.bounds.center;
                // if it's not image, we return zero bounds (content is not zoomable)
                return item.bounds;
            }
        }, _appendImage = function(index, item, baseDiv, img, preventAnimation, keepPlaceholder) {
            if (item.loadError) return;
            if (img) {
                item.imageAppended = true;
                _setImageSize(item, img, item === self.currItem && _renderMaxResolution);
                baseDiv.appendChild(img);
                if (keepPlaceholder) setTimeout(function() {
                    if (item && item.loaded && item.placeholder) {
                        item.placeholder.style.display = 'none';
                        item.placeholder = null;
                    }
                }, 500);
            }
        }, _preloadImage = function(item) {
            item.loading = true;
            item.loaded = false;
            var img = item.img = framework.createEl('pswp__img', 'img');
            var onComplete = function() {
                item.loading = false;
                item.loaded = true;
                if (item.loadComplete) item.loadComplete(item);
                else item.img = null; // no need to store image object
                img.onload = img.onerror = null;
                img = null;
            };
            img.onload = onComplete;
            img.onerror = function() {
                item.loadError = true;
                onComplete();
            };
            img.src = item.src; // + '?a=' + Math.random();
            return img;
        }, _checkForError = function(item, cleanUp) {
            if (item.src && item.loadError && item.container) {
                if (cleanUp) item.container.innerHTML = '';
                item.container.innerHTML = _options.errorMsg.replace('%url%', item.src);
                return true;
            }
        }, _setImageSize = function(item, img, maxRes) {
            if (!item.src) return;
            if (!img) img = item.container.lastChild;
            var w = maxRes ? item.w : Math.round(item.w * item.fitRatio), h = maxRes ? item.h : Math.round(item.h * item.fitRatio);
            if (item.placeholder && !item.loaded) {
                item.placeholder.style.width = w + 'px';
                item.placeholder.style.height = h + 'px';
            }
            img.style.width = w + 'px';
            img.style.height = h + 'px';
        }, _appendImagesPool = function() {
            if (_imagesToAppendPool.length) {
                var poolItem;
                for(var i = 0; i < _imagesToAppendPool.length; i++){
                    poolItem = _imagesToAppendPool[i];
                    if (poolItem.holder.index === poolItem.index) _appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, false, poolItem.clearPlaceholder);
                }
                _imagesToAppendPool = [];
            }
        };
        _registerModule('Controller', {
            publicMethods: {
                lazyLoadItem: function(index) {
                    index = _getLoopedId(index);
                    var item = _getItemAt(index);
                    if (!item || (item.loaded || item.loading) && !_itemsNeedUpdate) return;
                    _shout('gettingData', index, item);
                    if (!item.src) return;
                    _preloadImage(item);
                },
                initController: function() {
                    framework.extend(_options, _controllerDefaultOptions, true);
                    self.items = _items = items;
                    _getItemAt = self.getItemAt;
                    _getNumItems = _options.getNumItemsFn; //self.getNumItems;
                    _initialIsLoop = _options.loop;
                    if (_getNumItems() < 3) _options.loop = false; // disable loop if less then 3 items
                    _listen('beforeChange', function(diff) {
                        var p = _options.preload, isNext = diff === null ? true : diff >= 0, preloadBefore = Math.min(p[0], _getNumItems()), preloadAfter = Math.min(p[1], _getNumItems()), i;
                        for(i = 1; i <= (isNext ? preloadAfter : preloadBefore); i++)self.lazyLoadItem(_currentItemIndex + i);
                        for(i = 1; i <= (isNext ? preloadBefore : preloadAfter); i++)self.lazyLoadItem(_currentItemIndex - i);
                    });
                    _listen('initialLayout', function() {
                        self.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
                    });
                    _listen('mainScrollAnimComplete', _appendImagesPool);
                    _listen('initialZoomInEnd', _appendImagesPool);
                    _listen('destroy', function() {
                        var item;
                        for(var i = 0; i < _items.length; i++){
                            item = _items[i];
                            // remove reference to DOM elements, for GC
                            if (item.container) item.container = null;
                            if (item.placeholder) item.placeholder = null;
                            if (item.img) item.img = null;
                            if (item.preloader) item.preloader = null;
                            if (item.loadError) item.loaded = item.loadError = false;
                        }
                        _imagesToAppendPool = null;
                    });
                },
                getItemAt: function(index) {
                    if (index >= 0) return _items[index] !== undefined ? _items[index] : false;
                    return false;
                },
                allowProgressiveImg: function() {
                    // 1. Progressive image loading isn't working on webkit/blink 
                    //    when hw-acceleration (e.g. translateZ) is applied to IMG element.
                    //    That's why in PhotoSwipe parent element gets zoom transform, not image itself.
                    //    
                    // 2. Progressive image loading sometimes blinks in webkit/blink when applying animation to parent element.
                    //    That's why it's disabled on touch devices (mainly because of swipe transition)
                    //    
                    // 3. Progressive image loading sometimes doesn't work in IE (up to 11).
                    // Don't allow progressive loading on non-large touch devices
                    return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200;
                // 1200 - to eliminate touch devices with large screen (like Chromebook Pixel)
                },
                setContent: function(holder, index) {
                    if (_options.loop) index = _getLoopedId(index);
                    var prevItem = self.getItemAt(holder.index);
                    if (prevItem) prevItem.container = null;
                    var item = self.getItemAt(index), img;
                    if (!item) {
                        holder.el.innerHTML = '';
                        return;
                    }
                    // allow to override data
                    _shout('gettingData', index, item);
                    holder.index = index;
                    holder.item = item;
                    // base container DIV is created only once for each of 3 holders
                    var baseDiv = item.container = framework.createEl('pswp__zoom-wrap');
                    if (!item.src && item.html) {
                        if (item.html.tagName) baseDiv.appendChild(item.html);
                        else baseDiv.innerHTML = item.html;
                    }
                    _checkForError(item);
                    _calculateItemSize(item, _viewportSize);
                    if (item.src && !item.loadError && !item.loaded) {
                        item.loadComplete = function(item) {
                            // gallery closed before image finished loading
                            if (!_isOpen) return;
                            // check if holder hasn't changed while image was loading
                            if (holder && holder.index === index) {
                                if (_checkForError(item, true)) {
                                    item.loadComplete = item.img = null;
                                    _calculateItemSize(item, _viewportSize);
                                    _applyZoomPanToItem(item);
                                    if (holder.index === _currentItemIndex) // recalculate dimensions
                                    self.updateCurrZoomItem();
                                    return;
                                }
                                if (!item.imageAppended) {
                                    if (_features.transform && (_mainScrollAnimating || _initialZoomRunning)) _imagesToAppendPool.push({
                                        item: item,
                                        baseDiv: baseDiv,
                                        img: item.img,
                                        index: index,
                                        holder: holder,
                                        clearPlaceholder: true
                                    });
                                    else _appendImage(index, item, baseDiv, item.img, _mainScrollAnimating || _initialZoomRunning, true);
                                } else // remove preloader & mini-img
                                if (!_initialZoomRunning && item.placeholder) {
                                    item.placeholder.style.display = 'none';
                                    item.placeholder = null;
                                }
                            }
                            item.loadComplete = null;
                            item.img = null; // no need to store image element after it's added
                            _shout('imageLoadComplete', index, item);
                        };
                        if (framework.features.transform) {
                            var placeholderClassName = 'pswp__img pswp__img--placeholder';
                            placeholderClassName += item.msrc ? '' : ' pswp__img--placeholder--blank';
                            var placeholder = framework.createEl(placeholderClassName, item.msrc ? 'img' : '');
                            if (item.msrc) placeholder.src = item.msrc;
                            _setImageSize(item, placeholder);
                            baseDiv.appendChild(placeholder);
                            item.placeholder = placeholder;
                        }
                        if (!item.loading) _preloadImage(item);
                        if (self.allowProgressiveImg()) {
                            // just append image
                            if (!_initialContentSet && _features.transform) _imagesToAppendPool.push({
                                item: item,
                                baseDiv: baseDiv,
                                img: item.img,
                                index: index,
                                holder: holder
                            });
                            else _appendImage(index, item, baseDiv, item.img, true, true);
                        }
                    } else if (item.src && !item.loadError) {
                        // image object is created every time, due to bugs of image loading & delay when switching images
                        img = framework.createEl('pswp__img', 'img');
                        img.style.opacity = 1;
                        img.src = item.src;
                        _setImageSize(item, img);
                        _appendImage(index, item, baseDiv, img, true);
                    }
                    if (!_initialContentSet && index === _currentItemIndex) {
                        _currZoomElementStyle = baseDiv.style;
                        _showOrHide(item, img || item.img);
                    } else _applyZoomPanToItem(item);
                    holder.el.innerHTML = '';
                    holder.el.appendChild(baseDiv);
                },
                cleanSlide: function(item) {
                    if (item.img) item.img.onload = item.img.onerror = null;
                    item.loaded = item.loading = item.img = item.imageAppended = false;
                }
            }
        });
        /*>>items-controller*/ /*>>tap*/ /**
 * tap.js:
 *
 * Displatches tap and double-tap events.
 * 
 */ var tapTimer, tapReleasePoint = {}, _dispatchTapEvent = function(origEvent, releasePoint, pointerType) {
            var e = document.createEvent('CustomEvent'), eDetail = {
                origEvent: origEvent,
                target: origEvent.target,
                releasePoint: releasePoint,
                pointerType: pointerType || 'touch'
            };
            e.initCustomEvent('pswpTap', true, true, eDetail);
            origEvent.target.dispatchEvent(e);
        };
        _registerModule('Tap', {
            publicMethods: {
                initTap: function() {
                    _listen('firstTouchStart', self.onTapStart);
                    _listen('touchRelease', self.onTapRelease);
                    _listen('destroy', function() {
                        tapReleasePoint = {};
                        tapTimer = null;
                    });
                },
                onTapStart: function(touchList) {
                    if (touchList.length > 1) {
                        clearTimeout(tapTimer);
                        tapTimer = null;
                    }
                },
                onTapRelease: function(e, releasePoint) {
                    if (!releasePoint) return;
                    if (!_moved && !_isMultitouch && !_numAnimations) {
                        var p0 = releasePoint;
                        if (tapTimer) {
                            clearTimeout(tapTimer);
                            tapTimer = null;
                            // Check if taped on the same place
                            if (_isNearbyPoints(p0, tapReleasePoint)) {
                                _shout('doubleTap', p0);
                                return;
                            }
                        }
                        if (releasePoint.type === 'mouse') {
                            _dispatchTapEvent(e, releasePoint, 'mouse');
                            return;
                        }
                        var clickedTagName = e.target.tagName.toUpperCase();
                        // avoid double tap delay on buttons and elements that have class pswp__single-tap
                        if (clickedTagName === 'BUTTON' || framework.hasClass(e.target, 'pswp__single-tap')) {
                            _dispatchTapEvent(e, releasePoint);
                            return;
                        }
                        _equalizePoints(tapReleasePoint, p0);
                        tapTimer = setTimeout(function() {
                            _dispatchTapEvent(e, releasePoint);
                            tapTimer = null;
                        }, 300);
                    }
                }
            }
        });
        /*>>tap*/ /*>>desktop-zoom*/ /**
 *
 * desktop-zoom.js:
 *
 * - Binds mousewheel event for paning zoomed image.
 * - Manages "dragging", "zoomed-in", "zoom-out" classes.
 *   (which are used for cursors and zoom icon)
 * - Adds toggleDesktopZoom function.
 * 
 */ var _wheelDelta;
        _registerModule('DesktopZoom', {
            publicMethods: {
                initDesktopZoom: function() {
                    if (_oldIE) // no zoom for old IE (<=8)
                    return;
                    if (_likelyTouchDevice) // if detected hardware touch support, we wait until mouse is used,
                    // and only then apply desktop-zoom features
                    _listen('mouseUsed', function() {
                        self.setupDesktopZoom();
                    });
                    else self.setupDesktopZoom(true);
                },
                setupDesktopZoom: function(onInit) {
                    _wheelDelta = {};
                    var events = 'wheel mousewheel DOMMouseScroll';
                    _listen('bindEvents', function() {
                        framework.bind(template, events, self.handleMouseWheel);
                    });
                    _listen('unbindEvents', function() {
                        if (_wheelDelta) framework.unbind(template, events, self.handleMouseWheel);
                    });
                    self.mouseZoomedIn = false;
                    var hasDraggingClass, updateZoomable = function() {
                        if (self.mouseZoomedIn) {
                            framework.removeClass(template, 'pswp--zoomed-in');
                            self.mouseZoomedIn = false;
                        }
                        if (_currZoomLevel < 1) framework.addClass(template, 'pswp--zoom-allowed');
                        else framework.removeClass(template, 'pswp--zoom-allowed');
                        removeDraggingClass();
                    }, removeDraggingClass = function() {
                        if (hasDraggingClass) {
                            framework.removeClass(template, 'pswp--dragging');
                            hasDraggingClass = false;
                        }
                    };
                    _listen('resize', updateZoomable);
                    _listen('afterChange', updateZoomable);
                    _listen('pointerDown', function() {
                        if (self.mouseZoomedIn) {
                            hasDraggingClass = true;
                            framework.addClass(template, 'pswp--dragging');
                        }
                    });
                    _listen('pointerUp', removeDraggingClass);
                    if (!onInit) updateZoomable();
                },
                handleMouseWheel: function(e) {
                    if (_currZoomLevel <= self.currItem.fitRatio) {
                        if (_options.modal) {
                            if (!_options.closeOnScroll || _numAnimations || _isDragging) e.preventDefault();
                            else if (_transformKey && Math.abs(e.deltaY) > 2) {
                                // close PhotoSwipe
                                // if browser supports transforms & scroll changed enough
                                _closedByScroll = true;
                                self.close();
                            }
                        }
                        return true;
                    }
                    // allow just one event to fire
                    e.stopPropagation();
                    // https://developer.mozilla.org/en-US/docs/Web/Events/wheel
                    _wheelDelta.x = 0;
                    if ('deltaX' in e) {
                        if (e.deltaMode === 1 /* DOM_DELTA_LINE */ ) {
                            // 18 - average line height
                            _wheelDelta.x = e.deltaX * 18;
                            _wheelDelta.y = e.deltaY * 18;
                        } else {
                            _wheelDelta.x = e.deltaX;
                            _wheelDelta.y = e.deltaY;
                        }
                    } else if ('wheelDelta' in e) {
                        if (e.wheelDeltaX) _wheelDelta.x = -0.16 * e.wheelDeltaX;
                        if (e.wheelDeltaY) _wheelDelta.y = -0.16 * e.wheelDeltaY;
                        else _wheelDelta.y = -0.16 * e.wheelDelta;
                    } else if ('detail' in e) _wheelDelta.y = e.detail;
                    else return;
                    _calculatePanBounds(_currZoomLevel, true);
                    var newPanX = _panOffset.x - _wheelDelta.x, newPanY = _panOffset.y - _wheelDelta.y;
                    // only prevent scrolling in nonmodal mode when not at edges
                    if (_options.modal || newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x && newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y) e.preventDefault();
                    // TODO: use rAF instead of mousewheel?
                    self.panTo(newPanX, newPanY);
                },
                toggleDesktopZoom: function(centerPoint) {
                    centerPoint = centerPoint || {
                        x: _viewportSize.x / 2 + _offset.x,
                        y: _viewportSize.y / 2 + _offset.y
                    };
                    var doubleTapZoomLevel = _options.getDoubleTapZoom(true, self.currItem);
                    var zoomOut = _currZoomLevel === doubleTapZoomLevel;
                    self.mouseZoomedIn = !zoomOut;
                    self.zoomTo(zoomOut ? self.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333);
                    framework[(!zoomOut ? 'add' : 'remove') + 'Class'](template, 'pswp--zoomed-in');
                }
            }
        });
        /*>>desktop-zoom*/ /*>>history*/ /**
 *
 * history.js:
 *
 * - Back button to close gallery.
 * 
 * - Unique URL for each slide: example.com/&pid=1&gid=3
 *   (where PID is picture index, and GID and gallery index)
 *   
 * - Switch URL when slides change.
 * 
 */ var _historyDefaultOptions = {
            history: true,
            galleryUID: 1
        };
        var _historyUpdateTimeout, _hashChangeTimeout, _hashAnimCheckTimeout, _hashChangedByScript, _hashChangedByHistory, _hashReseted, _initialHash, _historyChanged, _closedFromURL, _urlChangedOnce, _windowLoc, _supportsPushState, _getHash = function() {
            return _windowLoc.hash.substring(1);
        }, _cleanHistoryTimeouts = function() {
            if (_historyUpdateTimeout) clearTimeout(_historyUpdateTimeout);
            if (_hashAnimCheckTimeout) clearTimeout(_hashAnimCheckTimeout);
        }, // pid - Picture index
        // gid - Gallery index
        _parseItemIndexFromURL = function() {
            var hash = _getHash(), params = {};
            if (hash.length < 5) return params;
            var i, vars = hash.split('&');
            for(i = 0; i < vars.length; i++){
                if (!vars[i]) continue;
                var pair = vars[i].split('=');
                if (pair.length < 2) continue;
                params[pair[0]] = pair[1];
            }
            if (_options.galleryPIDs) {
                // detect custom pid in hash and search for it among the items collection
                var searchfor = params.pid;
                params.pid = 0; // if custom pid cannot be found, fallback to the first item
                for(i = 0; i < _items.length; i++)if (_items[i].pid === searchfor) {
                    params.pid = i;
                    break;
                }
            } else params.pid = parseInt(params.pid, 10) - 1;
            if (params.pid < 0) params.pid = 0;
            return params;
        }, _updateHash = function() {
            if (_hashAnimCheckTimeout) clearTimeout(_hashAnimCheckTimeout);
            if (_numAnimations || _isDragging) {
                // changing browser URL forces layout/paint in some browsers, which causes noticable lag during animation
                // that's why we update hash only when no animations running
                _hashAnimCheckTimeout = setTimeout(_updateHash, 500);
                return;
            }
            if (_hashChangedByScript) clearTimeout(_hashChangeTimeout);
            else _hashChangedByScript = true;
            var pid = _currentItemIndex + 1;
            var item = _getItemAt(_currentItemIndex);
            if (item.hasOwnProperty('pid')) // carry forward any custom pid assigned to the item
            pid = item.pid;
            var newHash = _initialHash + '&' + 'gid=' + _options.galleryUID + '&' + 'pid=' + pid;
            if (!_historyChanged) {
                if (_windowLoc.hash.indexOf(newHash) === -1) _urlChangedOnce = true;
            }
            var newURL = _windowLoc.href.split('#')[0] + '#' + newHash;
            if (_supportsPushState) {
                if ('#' + newHash !== window.location.hash) history[_historyChanged ? 'replaceState' : 'pushState']('', document.title, newURL);
            } else if (_historyChanged) _windowLoc.replace(newURL);
            else _windowLoc.hash = newHash;
            _historyChanged = true;
            _hashChangeTimeout = setTimeout(function() {
                _hashChangedByScript = false;
            }, 60);
        };
        _registerModule('History', {
            publicMethods: {
                initHistory: function() {
                    framework.extend(_options, _historyDefaultOptions, true);
                    if (!_options.history) return;
                    _windowLoc = window.location;
                    _urlChangedOnce = false;
                    _closedFromURL = false;
                    _historyChanged = false;
                    _initialHash = _getHash();
                    _supportsPushState = 'pushState' in history;
                    if (_initialHash.indexOf('gid=') > -1) {
                        _initialHash = _initialHash.split('&gid=')[0];
                        _initialHash = _initialHash.split('?gid=')[0];
                    }
                    _listen('afterChange', self.updateURL);
                    _listen('unbindEvents', function() {
                        framework.unbind(window, 'hashchange', self.onHashChange);
                    });
                    var returnToOriginal = function() {
                        _hashReseted = true;
                        if (!_closedFromURL) {
                            if (_urlChangedOnce) history.back();
                            else {
                                if (_initialHash) _windowLoc.hash = _initialHash;
                                else if (_supportsPushState) // remove hash from url without refreshing it or scrolling to top
                                history.pushState('', document.title, _windowLoc.pathname + _windowLoc.search);
                                else _windowLoc.hash = '';
                            }
                        }
                        _cleanHistoryTimeouts();
                    };
                    _listen('unbindEvents', function() {
                        if (_closedByScroll) // if PhotoSwipe is closed by scroll, we go "back" before the closing animation starts
                        // this is done to keep the scroll position
                        returnToOriginal();
                    });
                    _listen('destroy', function() {
                        if (!_hashReseted) returnToOriginal();
                    });
                    _listen('firstUpdate', function() {
                        _currentItemIndex = _parseItemIndexFromURL().pid;
                    });
                    var index = _initialHash.indexOf('pid=');
                    if (index > -1) {
                        _initialHash = _initialHash.substring(0, index);
                        if (_initialHash.slice(-1) === '&') _initialHash = _initialHash.slice(0, -1);
                    }
                    setTimeout(function() {
                        if (_isOpen) framework.bind(window, 'hashchange', self.onHashChange);
                    }, 40);
                },
                onHashChange: function() {
                    if (_getHash() === _initialHash) {
                        _closedFromURL = true;
                        self.close();
                        return;
                    }
                    if (!_hashChangedByScript) {
                        _hashChangedByHistory = true;
                        self.goTo(_parseItemIndexFromURL().pid);
                        _hashChangedByHistory = false;
                    }
                },
                updateURL: function() {
                    // Delay the update of URL, to avoid lag during transition, 
                    // and to not to trigger actions like "refresh page sound" or "blinking favicon" to often
                    _cleanHistoryTimeouts();
                    if (_hashChangedByHistory) return;
                    if (!_historyChanged) _updateHash(); // first time
                    else _historyUpdateTimeout = setTimeout(_updateHash, 800);
                }
            }
        });
        /*>>history*/ framework.extend(self, publicMethods);
    };
    return PhotoSwipe;
});


var $79de6f6f8dcbb90f$exports = {};
/*! PhotoSwipe Default UI - 4.1.3 - 2019-01-08
* http://photoswipe.com
* Copyright (c) 2019 Dmitry Semenov; */ !function(a, b) {
    "function" == typeof define && define.amd ? define(b) : $79de6f6f8dcbb90f$exports = b();
}($79de6f6f8dcbb90f$exports, function() {
    "use strict";
    var a = function(a, b) {
        var c, d, e, f, g, h, i, j, k, l, m, n, o, p, q, r, s, t, u, v = this, w = !1, x = !0, y = !0, z = {
            barsSize: {
                top: 44,
                bottom: "auto"
            },
            closeElClasses: [
                "item",
                "caption",
                "zoom-wrap",
                "ui",
                "top-bar"
            ],
            timeToIdle: 4e3,
            timeToIdleOutside: 1e3,
            loadingIndicatorDelay: 1e3,
            addCaptionHTMLFn: function(a, b) {
                return a.title ? (b.children[0].innerHTML = a.title, !0) : (b.children[0].innerHTML = "", !1);
            },
            closeEl: !0,
            captionEl: !0,
            fullscreenEl: !0,
            zoomEl: !0,
            shareEl: !0,
            counterEl: !0,
            arrowEl: !0,
            preloaderEl: !0,
            tapToClose: !1,
            tapToToggleControls: !0,
            clickToCloseNonZoomable: !0,
            shareButtons: [
                {
                    id: "facebook",
                    label: "Share on Facebook",
                    url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
                },
                {
                    id: "twitter",
                    label: "Tweet",
                    url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
                },
                {
                    id: "pinterest",
                    label: "Pin it",
                    url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
                },
                {
                    id: "download",
                    label: "Download image",
                    url: "{{raw_image_url}}",
                    download: !0
                }
            ],
            getImageURLForShare: function() {
                return a.currItem.src || "";
            },
            getPageURLForShare: function() {
                return window.location.href;
            },
            getTextForShare: function() {
                return a.currItem.title || "";
            },
            indexIndicatorSep: " / ",
            fitControlsWidth: 1200
        }, A = function(a) {
            if (r) return !0;
            a = a || window.event, q.timeToIdle && q.mouseUsed && !k && K();
            for(var c, d, e = a.target || a.srcElement, f = e.getAttribute("class") || "", g = 0; g < S.length; g++)c = S[g], c.onTap && f.indexOf("pswp__" + c.name) > -1 && (c.onTap(), d = !0);
            if (d) {
                a.stopPropagation && a.stopPropagation(), r = !0;
                var h = b.features.isOldAndroid ? 600 : 30;
                s = setTimeout(function() {
                    r = !1;
                }, h);
            }
        }, B = function() {
            return !a.likelyTouchDevice || q.mouseUsed || screen.width > q.fitControlsWidth;
        }, C = function(a, c, d) {
            b[(d ? "add" : "remove") + "Class"](a, "pswp__" + c);
        }, D = function() {
            var a = 1 === q.getNumItemsFn();
            a !== p && (C(d, "ui--one-slide", a), p = a);
        }, E = function() {
            C(i, "share-modal--hidden", y);
        }, F = function() {
            return y = !y, y ? (b.removeClass(i, "pswp__share-modal--fade-in"), setTimeout(function() {
                y && E();
            }, 300)) : (E(), setTimeout(function() {
                y || b.addClass(i, "pswp__share-modal--fade-in");
            }, 30)), y || H(), !1;
        }, G = function(b) {
            b = b || window.event;
            var c = b.target || b.srcElement;
            return a.shout("shareLinkClick", b, c), !!c.href && (!!c.hasAttribute("download") || (window.open(c.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)), y || F(), !1));
        }, H = function() {
            for(var a, b, c, d, e, f = "", g = 0; g < q.shareButtons.length; g++)a = q.shareButtons[g], c = q.getImageURLForShare(a), d = q.getPageURLForShare(a), e = q.getTextForShare(a), b = a.url.replace("{{url}}", encodeURIComponent(d)).replace("{{image_url}}", encodeURIComponent(c)).replace("{{raw_image_url}}", c).replace("{{text}}", encodeURIComponent(e)), f += '<a href="' + b + '" target="_blank" class="pswp__share--' + a.id + '"' + (a.download ? "download" : "") + ">" + a.label + "</a>", q.parseShareButtonOut && (f = q.parseShareButtonOut(a, f));
            i.children[0].innerHTML = f, i.children[0].onclick = G;
        }, I = function(a) {
            for(var c = 0; c < q.closeElClasses.length; c++)if (b.hasClass(a, "pswp__" + q.closeElClasses[c])) return !0;
        }, J = 0, K = function() {
            clearTimeout(u), J = 0, k && v.setIdle(!1);
        }, L = function(a) {
            a = a ? a : window.event;
            var b = a.relatedTarget || a.toElement;
            b && "HTML" !== b.nodeName || (clearTimeout(u), u = setTimeout(function() {
                v.setIdle(!0);
            }, q.timeToIdleOutside));
        }, M = function() {
            q.fullscreenEl && !b.features.isOldAndroid && (c || (c = v.getFullscreenAPI()), c ? (b.bind(document, c.eventK, v.updateFullscreen), v.updateFullscreen(), b.addClass(a.template, "pswp--supports-fs")) : b.removeClass(a.template, "pswp--supports-fs"));
        }, N = function() {
            q.preloaderEl && (O(!0), l("beforeChange", function() {
                clearTimeout(o), o = setTimeout(function() {
                    a.currItem && a.currItem.loading ? (!a.allowProgressiveImg() || a.currItem.img && !a.currItem.img.naturalWidth) && O(!1) : O(!0);
                }, q.loadingIndicatorDelay);
            }), l("imageLoadComplete", function(b, c) {
                a.currItem === c && O(!0);
            }));
        }, O = function(a) {
            n !== a && (C(m, "preloader--active", !a), n = a);
        }, P = function(a) {
            var c = a.vGap;
            if (B()) {
                var g = q.barsSize;
                if (q.captionEl && "auto" === g.bottom) {
                    if (f || (f = b.createEl("pswp__caption pswp__caption--fake"), f.appendChild(b.createEl("pswp__caption__center")), d.insertBefore(f, e), b.addClass(d, "pswp__ui--fit")), q.addCaptionHTMLFn(a, f, !0)) {
                        var h = f.clientHeight;
                        c.bottom = parseInt(h, 10) || 44;
                    } else c.bottom = g.top;
                } else c.bottom = "auto" === g.bottom ? 0 : g.bottom;
                c.top = g.top;
            } else c.top = c.bottom = 0;
        }, Q = function() {
            q.timeToIdle && l("mouseUsed", function() {
                b.bind(document, "mousemove", K), b.bind(document, "mouseout", L), t = setInterval(function() {
                    J++, 2 === J && v.setIdle(!0);
                }, q.timeToIdle / 2);
            });
        }, R = function() {
            l("onVerticalDrag", function(a) {
                x && a < .95 ? v.hideControls() : !x && a >= .95 && v.showControls();
            });
            var a;
            l("onPinchClose", function(b) {
                x && b < .9 ? (v.hideControls(), a = !0) : a && !x && b > .9 && v.showControls();
            }), l("zoomGestureEnded", function() {
                a = !1, a && !x && v.showControls();
            });
        }, S = [
            {
                name: "caption",
                option: "captionEl",
                onInit: function(a) {
                    e = a;
                }
            },
            {
                name: "share-modal",
                option: "shareEl",
                onInit: function(a) {
                    i = a;
                },
                onTap: function() {
                    F();
                }
            },
            {
                name: "button--share",
                option: "shareEl",
                onInit: function(a) {
                    h = a;
                },
                onTap: function() {
                    F();
                }
            },
            {
                name: "button--zoom",
                option: "zoomEl",
                onTap: a.toggleDesktopZoom
            },
            {
                name: "counter",
                option: "counterEl",
                onInit: function(a) {
                    g = a;
                }
            },
            {
                name: "button--close",
                option: "closeEl",
                onTap: a.close
            },
            {
                name: "button--arrow--left",
                option: "arrowEl",
                onTap: a.prev
            },
            {
                name: "button--arrow--right",
                option: "arrowEl",
                onTap: a.next
            },
            {
                name: "button--fs",
                option: "fullscreenEl",
                onTap: function() {
                    c.isFullscreen() ? c.exit() : c.enter();
                }
            },
            {
                name: "preloader",
                option: "preloaderEl",
                onInit: function(a) {
                    m = a;
                }
            }
        ], T = function() {
            var a, c, e, f = function(d) {
                if (d) for(var f = d.length, g = 0; g < f; g++){
                    a = d[g], c = a.className;
                    for(var h = 0; h < S.length; h++)e = S[h], c.indexOf("pswp__" + e.name) > -1 && (q[e.option] ? (b.removeClass(a, "pswp__element--disabled"), e.onInit && e.onInit(a)) : b.addClass(a, "pswp__element--disabled"));
                }
            };
            f(d.children);
            var g = b.getChildByClass(d, "pswp__top-bar");
            g && f(g.children);
        };
        v.init = function() {
            b.extend(a.options, z, !0), q = a.options, d = b.getChildByClass(a.scrollWrap, "pswp__ui"), l = a.listen, R(), l("beforeChange", v.update), l("doubleTap", function(b) {
                var c = a.currItem.initialZoomLevel;
                a.getZoomLevel() !== c ? a.zoomTo(c, b, 333) : a.zoomTo(q.getDoubleTapZoom(!1, a.currItem), b, 333);
            }), l("preventDragEvent", function(a, b, c) {
                var d = a.target || a.srcElement;
                d && d.getAttribute("class") && a.type.indexOf("mouse") > -1 && (d.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(d.tagName)) && (c.prevent = !1);
            }), l("bindEvents", function() {
                b.bind(d, "pswpTap click", A), b.bind(a.scrollWrap, "pswpTap", v.onGlobalTap), a.likelyTouchDevice || b.bind(a.scrollWrap, "mouseover", v.onMouseOver);
            }), l("unbindEvents", function() {
                y || F(), t && clearInterval(t), b.unbind(document, "mouseout", L), b.unbind(document, "mousemove", K), b.unbind(d, "pswpTap click", A), b.unbind(a.scrollWrap, "pswpTap", v.onGlobalTap), b.unbind(a.scrollWrap, "mouseover", v.onMouseOver), c && (b.unbind(document, c.eventK, v.updateFullscreen), c.isFullscreen() && (q.hideAnimationDuration = 0, c.exit()), c = null);
            }), l("destroy", function() {
                q.captionEl && (f && d.removeChild(f), b.removeClass(e, "pswp__caption--empty")), i && (i.children[0].onclick = null), b.removeClass(d, "pswp__ui--over-close"), b.addClass(d, "pswp__ui--hidden"), v.setIdle(!1);
            }), q.showAnimationDuration || b.removeClass(d, "pswp__ui--hidden"), l("initialZoomIn", function() {
                q.showAnimationDuration && b.removeClass(d, "pswp__ui--hidden");
            }), l("initialZoomOut", function() {
                b.addClass(d, "pswp__ui--hidden");
            }), l("parseVerticalMargin", P), T(), q.shareEl && h && i && (y = !0), D(), Q(), M(), N();
        }, v.setIdle = function(a) {
            k = a, C(d, "ui--idle", a);
        }, v.update = function() {
            x && a.currItem ? (v.updateIndexIndicator(), q.captionEl && (q.addCaptionHTMLFn(a.currItem, e), C(e, "caption--empty", !a.currItem.title)), w = !0) : w = !1, y || F(), D();
        }, v.updateFullscreen = function(d) {
            d && setTimeout(function() {
                a.setScrollOffset(0, b.getScrollY());
            }, 50), b[(c.isFullscreen() ? "add" : "remove") + "Class"](a.template, "pswp--fs");
        }, v.updateIndexIndicator = function() {
            q.counterEl && (g.innerHTML = a.getCurrentIndex() + 1 + q.indexIndicatorSep + q.getNumItemsFn());
        }, v.onGlobalTap = function(c) {
            c = c || window.event;
            var d = c.target || c.srcElement;
            if (!r) {
                if (c.detail && "mouse" === c.detail.pointerType) {
                    if (I(d)) return void a.close();
                    b.hasClass(d, "pswp__img") && (1 === a.getZoomLevel() && a.getZoomLevel() <= a.currItem.fitRatio ? q.clickToCloseNonZoomable && a.close() : a.toggleDesktopZoom(c.detail.releasePoint));
                } else if (q.tapToToggleControls && (x ? v.hideControls() : v.showControls()), q.tapToClose && (b.hasClass(d, "pswp__img") || I(d))) return void a.close();
            }
        }, v.onMouseOver = function(a) {
            a = a || window.event;
            var b = a.target || a.srcElement;
            C(d, "ui--over-close", I(b));
        }, v.hideControls = function() {
            b.addClass(d, "pswp__ui--hidden"), x = !1;
        }, v.showControls = function() {
            x = !0, w || v.update(), b.removeClass(d, "pswp__ui--hidden");
        }, v.supportsFullscreen = function() {
            var a = document;
            return !!(a.exitFullscreen || a.mozCancelFullScreen || a.webkitExitFullscreen || a.msExitFullscreen);
        }, v.getFullscreenAPI = function() {
            var b, c = document.documentElement, d = "fullscreenchange";
            return c.requestFullscreen ? b = {
                enterK: "requestFullscreen",
                exitK: "exitFullscreen",
                elementK: "fullscreenElement",
                eventK: d
            } : c.mozRequestFullScreen ? b = {
                enterK: "mozRequestFullScreen",
                exitK: "mozCancelFullScreen",
                elementK: "mozFullScreenElement",
                eventK: "moz" + d
            } : c.webkitRequestFullscreen ? b = {
                enterK: "webkitRequestFullscreen",
                exitK: "webkitExitFullscreen",
                elementK: "webkitFullscreenElement",
                eventK: "webkit" + d
            } : c.msRequestFullscreen && (b = {
                enterK: "msRequestFullscreen",
                exitK: "msExitFullscreen",
                elementK: "msFullscreenElement",
                eventK: "MSFullscreenChange"
            }), b && (b.enter = function() {
                return j = q.closeOnScroll, q.closeOnScroll = !1, "webkitRequestFullscreen" !== this.enterK ? a.template[this.enterK]() : void a.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
            }, b.exit = function() {
                return q.closeOnScroll = j, document[this.exitK]();
            }, b.isFullscreen = function() {
                return document[this.elementK];
            }), b;
        };
    };
    return a;
});


class $86594afc95b9677c$export$2e2bcd8739ae039 extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    requiredRefs = [
        'container'
    ];
    lightbox = null;
    template = `
        <!-- Root element of PhotoSwipe. Must have class pswp. -->
        <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">

            <!-- Background of PhotoSwipe.
                It's a separate element as animating opacity is faster than rgba(). -->
            <div class="pswp__bg"></div>

                <!-- Slides wrapper with overflow:hidden. -->
                <div class="pswp__scroll-wrap">

                    <!-- Container that holds slides.
                        PhotoSwipe keeps only 3 of them in the DOM to save memory.
                        Don't modify these 3 pswp__item elements, data is added later on. -->
                    <div class="pswp__container">
                        <div class="pswp__item"></div>
                        <div class="pswp__item"></div>
                        <div class="pswp__item"></div>
                    </div>

                    <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
                    <div class="pswp__ui pswp__ui--hidden">

                    <div class="pswp__top-bar">

                    <!--  Controls are self-explanatory. Order can be changed. -->

                    <div class="pswp__counter"></div>

                        <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

                        <button class="pswp__button pswp__button--share" title="Share"></button>

                        <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

                        <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

                        <!-- Preloader demo https://codepen.io/dimsemenov/pen/yyBWoR -->
                        <!-- element will get class pswp__preloader--active when preloader is running -->
                        <div class="pswp__preloader">
                            <div class="pswp__preloader__icn">
                                <div class="pswp__preloader__cut">
                                    <div class="pswp__preloader__donut"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                        <div class="pswp__share-tooltip"></div>
                    </div>

                    <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>

                    <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>

                    <div class="pswp__caption">
                        <div class="pswp__caption__center"></div>
                    </div>

                </div>

            </div>

        </div>
    `;
    constructor(el, componentName){
        super(el, componentName);
        this.init();
    }
    prepareImages = ()=>{
        let images = [];
        if (!this.refs.image.length) this.refs.image = [
            this.refs.image
        ];
        this.refs.image.forEach((image)=>{
            images.push({
                src: image.dataset.url,
                w: image.dataset.width,
                h: image.dataset.height
            });
        });
        return images;
    };
    openGallery = (e)=>{
        e.preventDefault();
        // set options while using the current image index
        const options = {
            bgOpacity: 0.7,
            index: e.currentTarget.dataset.index - 1,
            shareEl: false,
            fullscreenEl: false,
            closeOnScroll: false
        };
        // crete items array in the required format based on the HTML markup
        const images = this.prepareImages();
        const gallery = new (0, (/*@__PURE__*/$parcel$interopDefault($ac0af11aed6320f0$exports)))(this.el.querySelector('.pswp'), (0, (/*@__PURE__*/$parcel$interopDefault($79de6f6f8dcbb90f$exports))), images, options);
        gallery.init();
    };
    init = ()=>{
        // insert html skeleton in template
        this.el.insertAdjacentHTML('beforeend', this.template);
        // bind opening gallery
        this.el.querySelectorAll('.Image').forEach((el)=>{
            el.addEventListener("click", this.openGallery);
        });
    };
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('Lightbox', $86594afc95b9677c$export$2e2bcd8739ae039);





var $apdun = parcelRequire("apdun");

var $apdun = parcelRequire("apdun");
function $9080b381e91840d8$export$8694e5c03a4df8e6(obj) {
    var object = obj;
    Object.keys(object).forEach(function(key) {
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $9080b381e91840d8$export$bdd553fddd433dcb(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $9080b381e91840d8$export$461939dd4422153() {
    return Date.now();
}
function $9080b381e91840d8$export$3735103072e4a80(el) {
    var window1 = (0, $apdun.getWindow)();
    var style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $9080b381e91840d8$export$5ec402b7fcf74398(el, axis) {
    if (axis === void 0) axis = 'x';
    var window1 = (0, $apdun.getWindow)();
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = $9080b381e91840d8$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map(function(a) {
            return a.replace(',', '.');
        }).join(', ');
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $9080b381e91840d8$export$a6cdc56e425d0d0a(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $9080b381e91840d8$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $9080b381e91840d8$export$8b58be045bf06082() {
    var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    var noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(var i = 1; i < arguments.length; i += 1){
        var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$9080b381e91840d8$var$isNode(nextSource)) {
            var keysArray = Object.keys(Object(nextSource)).filter(function(key) {
                return noExtend.indexOf(key) < 0;
            });
            for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                var nextKey = keysArray[nextIndex];
                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($9080b381e91840d8$export$a6cdc56e425d0d0a(to[nextKey]) && $9080b381e91840d8$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $9080b381e91840d8$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$9080b381e91840d8$export$a6cdc56e425d0d0a(to[nextKey]) && $9080b381e91840d8$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $9080b381e91840d8$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $9080b381e91840d8$export$d2651194ddf43b70(instance, obj) {
    Object.keys(obj).forEach(function(key) {
        if ($9080b381e91840d8$export$a6cdc56e425d0d0a(obj[key])) Object.keys(obj[key]).forEach(function(subKey) {
            if (typeof obj[key][subKey] === 'function') obj[key][subKey] = obj[key][subKey].bind(instance);
        });
        instance[key] = obj[key];
    });
}
function $9080b381e91840d8$export$730a8e2ed4fdbe02(classes) {
    if (classes === void 0) classes = '';
    return "." + classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.');
}
function $9080b381e91840d8$export$f4bbea1d7959d26b($container, params, createElements, checkProps) {
    var document = (0, $apdun.getDocument)();
    if (createElements) Object.keys(checkProps).forEach(function(key) {
        if (!params[key] && params.auto === true) {
            var element = document.createElement('div');
            element.className = checkProps[key];
            $container.append(element);
            params[key] = element;
        }
    });
    return params;
}


function $50ce1174baac4ab2$var$_extends() {
    $50ce1174baac4ab2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $50ce1174baac4ab2$var$_extends.apply(this, arguments);
}
var $50ce1174baac4ab2$var$Autoplay = {
    run: function run() {
        var swiper = this;
        var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        var delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr('data-swiper-autoplay')) delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = (0, $9080b381e91840d8$export$bdd553fddd433dcb)(function() {
            var autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    swiper.emit('autoplay');
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    swiper.emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    swiper.emit('autoplay');
                } else swiper.autoplay.stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                swiper.emit('autoplay');
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                swiper.emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                swiper.emit('autoplay');
            } else swiper.autoplay.stop();
            if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();
            else if (autoplayResult === false) swiper.autoplay.run();
        }, delay);
    },
    start: function start() {
        var swiper = this;
        if (typeof swiper.autoplay.timeout !== 'undefined') return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        swiper.emit('autoplayStart');
        swiper.autoplay.run();
        return true;
    },
    stop: function stop() {
        var swiper = this;
        if (!swiper.autoplay.running) return false;
        if (typeof swiper.autoplay.timeout === 'undefined') return false;
        if (swiper.autoplay.timeout) {
            clearTimeout(swiper.autoplay.timeout);
            swiper.autoplay.timeout = undefined;
        }
        swiper.autoplay.running = false;
        swiper.emit('autoplayStop');
        return true;
    },
    pause: function pause(speed) {
        var swiper = this;
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            swiper.autoplay.run();
        } else [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach(function(event) {
            swiper.$wrapperEl[0].addEventListener(event, swiper.autoplay.onTransitionEnd);
        });
    },
    onVisibilityChange: function onVisibilityChange() {
        var swiper = this;
        var document = (0, $apdun.getDocument)();
        if (document.visibilityState === 'hidden' && swiper.autoplay.running) swiper.autoplay.pause();
        if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
            swiper.autoplay.run();
            swiper.autoplay.paused = false;
        }
    },
    onTransitionEnd: function onTransitionEnd(e) {
        var swiper = this;
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach(function(event) {
            swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) swiper.autoplay.stop();
        else swiper.autoplay.run();
    },
    onMouseEnter: function onMouseEnter() {
        var swiper = this;
        if (swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
        else swiper.autoplay.pause();
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach(function(event) {
            swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
        });
    },
    onMouseLeave: function onMouseLeave() {
        var swiper = this;
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        swiper.autoplay.run();
    },
    attachMouseEvents: function attachMouseEvents() {
        var swiper = this;
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on('mouseenter', swiper.autoplay.onMouseEnter);
            swiper.$el.on('mouseleave', swiper.autoplay.onMouseLeave);
        }
    },
    detachMouseEvents: function detachMouseEvents() {
        var swiper = this;
        swiper.$el.off('mouseenter', swiper.autoplay.onMouseEnter);
        swiper.$el.off('mouseleave', swiper.autoplay.onMouseLeave);
    }
};
var $50ce1174baac4ab2$export$2e2bcd8739ae039 = {
    name: 'autoplay',
    params: {
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    },
    create: function create() {
        var swiper = this;
        (0, $9080b381e91840d8$export$d2651194ddf43b70)(swiper, {
            autoplay: $50ce1174baac4ab2$var$_extends({}, $50ce1174baac4ab2$var$Autoplay, {
                running: false,
                paused: false
            })
        });
    },
    on: {
        init: function init(swiper) {
            if (swiper.params.autoplay.enabled) {
                swiper.autoplay.start();
                var document = (0, $apdun.getDocument)();
                document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
                swiper.autoplay.attachMouseEvents();
            }
        },
        beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
            if (swiper.autoplay.running) {
                if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
                else swiper.autoplay.stop();
            }
        },
        sliderFirstMove: function sliderFirstMove(swiper) {
            if (swiper.autoplay.running) {
                if (swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                else swiper.autoplay.pause();
            }
        },
        touchEnd: function touchEnd(swiper) {
            if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.run();
        },
        destroy: function destroy(swiper) {
            swiper.autoplay.detachMouseEvents();
            if (swiper.autoplay.running) swiper.autoplay.stop();
            var document = (0, $apdun.getDocument)();
            document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
        }
    }
};


var $apdun = parcelRequire("apdun");

var $1PrgP = parcelRequire("1PrgP");
var $32a1c384014113b9$var$Methods = {
    addClass: (0, $1PrgP.addClass),
    removeClass: (0, $1PrgP.removeClass),
    hasClass: (0, $1PrgP.hasClass),
    toggleClass: (0, $1PrgP.toggleClass),
    attr: (0, $1PrgP.attr),
    removeAttr: (0, $1PrgP.removeAttr),
    transform: (0, $1PrgP.transform),
    transition: (0, $1PrgP.transition),
    on: (0, $1PrgP.on),
    off: (0, $1PrgP.off),
    trigger: (0, $1PrgP.trigger),
    transitionEnd: (0, $1PrgP.transitionEnd),
    outerWidth: (0, $1PrgP.outerWidth),
    outerHeight: (0, $1PrgP.outerHeight),
    styles: (0, $1PrgP.styles),
    offset: (0, $1PrgP.offset),
    css: (0, $1PrgP.css),
    each: (0, $1PrgP.each),
    html: (0, $1PrgP.html),
    text: (0, $1PrgP.text),
    is: (0, $1PrgP.is),
    index: (0, $1PrgP.index),
    eq: (0, $1PrgP.eq),
    append: (0, $1PrgP.append),
    prepend: (0, $1PrgP.prepend),
    next: (0, $1PrgP.next),
    nextAll: (0, $1PrgP.nextAll),
    prev: (0, $1PrgP.prev),
    prevAll: (0, $1PrgP.prevAll),
    parent: (0, $1PrgP.parent),
    parents: (0, $1PrgP.parents),
    closest: (0, $1PrgP.closest),
    find: (0, $1PrgP.find),
    children: (0, $1PrgP.children),
    filter: (0, $1PrgP.filter),
    remove: (0, $1PrgP.remove)
};
Object.keys($32a1c384014113b9$var$Methods).forEach(function(methodName) {
    Object.defineProperty((0, $1PrgP.$).fn, methodName, {
        value: $32a1c384014113b9$var$Methods[methodName],
        writable: true
    });
});
var $32a1c384014113b9$export$2e2bcd8739ae039 = (0, $1PrgP.$);




var $apdun = parcelRequire("apdun");
var $b9d30bb2924a16bf$var$support;
function $b9d30bb2924a16bf$var$calcSupport() {
    var window = (0, $apdun.getWindow)();
    var document = (0, $apdun.getDocument)();
    return {
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
        observer: function checkObserver() {
            return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
        }(),
        passiveListener: function checkPassiveListener() {
            var supportsPassive = false;
            try {
                var opts = Object.defineProperty({}, 'passive', {
                    // eslint-disable-next-line
                    get: function get() {
                        supportsPassive = true;
                    }
                });
                window.addEventListener('testPassiveListener', null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return 'ongesturestart' in window;
        }()
    };
}
function $b9d30bb2924a16bf$export$d61c7b85ff180578() {
    if (!$b9d30bb2924a16bf$var$support) $b9d30bb2924a16bf$var$support = $b9d30bb2924a16bf$var$calcSupport();
    return $b9d30bb2924a16bf$var$support;
}



var $apdun = parcelRequire("apdun");

var $1ce9b9db0159e11f$var$device;
function $1ce9b9db0159e11f$var$calcDevice(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, userAgent = _ref.userAgent;
    var support = (0, $b9d30bb2924a16bf$export$d61c7b85ff180578)();
    var window = (0, $apdun.getWindow)();
    var platform = window.navigator.platform;
    var ua = userAgent || window.navigator.userAgent;
    var device = {
        ios: false,
        android: false
    };
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var windows = platform === 'Win32';
    var macos = platform === 'MacIntel'; // iPadOs 13 fix
    var iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    } // Export object
    return device;
}
function $1ce9b9db0159e11f$export$30c823bc834d6ab4(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$1ce9b9db0159e11f$var$device) $1ce9b9db0159e11f$var$device = $1ce9b9db0159e11f$var$calcDevice(overrides);
    return $1ce9b9db0159e11f$var$device;
}



var $apdun = parcelRequire("apdun");
var $6d95e553c0f5b245$var$browser;
function $6d95e553c0f5b245$var$calcBrowser() {
    var window = (0, $apdun.getWindow)();
    function isSafari() {
        var ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    return {
        isEdge: !!window.navigator.userAgent.match(/Edge/g),
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $6d95e553c0f5b245$export$89e15fc796a4a429() {
    if (!$6d95e553c0f5b245$var$browser) $6d95e553c0f5b245$var$browser = $6d95e553c0f5b245$var$calcBrowser();
    return $6d95e553c0f5b245$var$browser;
}



var $apdun = parcelRequire("apdun");

var $a21a3c5c164b1a16$var$supportsResizeObserver = function supportsResizeObserver() {
    var window = (0, $apdun.getWindow)();
    return typeof window.ResizeObserver !== 'undefined';
};
var $a21a3c5c164b1a16$export$2e2bcd8739ae039 = {
    name: 'resize',
    create: function create() {
        var swiper = this;
        (0, $9080b381e91840d8$export$8b58be045bf06082)(swiper, {
            resize: {
                observer: null,
                createObserver: function createObserver() {
                    if (!swiper || swiper.destroyed || !swiper.initialized) return;
                    swiper.resize.observer = new ResizeObserver(function(entries) {
                        var width = swiper.width, height = swiper.height;
                        var newWidth = width;
                        var newHeight = height;
                        entries.forEach(function(_ref) {
                            var contentBoxSize = _ref.contentBoxSize, contentRect = _ref.contentRect, target = _ref.target;
                            if (target && target !== swiper.el) return;
                            newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                            newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                        });
                        if (newWidth !== width || newHeight !== height) swiper.resize.resizeHandler();
                    });
                    swiper.resize.observer.observe(swiper.el);
                },
                removeObserver: function removeObserver() {
                    if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
                        swiper.resize.observer.unobserve(swiper.el);
                        swiper.resize.observer = null;
                    }
                },
                resizeHandler: function resizeHandler() {
                    if (!swiper || swiper.destroyed || !swiper.initialized) return;
                    swiper.emit('beforeResize');
                    swiper.emit('resize');
                },
                orientationChangeHandler: function orientationChangeHandler() {
                    if (!swiper || swiper.destroyed || !swiper.initialized) return;
                    swiper.emit('orientationchange');
                }
            }
        });
    },
    on: {
        init: function init(swiper) {
            var window = (0, $apdun.getWindow)();
            if (swiper.params.resizeObserver && $a21a3c5c164b1a16$var$supportsResizeObserver()) {
                swiper.resize.createObserver();
                return;
            } // Emit resize
            window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange
            window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
        },
        destroy: function destroy(swiper) {
            var window = (0, $apdun.getWindow)();
            swiper.resize.removeObserver();
            window.removeEventListener('resize', swiper.resize.resizeHandler);
            window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
        }
    }
};



var $apdun = parcelRequire("apdun");

function $ba7be428e15f5125$var$_extends() {
    $ba7be428e15f5125$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ba7be428e15f5125$var$_extends.apply(this, arguments);
}
var $ba7be428e15f5125$var$Observer = {
    attach: function attach(target, options) {
        if (options === void 0) options = {};
        var window = (0, $apdun.getWindow)();
        var swiper = this;
        var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                swiper.emit('observerUpdate', mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                swiper.emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: typeof options.childList === 'undefined' ? true : options.childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        swiper.observer.observers.push(observer);
    },
    init: function init() {
        var swiper = this;
        if (!swiper.support.observer || !swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = swiper.$el.parents();
            for(var i = 0; i < containerParents.length; i += 1)swiper.observer.attach(containerParents[i]);
        } // Observe container
        swiper.observer.attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        swiper.observer.attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    },
    destroy: function destroy() {
        var swiper = this;
        swiper.observer.observers.forEach(function(observer) {
            observer.disconnect();
        });
        swiper.observer.observers = [];
    }
};
var $ba7be428e15f5125$export$2e2bcd8739ae039 = {
    name: 'observer',
    params: {
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    },
    create: function create() {
        var swiper = this;
        (0, $9080b381e91840d8$export$d2651194ddf43b70)(swiper, {
            observer: $ba7be428e15f5125$var$_extends({}, $ba7be428e15f5125$var$Observer, {
                observers: []
            })
        });
    },
    on: {
        init: function init(swiper) {
            swiper.observer.init();
        },
        destroy: function destroy(swiper) {
            swiper.observer.destroy();
        }
    }
};



var $b6d7a66776f16016$export$2e2bcd8739ae039 = {
    useParams: function useParams(instanceParams) {
        var instance = this;
        if (!instance.modules) return;
        Object.keys(instance.modules).forEach(function(moduleName) {
            var module = instance.modules[moduleName]; // Extend params
            if (module.params) (0, $9080b381e91840d8$export$8b58be045bf06082)(instanceParams, module.params);
        });
    },
    useModules: function useModules(modulesParams) {
        if (modulesParams === void 0) modulesParams = {};
        var instance = this;
        if (!instance.modules) return;
        Object.keys(instance.modules).forEach(function(moduleName) {
            var module = instance.modules[moduleName];
            var moduleParams = modulesParams[moduleName] || {}; // Add event listeners
            if (module.on && instance.on) Object.keys(module.on).forEach(function(moduleEventName) {
                instance.on(moduleEventName, module.on[moduleEventName]);
            });
             // Module create callback
            if (module.create) module.create.bind(instance)(moduleParams);
        });
    }
};


/* eslint-disable no-underscore-dangle */ var $4fae98c445de58c8$export$2e2bcd8739ae039 = {
    on: function on(events, handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        events.split(' ').forEach(function(event) {
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once: function once(events, handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny: function onAny(handler, priority) {
        var self = this;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny: function offAny(handler) {
        var self = this;
        if (!self.eventsAnyListeners) return self;
        var index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off: function off(events, handler) {
        var self = this;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach(function(event) {
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler, index) {
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit: function emit() {
        var self = this;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        var eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach(function(event) {
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach(function(eventHandler) {
                eventHandler.apply(context, [
                    event
                ].concat(data));
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler) {
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};



function $64cb504bad1928ed$export$2e2bcd8739ae039() {
    var swiper = this;
    var width;
    var height;
    var $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
    height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    (0, $9080b381e91840d8$export$8b58be045bf06082)(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}



function $49c82f67c5fec854$export$2e2bcd8739ae039() {
    var swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    var params = swiper.params;
    var $wrapperEl = swiper.$wrapperEl, swiperSize = swiper.size, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = $wrapperEl.children("." + swiper.params.slideClass);
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.slidesGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: '',
        marginBottom: '',
        marginTop: ''
    });
    else slides.css({
        marginRight: '',
        marginBottom: '',
        marginTop: ''
    });
    var slidesNumberEvenToRows;
    if (params.slidesPerColumn > 1) {
        if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
        if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
    } // Calc slides
    var slideSize;
    var slidesPerColumn = params.slidesPerColumn;
    var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
    var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = slides.eq(i);
        if (params.slidesPerColumn > 1) {
            // Set slides order
            var newSlideOrderIndex = void 0;
            var column = void 0;
            var row = void 0;
            if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
                var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
                var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
                var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
                row = Math.floor(slideIndexInGroup / columnsInGroup);
                column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
                newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
                slide.css({
                    '-webkit-box-ordinal-group': newSlideOrderIndex,
                    '-moz-box-ordinal-group': newSlideOrderIndex,
                    '-ms-flex-order': newSlideOrderIndex,
                    '-webkit-order': newSlideOrderIndex,
                    order: newSlideOrderIndex
                });
            } else if (params.slidesPerColumnFill === 'column') {
                column = Math.floor(i / slidesPerColumn);
                row = i - column * slidesPerColumn;
                if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
                    row += 1;
                    if (row >= slidesPerColumn) {
                        row = 0;
                        column += 1;
                    }
                }
            } else {
                row = Math.floor(i / slidesPerRow);
                column = i - row * slidesPerRow;
            }
            slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
        }
        if (slide.css('display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            var slideStyles = getComputedStyle(slide[0]);
            var currentTransform = slide[0].style.transform;
            var currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = 'none';
            if (currentWebKitTransform) slide[0].style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                var width = getDirectionPropertyValue(slideStyles, 'width');
                var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                var boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    var _slide$ = slide[0], clientWidth = _slide$.clientWidth, offsetWidth = _slide$.offsetWidth;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel('width')] = slideSize + "px";
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    var newSlidesGrid;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) $wrapperEl.css({
        width: swiper.virtualSize + params.spaceBetween + "px"
    });
    if (params.setWrapperSize) {
        var _$wrapperEl$css;
        $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
    }
    if (params.slidesPerColumn > 1) {
        var _$wrapperEl$css2;
        swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
        $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));
        if (params.centeredSlides) {
            newSlidesGrid = [];
            for(var _i = 0; _i < snapGrid.length; _i += 1){
                var slidesGridItem = snapGrid[_i];
                if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid = newSlidesGrid;
        }
    } // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        newSlidesGrid = [];
        for(var _i2 = 0; _i2 < snapGrid.length; _i2 += 1){
            var _slidesGridItem = snapGrid[_i2];
            if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);
            if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(_slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        var _slides$filter$css;
        var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
        slides.filter(function(_, slideIndex) {
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        var maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map(function(snap) {
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        var _allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        _allSlidesSize -= params.spaceBetween;
        if (_allSlidesSize < swiperSize) {
            var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    (0, $9080b381e91840d8$export$8b58be045bf06082)(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress || params.watchSlidesVisibility) swiper.updateSlidesOffset();
}


function $eff55f45062d5e03$export$2e2bcd8739ae039(speed) {
    var swiper = this;
    var activeSlides = [];
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    var getSlideByIndex = function getSlideByIndex(index) {
        if (isVirtual) return swiper.slides.filter(function(el) {
            return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
        })[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) swiper.visibleSlides.each(function(slide) {
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            var index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
}


function $a29027ad65ac2a15$export$2e2bcd8739ae039() {
    var swiper = this;
    var slides = swiper.slides;
    for(var i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}



function $13c2b3c1082af517$export$2e2bcd8739ae039(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
            var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
            var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
            var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
            if (isVisible) {
                swiper.visibleSlides.push(slide);
                swiper.visibleSlidesIndexes.push(i);
                slides.eq(i).addClass(params.slideVisibleClass);
            }
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
    }
    swiper.visibleSlides = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(swiper.visibleSlides);
}



function $d3f03085ccdc2fc1$export$2e2bcd8739ae039(translate) {
    var swiper = this;
    if (typeof translate === 'undefined') {
        var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    (0, $9080b381e91840d8$export$8b58be045bf06082)(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}


function $e2cd8d2072e550cc$export$2e2bcd8739ae039() {
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex, realIndex = swiper.realIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
    var activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}



function $8fbb34d684ddfd1e$export$2e2bcd8739ae039(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var slidesGrid = swiper.slidesGrid, snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    if (typeof activeIndex === 'undefined') {
        for(var i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== 'undefined') {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    } // Get real index
    var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    (0, $9080b381e91840d8$export$8b58be045bf06082)(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit('slideChange');
}



function $4731547fed131533$export$2e2bcd8739ae039(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(e.target).closest("." + params.slideClass)[0];
    var slideFound = false;
    var slideIndex;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $32a1c384014113b9$export$2e2bcd8739ae039)(slide).attr('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $0813070a662e318c$export$2e2bcd8739ae039 = {
    updateSize: (0, $64cb504bad1928ed$export$2e2bcd8739ae039),
    updateSlides: (0, $49c82f67c5fec854$export$2e2bcd8739ae039),
    updateAutoHeight: (0, $eff55f45062d5e03$export$2e2bcd8739ae039),
    updateSlidesOffset: (0, $a29027ad65ac2a15$export$2e2bcd8739ae039),
    updateSlidesProgress: (0, $13c2b3c1082af517$export$2e2bcd8739ae039),
    updateProgress: (0, $d3f03085ccdc2fc1$export$2e2bcd8739ae039),
    updateSlidesClasses: (0, $e2cd8d2072e550cc$export$2e2bcd8739ae039),
    updateActiveIndex: (0, $8fbb34d684ddfd1e$export$2e2bcd8739ae039),
    updateClickedSlide: (0, $4731547fed131533$export$2e2bcd8739ae039)
};



function $ce39b47ea58d4e3b$export$2e2bcd8739ae039(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? 'x' : 'y';
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, $wrapperEl = swiper.$wrapperEl;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    var currentTranslate = (0, $9080b381e91840d8$export$5ec402b7fcf74398)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $412e666a3bfb0d89$export$2e2bcd8739ae039(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, $wrapperEl = swiper.$wrapperEl, wrapperEl = swiper.wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}


function $3488c07cc6f91d1b$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $d2067f7cb0ebcbe0$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}


function $d7c5810a35740aba$export$2e2bcd8739ae039(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    var swiper = this;
    var params = swiper.params, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    var minTranslate = swiper.minTranslate();
    var maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
            var _wrapperEl$scrollTo;
            wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
        } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $2ad485031d8e346c$export$2e2bcd8739ae039 = {
    getTranslate: (0, $ce39b47ea58d4e3b$export$2e2bcd8739ae039),
    setTranslate: (0, $412e666a3bfb0d89$export$2e2bcd8739ae039),
    minTranslate: (0, $3488c07cc6f91d1b$export$2e2bcd8739ae039),
    maxTranslate: (0, $d2067f7cb0ebcbe0$export$2e2bcd8739ae039),
    translateTo: (0, $d7c5810a35740aba$export$2e2bcd8739ae039)
};


function $6e0d070367fd49a0$export$2e2bcd8739ae039(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit('setTransition', duration, byController);
}


function $994293e012f9725e$export$2e2bcd8739ae039(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var activeIndex = swiper.activeIndex, params = swiper.params, previousIndex = swiper.previousIndex;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit('transitionStart');
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit('slideResetTransitionStart');
            return;
        }
        swiper.emit('slideChangeTransitionStart');
        if (dir === 'next') swiper.emit('slideNextTransitionStart');
        else swiper.emit('slidePrevTransitionStart');
    }
}


function $f0cd624259414129$export$2e2bcd8739ae039(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex, params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit('transitionEnd');
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit('slideResetTransitionEnd');
            return;
        }
        swiper.emit('slideChangeTransitionEnd');
        if (dir === 'next') swiper.emit('slideNextTransitionEnd');
        else swiper.emit('slidePrevTransitionEnd');
    }
}


var $0e04f6ba082a0aac$export$2e2bcd8739ae039 = {
    setTransition: (0, $6e0d070367fd49a0$export$2e2bcd8739ae039),
    transitionStart: (0, $994293e012f9725e$export$2e2bcd8739ae039),
    transitionEnd: (0, $f0cd624259414129$export$2e2bcd8739ae039)
};


function $0eb743bfbb39c7e6$export$2e2bcd8739ae039(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index !== 'number' && typeof index !== 'string') throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ var indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ var isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate, wrapperEl = swiper.wrapperEl, enabled = swiper.enabled;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    var translate = -snapGrid[snapIndex]; // Update progress
    swiper.updateProgress(translate); // Normalize slideIndex
    if (params.normalizeSlideIndex) for(var i = 0; i < slidesGrid.length; i += 1){
        var normalizedTranslate = -Math.floor(translate * 100);
        var normalizedGird = Math.floor(slidesGrid[i] * 100);
        var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGird) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    var direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset'; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = -translate;
        if (rtl) t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        else // eslint-disable-next-line
        if (wrapperEl.scrollTo) {
            var _wrapperEl$scrollTo;
            wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
        } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
                swiper.onSlideToWrapperTransitionEnd = null;
                delete swiper.onSlideToWrapperTransitionEnd;
                swiper.transitionEnd(runCallbacks, direction);
            };
            swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        }
    }
    return true;
}


function $91dfbf1faf30fe4d$export$2e2bcd8739ae039(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $968ae94971d57f3e$export$2e2bcd8739ae039(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params, animating = swiper.animating, enabled = swiper.enabled;
    if (!enabled) return swiper;
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $625533614f70d1fb$export$2e2bcd8739ae039(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params, animating = swiper.animating, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) snapGrid.forEach(function(snap) {
        if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
    });
    var prevIndex;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $5918e1e6541ad360$export$2e2bcd8739ae039(speed, runCallbacks, internal) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $11022e4b47c1be1b$export$2e2bcd8739ae039(speed, runCallbacks, internal, threshold) {
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    var swiper = this;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var _currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}




function $2fa254d61e40beb4$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl;
    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $32a1c384014113b9$export$2e2bcd8739ae039)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
                (0, $9080b381e91840d8$export$bdd553fddd433dcb)(function() {
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
            (0, $9080b381e91840d8$export$bdd553fddd433dcb)(function() {
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $930969f479d7b725$export$2e2bcd8739ae039 = {
    slideTo: (0, $0eb743bfbb39c7e6$export$2e2bcd8739ae039),
    slideToLoop: (0, $91dfbf1faf30fe4d$export$2e2bcd8739ae039),
    slideNext: (0, $968ae94971d57f3e$export$2e2bcd8739ae039),
    slidePrev: (0, $625533614f70d1fb$export$2e2bcd8739ae039),
    slideReset: (0, $5918e1e6541ad360$export$2e2bcd8739ae039),
    slideToClosest: (0, $11022e4b47c1be1b$export$2e2bcd8739ae039),
    slideToClickedSlide: (0, $2fa254d61e40beb4$export$2e2bcd8739ae039)
};



var $apdun = parcelRequire("apdun");

function $2f0bd1e7999cd21a$export$2e2bcd8739ae039() {
    var swiper = this;
    var document = (0, $apdun.getDocument)();
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides
    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
    var slides = $wrapperEl.children("." + params.slideClass);
    if (params.loopFillGroupWithBlank) {
        var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(var i = 0; i < blankSlidesNum; i += 1){
                var blankNode = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
                $wrapperEl.append(blankNode);
            }
            slides = $wrapperEl.children("." + params.slideClass);
        }
    }
    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length) swiper.loopedSlides = slides.length;
    var prependSlides = [];
    var appendSlides = [];
    slides.each(function(el, index) {
        var slide = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(el);
        if (index < swiper.loopedSlides) appendSlides.push(el);
        if (index < slides.length && index >= slides.length - swiper.loopedSlides) prependSlides.push(el);
        slide.attr('data-swiper-slide-index', index);
    });
    for(var _i = 0; _i < appendSlides.length; _i += 1)$wrapperEl.append((0, $32a1c384014113b9$export$2e2bcd8739ae039)(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1)$wrapperEl.prepend((0, $32a1c384014113b9$export$2e2bcd8739ae039)(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
}


function $1d27f153aaff5f9c$export$2e2bcd8739ae039() {
    var swiper = this;
    swiper.emit('beforeLoopFix');
    var activeIndex = swiper.activeIndex, slides = swiper.slides, loopedSlides = swiper.loopedSlides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, snapGrid = swiper.snapGrid, rtl = swiper.rtlTranslate;
    var newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    var snapTranslate = -snapGrid[activeIndex];
    var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        var slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        var _slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (_slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
}


function $888718aa7bdca0e2$export$2e2bcd8739ae039() {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, slides = swiper.slides;
    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
    slides.removeAttr('data-swiper-slide-index');
}


var $94c1769974591c59$export$2e2bcd8739ae039 = {
    loopCreate: (0, $2f0bd1e7999cd21a$export$2e2bcd8739ae039),
    loopFix: (0, $1d27f153aaff5f9c$export$2e2bcd8739ae039),
    loopDestroy: (0, $888718aa7bdca0e2$export$2e2bcd8739ae039)
};


function $45f88860ebe360fc$export$2e2bcd8739ae039(moving) {
    var swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.el;
    el.style.cursor = 'move';
    el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
    el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
    el.style.cursor = moving ? 'grabbing' : 'grab';
}


function $bd0ff9996fec1f3b$export$2e2bcd8739ae039() {
    var swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper.el.style.cursor = '';
}


var $f20f90d3ffb9756f$export$2e2bcd8739ae039 = {
    setGrabCursor: (0, $45f88860ebe360fc$export$2e2bcd8739ae039),
    unsetGrabCursor: (0, $bd0ff9996fec1f3b$export$2e2bcd8739ae039)
};


function $e5036a17c0c20888$export$2e2bcd8739ae039(slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === 'object' && 'length' in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && swiper.support.observer)) swiper.update();
}


function $b067ccc282364717$export$2e2bcd8739ae039(slides) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    if (params.loop) swiper.loopDestroy();
    var newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && swiper.support.observer)) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}


function $b35f9d3d2bda53f5$export$2e2bcd8739ae039(index, slides) {
    var swiper = this;
    var $wrapperEl = swiper.$wrapperEl, params = swiper.params, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children("." + params.slideClass);
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for(var i = baseLength - 1; i >= index; i -= 1){
        var currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(var _i = 0; _i < slides.length; _i += 1)if (slides[_i]) $wrapperEl.append(slides[_i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1)$wrapperEl.append(slidesBuffer[_i2]);
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && swiper.support.observer)) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $2f8d970195fad2d5$export$2e2bcd8739ae039(slidesIndexes) {
    var swiper = this;
    var params = swiper.params, $wrapperEl = swiper.$wrapperEl, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children("." + params.slideClass);
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(var i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!(params.observer && swiper.support.observer)) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $ba88d9cb84268300$export$2e2bcd8739ae039() {
    var swiper = this;
    var slidesIndexes = [];
    for(var i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


var $c9c13551f095f951$export$2e2bcd8739ae039 = {
    appendSlide: (0, $e5036a17c0c20888$export$2e2bcd8739ae039),
    prependSlide: (0, $b067ccc282364717$export$2e2bcd8739ae039),
    addSlide: (0, $b35f9d3d2bda53f5$export$2e2bcd8739ae039),
    removeSlide: (0, $2f8d970195fad2d5$export$2e2bcd8739ae039),
    removeAllSlides: (0, $ba88d9cb84268300$export$2e2bcd8739ae039)
};



var $apdun = parcelRequire("apdun");

var $apdun = parcelRequire("apdun");


function $2efef317dc0880b2$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $apdun.getDocument)() || el === (0, $apdun.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        var found = el.closest(selector);
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $2efef317dc0880b2$export$2e2bcd8739ae039(event) {
    var swiper = this;
    var document = (0, $apdun.getDocument)();
    var window = (0, $apdun.getWindow)();
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, enabled = swiper.enabled;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var $targetEl = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(e.target);
    if (params.touchEventsTarget === 'wrapper') {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) $targetEl = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(event.path[0]);
    var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
    var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $2efef317dc0880b2$var$closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') event.preventDefault();
        else return;
    }
    (0, $9080b381e91840d8$export$8b58be045bf06082)(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $9080b381e91840d8$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== 'touchstart') {
        var preventDefault = true;
        if ($targetEl.is(data.focusableElements)) preventDefault = false;
        if (document.activeElement && (0, $32a1c384014113b9$export$2e2bcd8739ae039)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    swiper.emit('touchStart', e);
}



var $apdun = parcelRequire("apdun");


function $75d8276ed8a8a7d4$export$2e2bcd8739ae039(event) {
    var document = (0, $apdun.getDocument)();
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    if (data.isTouchEvent && e.type !== 'touchmove') return;
    var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        // isMoved = true;
        swiper.allowClick = false;
        if (data.isTouched) {
            (0, $9080b381e91840d8$export$8b58be045bf06082)(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $9080b381e91840d8$export$461939dd4422153)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $32a1c384014113b9$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    var diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode) {
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $9080b381e91840d8$export$461939dd4422153)()
        });
    } // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $de69dbbdadcce7aa$export$2e2bcd8739ae039(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, $wrapperEl = swiper.$wrapperEl, slidesGrid = swiper.slidesGrid, snapGrid = swiper.snapGrid, enabled = swiper.enabled;
    if (!enabled) return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    var touchEndTime = (0, $9080b381e91840d8$export$461939dd4422153)();
    var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        swiper.updateClickedSlide(e);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $9080b381e91840d8$export$461939dd4422153)();
    (0, $9080b381e91840d8$export$bdd553fddd433dcb)(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode) {
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeModeMomentum) {
            if (data.velocities.length > 1) {
                var lastMoveEvent = data.velocities.pop();
                var velocityEvent = data.velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $9080b381e91840d8$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeModeMomentumVelocityRatio;
            data.velocities.length = 0;
            var momentumDuration = 1000 * params.freeModeMomentumRatio;
            var momentumDistance = swiper.velocity * momentumDuration;
            var newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
            var needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeModeMomentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeModeMomentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeModeSticky) {
                var nextSlide;
                for(var j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) swiper.once('transitionEnd', function() {
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeModeSticky) {
                    // If freeModeSticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeModeSticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeModeMomentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(function() {
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    swiper.emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(function() {
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(function() {
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else {
                swiper.emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
            }
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeModeSticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) swiper.emit('_freeModeNoMomentumRelease');
        if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        return;
    } // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + _increment] !== 'undefined') {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + _increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    } // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}


function $f4d7ae47528b79bf$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $068067772d4ef945$export$2e2bcd8739ae039(e) {
    var swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $1eea703afcafd3cf$export$2e2bcd8739ae039() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) {
        if (rtlTranslate) swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
        else swiper.translate = -wrapperEl.scrollLeft;
    } else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === -0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}


var $c725ff59d991d131$var$dummyEventAttached = false;
function $c725ff59d991d131$var$dummyEventListener() {}
function $c725ff59d991d131$var$attachEvents() {
    var swiper = this;
    var document = (0, $apdun.getDocument)();
    var params = swiper.params, touchEvents = swiper.touchEvents, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device, support = swiper.support;
    swiper.onTouchStart = (0, $2efef317dc0880b2$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $75d8276ed8a8a7d4$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $de69dbbdadcce7aa$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $1eea703afcafd3cf$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $068067772d4ef945$export$2e2bcd8739ae039).bind(swiper);
    var capture = !!params.nested; // Touch Events
    if (!support.touch && support.pointerEvents) {
        el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
        document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
        document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
        if (support.touch) {
            var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
                passive: true,
                capture: false
            } : false;
            el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
                passive: false,
                capture: capture
            } : capture);
            el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
            if (touchEvents.cancel) el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
            if (!$c725ff59d991d131$var$dummyEventAttached) {
                document.addEventListener('touchstart', $c725ff59d991d131$var$dummyEventListener);
                $c725ff59d991d131$var$dummyEventAttached = true;
            }
        }
        if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
            el.addEventListener('mousedown', swiper.onTouchStart, false);
            document.addEventListener('mousemove', swiper.onTouchMove, capture);
            document.addEventListener('mouseup', swiper.onTouchEnd, false);
        }
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el.addEventListener('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl.addEventListener('scroll', swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', (0, $f4d7ae47528b79bf$export$2e2bcd8739ae039), true);
    else swiper.on('observerUpdate', (0, $f4d7ae47528b79bf$export$2e2bcd8739ae039), true);
}
function $c725ff59d991d131$var$detachEvents() {
    var swiper = this;
    var document = (0, $apdun.getDocument)();
    var params = swiper.params, touchEvents = swiper.touchEvents, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device, support = swiper.support;
    var capture = !!params.nested; // Touch Events
    if (!support.touch && support.pointerEvents) {
        el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
        document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
        document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
    } else {
        if (support.touch) {
            var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
                passive: true,
                capture: false
            } : false;
            el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
            el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
            if (touchEvents.cancel) el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
        }
        if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
            el.removeEventListener('mousedown', swiper.onTouchStart, false);
            document.removeEventListener('mousemove', swiper.onTouchMove, capture);
            document.removeEventListener('mouseup', swiper.onTouchEnd, false);
        }
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el.removeEventListener('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl.removeEventListener('scroll', swiper.onScroll);
     // Resize handler
    swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', (0, $f4d7ae47528b79bf$export$2e2bcd8739ae039));
}
var $c725ff59d991d131$export$2e2bcd8739ae039 = {
    attachEvents: $c725ff59d991d131$var$attachEvents,
    detachEvents: $c725ff59d991d131$var$detachEvents
};



function $11b09e47852f0231$export$2e2bcd8739ae039() {
    var swiper = this;
    var activeIndex = swiper.activeIndex, initialized = swiper.initialized, _swiper$loopedSlides = swiper.loopedSlides, loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides, params = swiper.params, $el = swiper.$el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    if (breakpointOnlyParams) [
        'slidesPerView',
        'spaceBetween',
        'slidesPerGroup',
        'slidesPerGroupSkip',
        'slidesPerColumn'
    ].forEach(function(param) {
        var paramValue = breakpointOnlyParams[param];
        if (typeof paramValue === 'undefined') return;
        if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) breakpointOnlyParams[param] = 'auto';
        else if (param === 'slidesPerView') breakpointOnlyParams[param] = parseFloat(paramValue);
        else breakpointOnlyParams[param] = parseInt(paramValue, 10);
    });
    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = params.slidesPerColumn > 1;
    var isMultiRow = breakpointParams.slidesPerColumn > 1;
    var wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(params.containerModifierClass + "multirow");
        if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === 'column' || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === 'column') $el.addClass(params.containerModifierClass + "multirow-column");
        swiper.emitContainerClasses();
    }
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $9080b381e91840d8$export$8b58be045bf06082)(swiper.params, breakpointParams);
    var isEnabled = swiper.params.enabled;
    (0, $9080b381e91840d8$export$8b58be045bf06082)(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit('breakpoint', breakpointParams);
}



var $apdun = parcelRequire("apdun");
function $ad665a2fbeb45b00$export$2e2bcd8739ae039(breakpoints, base, containerEl) {
    if (base === void 0) base = 'window';
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    var breakpoint = false;
    var window = (0, $apdun.getWindow)();
    var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    var points = Object.keys(breakpoints).map(function(point) {
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            var minRatio = parseFloat(point.substr(1));
            var value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort(function(a, b) {
        return parseInt(a.value, 10) - parseInt(b.value, 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var _points$i = points[i], point = _points$i.point, value = _points$i.value;
        if (base === 'window') {
            if (window.matchMedia("(min-width: " + value + "px)").matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}


var $e1c6bb0951a4969e$export$2e2bcd8739ae039 = {
    setBreakpoint: (0, $11b09e47852f0231$export$2e2bcd8739ae039),
    getBreakpoint: (0, $ad665a2fbeb45b00$export$2e2bcd8739ae039)
};


function $61a0cc6bce750c09$var$prepareClasses(entries, prefix) {
    var resultClasses = [];
    entries.forEach(function(item) {
        if (typeof item === 'object') Object.keys(item).forEach(function(classNames) {
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $61a0cc6bce750c09$export$2e2bcd8739ae039() {
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, $el = swiper.$el, device = swiper.device, support = swiper.support; // prettier-ignore
    var suffixes = $61a0cc6bce750c09$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'pointer-events': support.pointerEvents && !support.touch
        },
        {
            'free-mode': params.freeMode
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'multirow': params.slidesPerColumn > 1
        },
        {
            'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        }
    ], params.containerModifierClass);
    classNames.push.apply(classNames, suffixes);
    $el.addClass([].concat(classNames).join(' '));
    swiper.emitContainerClasses();
}


function $0dc114c686fd5b77$export$2e2bcd8739ae039() {
    var swiper = this;
    var $el = swiper.$el, classNames = swiper.classNames;
    $el.removeClass(classNames.join(' '));
    swiper.emitContainerClasses();
}


var $49b2d5c02d9f49e5$export$2e2bcd8739ae039 = {
    addClasses: (0, $61a0cc6bce750c09$export$2e2bcd8739ae039),
    removeClasses: (0, $0dc114c686fd5b77$export$2e2bcd8739ae039)
};



var $apdun = parcelRequire("apdun");

function $2d2bb74e17d9765a$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    var window = (0, $apdun.getWindow)();
    var image;
    function onReady() {
        if (callback) callback();
    }
    var isPicture = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(imageEl).parent('picture')[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}


function $73b844e2c38f2deb$export$2e2bcd8739ae039() {
    var swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit('imagesReady');
        }
    }
    for(var i = 0; i < swiper.imagesToLoad.length; i += 1){
        var imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
}


var $53320ecd1a9d0d44$export$2e2bcd8739ae039 = {
    loadImage: (0, $2d2bb74e17d9765a$export$2e2bcd8739ae039),
    preloadImages: (0, $73b844e2c38f2deb$export$2e2bcd8739ae039)
};


function $d6d09b5458d99a2f$var$checkOverflow() {
    var swiper = this;
    var params = swiper.params;
    var wasLocked = swiper.isLocked;
    var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;
    if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) swiper.isLocked = lastSlidePosition <= swiper.size;
    else swiper.isLocked = swiper.snapGrid.length === 1;
    swiper.allowSlideNext = !swiper.isLocked;
    swiper.allowSlidePrev = !swiper.isLocked; // events
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
    if (wasLocked && wasLocked !== swiper.isLocked) {
        swiper.isEnd = false;
        if (swiper.navigation) swiper.navigation.update();
    }
}
var $d6d09b5458d99a2f$export$2e2bcd8739ae039 = {
    checkOverflow: $d6d09b5458d99a2f$var$checkOverflow
};


var $4326680cc30d98cc$export$2e2bcd8739ae039 = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'container',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: false,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Free mode
    freeMode: false,
    freeModeMomentum: true,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: true,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: false,
    freeModeMinimumVelocity: 0.02,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: 'column',
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: false,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    watchSlidesVisibility: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    // NS
    containerModifierClass: 'swiper-container-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};


function $f4b4a3fe2f2f694c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f4b4a3fe2f2f694c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f4b4a3fe2f2f694c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f4b4a3fe2f2f694c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $f4b4a3fe2f2f694c$var$prototypes = {
    modular: (0, $b6d7a66776f16016$export$2e2bcd8739ae039),
    eventsEmitter: (0, $4fae98c445de58c8$export$2e2bcd8739ae039),
    update: (0, $0813070a662e318c$export$2e2bcd8739ae039),
    translate: (0, $2ad485031d8e346c$export$2e2bcd8739ae039),
    transition: (0, $0e04f6ba082a0aac$export$2e2bcd8739ae039),
    slide: (0, $930969f479d7b725$export$2e2bcd8739ae039),
    loop: (0, $94c1769974591c59$export$2e2bcd8739ae039),
    grabCursor: (0, $f20f90d3ffb9756f$export$2e2bcd8739ae039),
    manipulation: (0, $c9c13551f095f951$export$2e2bcd8739ae039),
    events: (0, $c725ff59d991d131$export$2e2bcd8739ae039),
    breakpoints: (0, $e1c6bb0951a4969e$export$2e2bcd8739ae039),
    checkOverflow: (0, $d6d09b5458d99a2f$export$2e2bcd8739ae039),
    classes: (0, $49b2d5c02d9f49e5$export$2e2bcd8739ae039),
    images: (0, $53320ecd1a9d0d44$export$2e2bcd8739ae039)
};
var $f4b4a3fe2f2f694c$var$extendedDefaults = {};
var $f4b4a3fe2f2f694c$var$Swiper = /*#__PURE__*/ function() {
    function Swiper() {
        var el;
        var params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else {
            el = args[0];
            params = args[1];
        }
        if (!params) params = {};
        params = (0, $9080b381e91840d8$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $32a1c384014113b9$export$2e2bcd8739ae039)(params.el).length > 1) {
            var swipers = [];
            (0, $32a1c384014113b9$export$2e2bcd8739ae039)(params.el).each(function(containerEl) {
                var newParams = (0, $9080b381e91840d8$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            return swipers;
        } // Swiper Instance
        var swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $b9d30bb2924a16bf$export$d61c7b85ff180578)();
        swiper.device = (0, $1ce9b9db0159e11f$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $6d95e553c0f5b245$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        if (typeof swiper.modules === 'undefined') swiper.modules = {};
        Object.keys(swiper.modules).forEach(function(moduleName) {
            var module = swiper.modules[moduleName];
            if (module.params) {
                var moduleParamName = Object.keys(module.params)[0];
                var moduleParams = module.params[moduleParamName];
                if (typeof moduleParams !== 'object' || moduleParams === null) return;
                if ([
                    'navigation',
                    'pagination',
                    'scrollbar'
                ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
                    auto: true
                };
                if (!(moduleParamName in params && 'enabled' in moduleParams)) return;
                if (params[moduleParamName] === true) params[moduleParamName] = {
                    enabled: true
                };
                if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
                if (!params[moduleParamName]) params[moduleParamName] = {
                    enabled: false
                };
            }
        }); // Extend defaults with modules params
        var swiperParams = (0, $9080b381e91840d8$export$8b58be045bf06082)({}, (0, $4326680cc30d98cc$export$2e2bcd8739ae039));
        swiper.useParams(swiperParams); // Extend defaults with passed params
        swiper.params = (0, $9080b381e91840d8$export$8b58be045bf06082)({}, swiperParams, $f4b4a3fe2f2f694c$var$extendedDefaults, params);
        swiper.originalParams = (0, $9080b381e91840d8$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $9080b381e91840d8$export$8b58be045bf06082)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach(function(eventName) {
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $32a1c384014113b9$export$2e2bcd8739ae039); // Extend Swiper
        (0, $9080b381e91840d8$export$8b58be045bf06082)(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $32a1c384014113b9$export$2e2bcd8739ae039)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function isHorizontal() {
                return swiper.params.direction === 'horizontal';
            },
            isVertical: function isVertical() {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                var touch = [
                    'touchstart',
                    'touchmove',
                    'touchend',
                    'touchcancel'
                ];
                var desktop = [
                    'mousedown',
                    'mousemove',
                    'mouseup'
                ];
                if (swiper.support.pointerEvents) desktop = [
                    'pointerdown',
                    'pointermove',
                    'pointerup'
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $9080b381e91840d8$export$461939dd4422153)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        }); // Install Modules
        swiper.useModules();
        swiper.emit('_swiper'); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        return swiper;
    }
    var _proto = Swiper.prototype;
    _proto.enable = function enable() {
        var swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    };
    _proto.disable = function disable() {
        var swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    };
    _proto.setProgress = function setProgress(progress, speed) {
        var swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        var min = swiper.minTranslate();
        var max = swiper.maxTranslate();
        var current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    };
    _proto.emitContainerClasses = function emitContainerClasses() {
        var swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        var classes = swiper.el.className.split(' ').filter(function(className) {
            return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', classes.join(' '));
    };
    _proto.getSlideClasses = function getSlideClasses(slideEl) {
        var swiper = this;
        return slideEl.className.split(' ').filter(function(className) {
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    };
    _proto.emitSlidesClasses = function emitSlidesClasses() {
        var swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        var updates = [];
        swiper.slides.each(function(slideEl) {
            var classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    };
    _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
        var swiper = this;
        var params = swiper.params, slides = swiper.slides, slidesGrid = swiper.slidesGrid, swiperSize = swiper.size, activeIndex = swiper.activeIndex;
        var spv = 1;
        if (params.centeredSlides) {
            var slideSize = slides[activeIndex].swiperSlideSize;
            var breakLoop;
            for(var i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(var _i = activeIndex - 1; _i >= 0; _i -= 1)if (slides[_i] && !breakLoop) {
                slideSize += slides[_i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            for(var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1)if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) spv += 1;
        }
        return spv;
    };
    _proto.update = function update() {
        var swiper = this;
        if (!swiper || swiper.destroyed) return;
        var snapGrid = swiper.snapGrid, params = swiper.params; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        var translated;
        if (swiper.params.freeMode) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    };
    _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        var swiper = this;
        var currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each(function(slideEl) {
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    };
    _proto.mount = function mount(el) {
        var swiper = this;
        if (swiper.mounted) return true; // Find el
        var $el = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        var getWrapperSelector = function getWrapperSelector() {
            return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
        };
        var getWrapper = function getWrapper() {
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                var res = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = function(options) {
                    return $el.children(options);
                };
                return res;
            }
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        var $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            var document = (0, $apdun.getDocument)();
            var wrapper = document.createElement('div');
            $wrapperEl = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children("." + swiper.params.slideClass).each(function(slideEl) {
                $wrapperEl.append(slideEl);
            });
        }
        (0, $9080b381e91840d8$export$8b58be045bf06082)(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
            wrongRTL: $wrapperEl.css('display') === '-webkit-box'
        });
        return true;
    };
    _proto.init = function init(el) {
        var swiper = this;
        if (swiper.initialized) return swiper;
        var mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit'); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    };
    _proto.destroy = function destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        var swiper = this;
        var params = swiper.params, $el = swiper.$el, $wrapperEl = swiper.$wrapperEl, slides = swiper.slides;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy'); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr('style');
            $wrapperEl.removeAttr('style');
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
        swiper.emit('destroy'); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach(function(eventName) {
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $9080b381e91840d8$export$8694e5c03a4df8e6)(swiper);
        }
        swiper.destroyed = true;
        return null;
    };
    Swiper.extendDefaults = function extendDefaults(newDefaults) {
        (0, $9080b381e91840d8$export$8b58be045bf06082)($f4b4a3fe2f2f694c$var$extendedDefaults, newDefaults);
    };
    Swiper.installModule = function installModule(module) {
        if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
        var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + (0, $9080b381e91840d8$export$461939dd4422153)();
        Swiper.prototype.modules[name] = module;
    };
    Swiper.use = function use(module) {
        if (Array.isArray(module)) {
            module.forEach(function(m) {
                return Swiper.installModule(m);
            });
            return Swiper;
        }
        Swiper.installModule(module);
        return Swiper;
    };
    $f4b4a3fe2f2f694c$var$_createClass(Swiper, null, [
        {
            key: "extendedDefaults",
            get: function get() {
                return $f4b4a3fe2f2f694c$var$extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return 0, $4326680cc30d98cc$export$2e2bcd8739ae039;
            }
        }
    ]);
    return Swiper;
}();
Object.keys($f4b4a3fe2f2f694c$var$prototypes).forEach(function(prototypeGroup) {
    Object.keys($f4b4a3fe2f2f694c$var$prototypes[prototypeGroup]).forEach(function(protoMethod) {
        $f4b4a3fe2f2f694c$var$Swiper.prototype[protoMethod] = $f4b4a3fe2f2f694c$var$prototypes[prototypeGroup][protoMethod];
    });
});
$f4b4a3fe2f2f694c$var$Swiper.use([
    (0, $a21a3c5c164b1a16$export$2e2bcd8739ae039),
    (0, $ba7be428e15f5125$export$2e2bcd8739ae039)
]);
var $f4b4a3fe2f2f694c$export$2e2bcd8739ae039 = $f4b4a3fe2f2f694c$var$Swiper;



function $f26c1fd9c2cb9754$var$_extends() {
    $f26c1fd9c2cb9754$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f26c1fd9c2cb9754$var$_extends.apply(this, arguments);
}
var $f26c1fd9c2cb9754$var$Navigation = {
    toggleEl: function toggleEl($el, disabled) {
        $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
        if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
    },
    update: function update() {
        // Update Navigation Buttons
        var swiper = this;
        var params = swiper.params.navigation;
        var toggleEl = swiper.navigation.toggleEl;
        if (swiper.params.loop) return;
        var _swiper$navigation = swiper.navigation, $nextEl = _swiper$navigation.$nextEl, $prevEl = _swiper$navigation.$prevEl;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) toggleEl($prevEl, true);
            else toggleEl($prevEl, false);
            if (swiper.params.watchOverflow && swiper.enabled) $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) toggleEl($nextEl, true);
            else toggleEl($nextEl, false);
            if (swiper.params.watchOverflow && swiper.enabled) $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
    },
    onPrevClick: function onPrevClick(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop) return;
        swiper.slidePrev();
    },
    onNextClick: function onNextClick(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop) return;
        swiper.slideNext();
    },
    init: function init() {
        var swiper = this;
        var params = swiper.params.navigation;
        swiper.params.navigation = (0, $9080b381e91840d8$export$f4bbea1d7959d26b)(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        var $nextEl;
        var $prevEl;
        if (params.nextEl) {
            $nextEl = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(params.nextEl);
            if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) $nextEl = swiper.$el.find(params.nextEl);
        }
        if (params.prevEl) {
            $prevEl = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(params.prevEl);
            if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) $prevEl = swiper.$el.find(params.prevEl);
        }
        if ($nextEl && $nextEl.length > 0) $nextEl.on('click', swiper.navigation.onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on('click', swiper.navigation.onPrevClick);
        (0, $9080b381e91840d8$export$8b58be045bf06082)(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    },
    destroy: function destroy() {
        var swiper = this;
        var _swiper$navigation2 = swiper.navigation, $nextEl = _swiper$navigation2.$nextEl, $prevEl = _swiper$navigation2.$prevEl;
        if ($nextEl && $nextEl.length) {
            $nextEl.off('click', swiper.navigation.onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off('click', swiper.navigation.onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
};
var $f26c1fd9c2cb9754$export$2e2bcd8739ae039 = {
    name: 'navigation',
    params: {
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock'
        }
    },
    create: function create() {
        var swiper = this;
        (0, $9080b381e91840d8$export$d2651194ddf43b70)(swiper, {
            navigation: $f26c1fd9c2cb9754$var$_extends({}, $f26c1fd9c2cb9754$var$Navigation)
        });
    },
    on: {
        init: function init(swiper) {
            swiper.navigation.init();
            swiper.navigation.update();
        },
        toEdge: function toEdge(swiper) {
            swiper.navigation.update();
        },
        fromEdge: function fromEdge(swiper) {
            swiper.navigation.update();
        },
        destroy: function destroy(swiper) {
            swiper.navigation.destroy();
        },
        'enable disable': function enableDisable(swiper) {
            var _swiper$navigation3 = swiper.navigation, $nextEl = _swiper$navigation3.$nextEl, $prevEl = _swiper$navigation3.$prevEl;
            if ($nextEl) $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
            if ($prevEl) $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        },
        click: function click(swiper, e) {
            var _swiper$navigation4 = swiper.navigation, $nextEl = _swiper$navigation4.$nextEl, $prevEl = _swiper$navigation4.$prevEl;
            var targetEl = e.target;
            if (swiper.params.navigation.hideOnClick && !(0, $32a1c384014113b9$export$2e2bcd8739ae039)(targetEl).is($prevEl) && !(0, $32a1c384014113b9$export$2e2bcd8739ae039)(targetEl).is($nextEl)) {
                if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
                var isHidden;
                if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
                else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
                if (isHidden === true) swiper.emit('navigationShow');
                else swiper.emit('navigationHide');
                if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
                if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
            }
        }
    }
};



function $4a452f591ded137a$var$_extends() {
    $4a452f591ded137a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4a452f591ded137a$var$_extends.apply(this, arguments);
}
var $4a452f591ded137a$var$Pagination = {
    update: function update() {
        // Render || Update Pagination bullets/items
        var swiper = this;
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el; // Current/Total
        var current;
        var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
        } else if (typeof swiper.snapIndex !== 'undefined') current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            var bullets = swiper.pagination.bullets;
            var firstIndex;
            var lastIndex;
            var midIndex;
            if (params.dynamicBullets) {
                swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
                $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
                    if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (swiper.pagination.dynamicBulletIndex < 0) swiper.pagination.dynamicBulletIndex = 0;
                }
                firstIndex = current - swiper.pagination.dynamicBulletIndex;
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");
            if ($el.length > 1) bullets.each(function(bullet) {
                var $bullet = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(bullet);
                var bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(params.bulletActiveClass + "-main");
                    if (bulletIndex === firstIndex) $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                    if (bulletIndex === lastIndex) $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                }
            });
            else {
                var $bullet = bullets.eq(current);
                var bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    var $firstDisplayedBullet = bullets.eq(firstIndex);
                    var $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(var i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(params.bulletActiveClass + "-main");
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
                            for(var _i = params.dynamicMainBullets; _i >= 0; _i -= 1)bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
                        } else {
                            $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                            $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                        }
                    } else {
                        $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                        $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                    }
                }
            }
            if (params.dynamicBullets) {
                var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
                var offsetProp = rtl ? 'right' : 'left';
                bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
            }
        }
        if (params.type === 'fraction') {
            $el.find((0, $9080b381e91840d8$export$730a8e2ed4fdbe02)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $9080b381e91840d8$export$730a8e2ed4fdbe02)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === 'progressbar') {
            var progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
            else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
            var scale = (current + 1) / total;
            var scaleX = 1;
            var scaleY = 1;
            if (progressbarDirection === 'horizontal') scaleX = scale;
            else scaleY = scale;
            $el.find((0, $9080b381e91840d8$export$730a8e2ed4fdbe02)(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
        }
        if (params.type === 'custom' && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            swiper.emit('paginationRender', $el[0]);
        } else swiper.emit('paginationUpdate', $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    },
    render: function render() {
        // Render Container
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el;
        var paginationHTML = '';
        if (params.type === 'bullets') {
            var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(var i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $9080b381e91840d8$export$730a8e2ed4fdbe02)(params.bulletClass));
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
            $el.html(paginationHTML);
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
            $el.html(paginationHTML);
        }
        if (params.type !== 'custom') swiper.emit('paginationRender', swiper.pagination.$el[0]);
    },
    init: function init() {
        var swiper = this;
        swiper.params.pagination = (0, $9080b381e91840d8$export$f4bbea1d7959d26b)(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
            el: 'swiper-pagination'
        });
        var params = swiper.params.pagination;
        if (!params.el) return;
        var $el = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) $el = swiper.$el.find(params.el);
        if (params.type === 'bullets' && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        if (params.type === 'bullets' && params.dynamicBullets) {
            $el.addClass("" + params.modifierClass + params.type + "-dynamic");
            swiper.pagination.dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === 'progressbar' && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on('click', (0, $9080b381e91840d8$export$730a8e2ed4fdbe02)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            var index = (0, $32a1c384014113b9$export$2e2bcd8739ae039)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        (0, $9080b381e91840d8$export$8b58be045bf06082)(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    },
    destroy: function destroy() {
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
        var $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off('click', (0, $9080b381e91840d8$export$730a8e2ed4fdbe02)(params.bulletClass));
    }
};
var $4a452f591ded137a$export$2e2bcd8739ae039 = {
    name: 'pagination',
    params: {
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: function formatFractionCurrent(number) {
                return number;
            },
            formatFractionTotal: function formatFractionTotal(number) {
                return number;
            },
            bulletClass: 'swiper-pagination-bullet',
            bulletActiveClass: 'swiper-pagination-bullet-active',
            modifierClass: 'swiper-pagination-',
            // NEW
            currentClass: 'swiper-pagination-current',
            totalClass: 'swiper-pagination-total',
            hiddenClass: 'swiper-pagination-hidden',
            progressbarFillClass: 'swiper-pagination-progressbar-fill',
            progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
            clickableClass: 'swiper-pagination-clickable',
            // NEW
            lockClass: 'swiper-pagination-lock'
        }
    },
    create: function create() {
        var swiper = this;
        (0, $9080b381e91840d8$export$d2651194ddf43b70)(swiper, {
            pagination: $4a452f591ded137a$var$_extends({
                dynamicBulletIndex: 0
            }, $4a452f591ded137a$var$Pagination)
        });
    },
    on: {
        init: function init(swiper) {
            swiper.pagination.init();
            swiper.pagination.render();
            swiper.pagination.update();
        },
        activeIndexChange: function activeIndexChange(swiper) {
            if (swiper.params.loop) swiper.pagination.update();
            else if (typeof swiper.snapIndex === 'undefined') swiper.pagination.update();
        },
        snapIndexChange: function snapIndexChange(swiper) {
            if (!swiper.params.loop) swiper.pagination.update();
        },
        slidesLengthChange: function slidesLengthChange(swiper) {
            if (swiper.params.loop) {
                swiper.pagination.render();
                swiper.pagination.update();
            }
        },
        snapGridLengthChange: function snapGridLengthChange(swiper) {
            if (!swiper.params.loop) {
                swiper.pagination.render();
                swiper.pagination.update();
            }
        },
        destroy: function destroy(swiper) {
            swiper.pagination.destroy();
        },
        'enable disable': function enableDisable(swiper) {
            var $el = swiper.pagination.$el;
            if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
        },
        click: function click(swiper, e) {
            var targetEl = e.target;
            if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !(0, $32a1c384014113b9$export$2e2bcd8739ae039)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
                if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
                var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
                if (isHidden === true) swiper.emit('paginationShow');
                else swiper.emit('paginationHide');
                swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
            }
        }
    }
};



// configure Swiper to use modules
(0, $f4b4a3fe2f2f694c$export$2e2bcd8739ae039).use([
    (0, $f26c1fd9c2cb9754$export$2e2bcd8739ae039),
    (0, $4a452f591ded137a$export$2e2bcd8739ae039),
    (0, $50ce1174baac4ab2$export$2e2bcd8739ae039)
]);
class $a52cc7307ee612ff$export$2e2bcd8739ae039 extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    requiredRefs = [
        'container'
    ];
    slider = null;
    constructor(el, componentName){
        super(el, componentName);
        const hasNavigation = this.refs.buttonNext || this.refs.buttonPrev;
        const hasPagination = this.refs.pagination;
        const isAutoplay = !!this.el.dataset.autoplay;
        const defaultOptions = {
            spaceBetween: 10,
            speed: 600,
            loop: false,
            watchOverflow: true,
            autoplay: isAutoplay ? {
                delay: parseInt(this.el.dataset.autoplay, 10) || 3000
            } : false,
            navigation: hasNavigation ? {
                nextEl: this.refs.buttonNext,
                prevEl: this.refs.buttonPrev
            } : false,
            pagination: hasPagination ? {
                el: this.refs.pagination,
                clickable: true,
                type: 'bullets'
            } : false,
            on: {
                afterInit: this.handleChange,
                slideChange: this.handleChange
            }
        };
        const { swiperOptions: swiperOptions } = el.dataset;
        const passedOptions = swiperOptions && JSON.parse(swiperOptions) || {};
        this.options = {
            ...defaultOptions,
            ...passedOptions,
            on: {
                ...passedOptions.on || {},
                ...defaultOptions.on
            }
        };
        this.init();
    }
    getCurrentSlide = (slider)=>{
        const swiperInstace = slider || this.slider;
        return swiperInstace && swiperInstace.slides[swiperInstace.activeIndex];
    };
    init = ()=>{
        this.slider = new (0, $f4b4a3fe2f2f694c$export$2e2bcd8739ae039)(this.refs.container, this.options);
        this.slider.getCurrentSlide = this.getCurrentSlide;
        this.el.slider = this.slider; // expose slider to other components
    };
    handleChange = (slider)=>{
        const currentSlide = this.getCurrentSlide(slider);
        const siblings = [
            currentSlide.nextElementSibling,
            currentSlide.previousElementSibling
        ].filter((el)=>!!el);
        (0, $6e2cf81170476d5a$export$635e15bbd66f01ea)(document.body, (0, $6e2cf81170476d5a$export$2e2bcd8739ae039).TRIGGER_LOAD_LAZY, {
            el: siblings
        });
    };
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('Slider', $a52cc7307ee612ff$export$2e2bcd8739ae039);





class $586fce124b1e5fd3$var$Header extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    requiredRefs = [
        'redboxContainer'
    ];
    constructor(el, componentName){
        super(el, componentName);
        const observer = new ResizeObserver((entries)=>{
            for (let entry of entries){
                const { width: width } = entry.target.getBoundingClientRect(); // need to use getBoundingCR because only that includes paddings.
                // save width of red box container to dochument
                document.documentElement.style.setProperty('--redbox-header-width', `${width}px`);
            }
        });
        observer.observe(this.refs.redboxContainer);
        this.el.addEventListener('mouseleave', this.handleMouseLeave, {
            passive: true
        });
    }
    handleMouseLeave = ()=>{
        (0, $6e2cf81170476d5a$export$635e15bbd66f01ea)(document.body, (0, $6e2cf81170476d5a$export$2e2bcd8739ae039).HEADER_MOUSELEAVE);
    };
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('Header', $586fce124b1e5fd3$var$Header);






const $2d5df31957b001bd$var$TAB_ACTIVE_CLASS = 'active';
const $2d5df31957b001bd$var$TOGGLER_ACTIVE_CLASS = 'active';
const $2d5df31957b001bd$var$TOGGLER_OPEN_CLASS = 'has-open';
function $2d5df31957b001bd$var$bindEscKey(el, fn) {
    const handler = (e)=>{
        e.stopPropagation();
        if (e.key === 'Esc' || e.key === 'Escape') fn(e);
    };
    window.addEventListener('keydown', handler);
    return ()=>window.removeEventListener('keydown', handler); // return function to destroy listener
}
class $2d5df31957b001bd$var$MegaMenu extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    requiredRefs = [
        'redboxContainer'
    ];
    constructor(el, componentName){
        super(el, componentName);
        this.currentActive = null;
        this.dom = {
            tabs: this.el.querySelectorAll('.MegaMenu__tab'),
            togglers: document.querySelectorAll('[ data-megamenu-toggle]')
        };
        // Options for the observer (which mutations to observe)
        const config = {
            attributes: true
        };
        // Create an observer instance linked to the callback function
        this.observer = new MutationObserver((mutationsList, observer)=>{
            // Use traditional 'for loops' for IE 11
            for (const mutation of mutationsList)if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const { target: target } = mutation;
                const isActive = target.classList.contains($2d5df31957b001bd$var$TAB_ACTIVE_CLASS);
                this.handleChange(target, isActive);
            }
        });
        // Start observing the target nodes for configured mutations
        this.dom.tabs.forEach((el)=>this.observer.observe(el, config));
        this.dom.togglers.forEach((el)=>{
            el.addEventListener('mouseenter', this.handleTogglerEnter);
            el.addEventListener('mouseleave', this.handleTogglerLeave);
        });
        document.body.addEventListener((0, $6e2cf81170476d5a$export$2e2bcd8739ae039).HEADER_MOUSELEAVE, this.handleHeaderMouseLeave);
    }
    getAssociatedTogglerOfTab = (tabEl)=>{
        return [
            ...this.dom.togglers
        ].find((toggler)=>tabEl.dataset.tabId === toggler.getAttribute('id'));
    };
    handleHeaderMouseLeave = ()=>{
        if (this.currentActive) this.handleChange();
    };
    handleTogglerEnter = (e)=>{
        e.preventDefault();
        const { target: target } = e;
        const tabId = target.getAttribute('id');
        if (tabId) {
            // A toggler which has a dropdown menu
            target.classList.add($2d5df31957b001bd$var$TOGGLER_ACTIVE_CLASS);
            const targetTab = [
                ...this.dom.tabs
            ].find((tab)=>tab.dataset.tabId === tabId);
            if (targetTab && targetTab !== this.currentActive) targetTab.classList.add($2d5df31957b001bd$var$TAB_ACTIVE_CLASS);
        } else // Toggler without a submenu
        this.handleChange();
    };
    handleTogglerLeave = (e)=>{
        e.preventDefault();
        const { target: target } = e;
        const tabId = target.getAttribute('id');
        if (tabId) target.classList.remove($2d5df31957b001bd$var$TOGGLER_ACTIVE_CLASS);
    };
    handleChange = async (target = null, isActive)=>{
        if (target === null) {
            // close the megamenu
            this.handleHeightChange(0);
            if (this.currentActive) {
                this.animateTabOut(this.currentActive);
                const targetToggler = this.getAssociatedTogglerOfTab(this.currentActive);
                if (targetToggler) targetToggler.classList.remove($2d5df31957b001bd$var$TOGGLER_OPEN_CLASS);
            }
            this.currentActive = null;
            return;
        }
        if (isActive) {
            let newHeight = target.offsetHeight;
            if (this.currentActive) {
                await this.animateTabOut(this.currentActive);
                const targetToggler = this.getAssociatedTogglerOfTab(this.currentActive);
                if (targetToggler) targetToggler.classList.remove($2d5df31957b001bd$var$TOGGLER_OPEN_CLASS);
            }
            this.currentActive = target;
            this.handleHeightChange(newHeight);
            this.animateTabIn(target);
            const targetToggler = this.getAssociatedTogglerOfTab(target);
            if (targetToggler) targetToggler.classList.add($2d5df31957b001bd$var$TOGGLER_OPEN_CLASS);
        }
    };
    animateTabOut = (tabEl)=>{
        const _this = this;
        return (0, $9770947dcdc34a25$export$99ee26438460406a).to(tabEl, {
            autoAlpha: 0
        }).then(()=>{
            if (_this.currentActive !== tabEl) tabEl.classList.remove($2d5df31957b001bd$var$TAB_ACTIVE_CLASS);
        });
    };
    animateTabIn = (tabEl)=>{
        return (0, $9770947dcdc34a25$export$99ee26438460406a).to(tabEl, {
            autoAlpha: 1,
            duration: 0.3,
            ease: 'power2.easeIn'
        });
    };
    handleHeightChange = (height)=>{
        return (0, $9770947dcdc34a25$export$99ee26438460406a).to(this.el, {
            height: height
        });
    };
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('MegaMenu', $2d5df31957b001bd$var$MegaMenu);



function $3a5a9ab03fc24b40$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $3a5a9ab03fc24b40$var$hasPassiveEvents = false;
if (typeof window !== 'undefined') {
    var $3a5a9ab03fc24b40$var$passiveTestOptions = {
        get passive () {
            $3a5a9ab03fc24b40$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener('testPassive', null, $3a5a9ab03fc24b40$var$passiveTestOptions);
    window.removeEventListener('testPassive', null, $3a5a9ab03fc24b40$var$passiveTestOptions);
}
var $3a5a9ab03fc24b40$var$isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
var $3a5a9ab03fc24b40$var$locks = [];
var $3a5a9ab03fc24b40$var$documentListenerAdded = false;
var $3a5a9ab03fc24b40$var$initialClientY = -1;
var $3a5a9ab03fc24b40$var$previousBodyOverflowSetting = void 0;
var $3a5a9ab03fc24b40$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $3a5a9ab03fc24b40$var$allowTouchMove = function allowTouchMove(el) {
    return $3a5a9ab03fc24b40$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $3a5a9ab03fc24b40$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($3a5a9ab03fc24b40$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $3a5a9ab03fc24b40$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($3a5a9ab03fc24b40$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            $3a5a9ab03fc24b40$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = scrollBarGap + 'px';
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($3a5a9ab03fc24b40$var$previousBodyOverflowSetting === undefined) {
        $3a5a9ab03fc24b40$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }
};
var $3a5a9ab03fc24b40$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($3a5a9ab03fc24b40$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $3a5a9ab03fc24b40$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $3a5a9ab03fc24b40$var$previousBodyPaddingRight = undefined;
    }
    if ($3a5a9ab03fc24b40$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $3a5a9ab03fc24b40$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $3a5a9ab03fc24b40$var$previousBodyOverflowSetting = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $3a5a9ab03fc24b40$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $3a5a9ab03fc24b40$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $3a5a9ab03fc24b40$var$initialClientY;
    if ($3a5a9ab03fc24b40$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $3a5a9ab03fc24b40$var$preventDefault(event);
    if ($3a5a9ab03fc24b40$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $3a5a9ab03fc24b40$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $3a5a9ab03fc24b40$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($3a5a9ab03fc24b40$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $3a5a9ab03fc24b40$var$locks = [].concat($3a5a9ab03fc24b40$var$_toConsumableArray($3a5a9ab03fc24b40$var$locks), [
        lock
    ]);
    if ($3a5a9ab03fc24b40$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $3a5a9ab03fc24b40$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $3a5a9ab03fc24b40$var$handleScroll(event, targetElement);
        };
        if (!$3a5a9ab03fc24b40$var$documentListenerAdded) {
            document.addEventListener('touchmove', $3a5a9ab03fc24b40$var$preventDefault, $3a5a9ab03fc24b40$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $3a5a9ab03fc24b40$var$documentListenerAdded = true;
        }
    } else $3a5a9ab03fc24b40$var$setOverflowHidden(options);
};
var $3a5a9ab03fc24b40$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($3a5a9ab03fc24b40$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $3a5a9ab03fc24b40$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($3a5a9ab03fc24b40$var$documentListenerAdded) {
            document.removeEventListener('touchmove', $3a5a9ab03fc24b40$var$preventDefault, $3a5a9ab03fc24b40$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $3a5a9ab03fc24b40$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $3a5a9ab03fc24b40$var$initialClientY = -1;
    } else $3a5a9ab03fc24b40$var$restoreOverflowSetting();
    $3a5a9ab03fc24b40$var$locks = [];
};
var $3a5a9ab03fc24b40$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
        return;
    }
    $3a5a9ab03fc24b40$var$locks = $3a5a9ab03fc24b40$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($3a5a9ab03fc24b40$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($3a5a9ab03fc24b40$var$documentListenerAdded && $3a5a9ab03fc24b40$var$locks.length === 0) {
            document.removeEventListener('touchmove', $3a5a9ab03fc24b40$var$preventDefault, $3a5a9ab03fc24b40$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $3a5a9ab03fc24b40$var$documentListenerAdded = false;
        }
    } else if (!$3a5a9ab03fc24b40$var$locks.length) $3a5a9ab03fc24b40$var$restoreOverflowSetting();
};




// returns the depth of the element "e" relative to element root
// for this calculation only parents with classname = waypoint are considered
function $68d6353aa9c7876c$var$getLevelDepth(el, root, waypoint, cnt) {
    cnt = cnt || 0;
    if (el === root) return cnt;
    if (el.classList.contains(waypoint)) ++cnt;
    return el.parentNode && $68d6353aa9c7876c$var$getLevelDepth(el.parentNode, root, waypoint, cnt);
}
const $68d6353aa9c7876c$var$BACK_CLASS = 'PushMenu__back';
const $68d6353aa9c7876c$var$EVENT_NAME = 'click';
class $68d6353aa9c7876c$var$PushMenu extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    // if menu is open or not
    open = false;
    // level depth
    level = 0;
    constructor(el, componentName){
        super(el, componentName);
        this.dom = {
            trigger: document.querySelector('[data-pushmenu-trigger]'),
            levelBack: [
                ...this.el.querySelectorAll(`.${$68d6353aa9c7876c$var$BACK_CLASS}`)
            ],
            menuItems: [
                ...this.el.querySelectorAll('li')
            ],
            levels: [
                ...this.el.querySelectorAll('.PushMenu__level')
            ]
        };
        this.init();
    }
    init = ()=>{
        // save the depth of each of these level elements
        this.dom.levels.forEach((el, i)=>{
            el.setAttribute('data-level', $68d6353aa9c7876c$var$getLevelDepth(el, this.el, 'PushMenu__level'));
        });
        // initialize / bind the necessary events
        this.initEvents();
    };
    initEvents = ()=>{
        // open (or close) the menu
        this.dom.trigger.addEventListener($68d6353aa9c7876c$var$EVENT_NAME, (e)=>{
            e.stopPropagation();
            e.preventDefault();
            if (this.open) this.closeMenu();
            else this.openMenu();
        });
        // opening a sub level menu
        this.dom.menuItems.forEach((el, i)=>{
            // check if it has a sub level
            const subLevel = el.querySelector('.PushMenu__level');
            if (subLevel) el.querySelector('a').addEventListener($68d6353aa9c7876c$var$EVENT_NAME, (ev)=>{
                ev.preventDefault();
                const level = el.closest('.PushMenu__level').getAttribute('data-level');
                if (this.level <= level) {
                    ev.stopPropagation();
                    el.closest('.PushMenu__level').classList.add('PushMenu__level--overlayed');
                    this.openMenu(subLevel);
                }
            });
        });
        // by clicking on a specific element
        this.dom.levelBack.forEach((el, i)=>{
            el.addEventListener($68d6353aa9c7876c$var$EVENT_NAME, (e)=>{
                e.preventDefault();
                const { level: level } = el.closest('.PushMenu__level').dataset;
                if (this.level <= level) {
                    e.stopPropagation();
                    this.level = el.closest('.PushMenu__level').getAttribute('data-level') - 1;
                    this.level === 0 ? this.closeMenu() : this.closeLevel();
                }
            });
        });
    };
    openMenu = (subLevel)=>{
        // increment level depth
        ++this.level;
        const currentLevelEl = subLevel || this.dom.levels[0];
        if (this.level === 1) {
            this.open = true;
            (0, $9770947dcdc34a25$export$99ee26438460406a).to(this.el, {
                xPercent: 0,
                x: 0
            });
            this.togglerOpen();
            console.log(this.dom.levels[0]);
            const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
            const navItemsTarget = this.dom.levels[0].parentElement.querySelectorAll('[data-level="1"] > ul > li');
            tl.from(navItemsTarget, {
                duration: 0.6,
                opacity: 0,
                x: -120,
                stagger: 0.13,
                transition: 'none',
                clearProps: 'all',
                ease: 'power2.easeOut'
            }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations);
            ;
        }
        currentLevelEl.classList.add('is-open');
        (0, $3a5a9ab03fc24b40$export$45a3ef215b2a5866)();
        (0, $3a5a9ab03fc24b40$export$24fdf68abf432c44)(currentLevelEl);
    };
    closeMenu = ()=>{
        this.level = 0;
        this.toggleLevels();
        this.togglerClose();
        (0, $9770947dcdc34a25$export$99ee26438460406a).to(this.el, {
            xPercent: -100
        });
        (0, $3a5a9ab03fc24b40$export$45a3ef215b2a5866)();
        this.open = false;
    };
    closeLevel = ()=>{
        this.toggleLevels();
    };
    toggleLevels = ()=>{
        for(let i = 0, len = this.dom.levels.length; i < len; ++i){
            const levelEl = this.dom.levels[i];
            if (levelEl.getAttribute('data-level') >= this.level + 1) {
                // level close
                levelEl.classList.remove('is-open');
                levelEl.classList.remove('PushMenu__level--overlayed');
                (0, $3a5a9ab03fc24b40$export$e5d0524c3725571e)(levelEl);
            } else if (parseInt(levelEl.getAttribute('data-level')) === this.level) {
                // closing to previous level
                levelEl.classList.remove('PushMenu__level--overlayed');
                (0, $3a5a9ab03fc24b40$export$24fdf68abf432c44)(levelEl);
            }
        }
    };
    togglerOpen = ()=>{
        const targets = this.dom.trigger.querySelectorAll('.bar');
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        tl.to(targets[0], {
            y: 5,
            duration: .075
        }, 0);
        tl.to(targets[0], {
            duration: .075,
            delay: .12,
            rotate: '45deg',
            transformOrigin: 'center',
            opacity: 0
        }, 0);
        tl.to(targets[1], {
            duration: .075,
            delay: .12,
            rotate: '45deg',
            transformOrigin: 'center'
        }, 0);
        tl.to(targets[2], {
            y: -5,
            duration: .075
        }, 0);
        tl.to(targets[2], {
            duration: .075,
            delay: .12,
            rotate: '-45deg',
            transformOrigin: 'center'
        }, 0);
        tl.duration(.5);
        return tl;
    };
    togglerClose = ()=>{
        const targets = this.dom.trigger.querySelectorAll('.bar');
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        tl.to(targets[0], {
            y: 0,
            delay: .12,
            duration: .075
        }, 0);
        tl.to(targets[0], {
            duration: .075,
            rotate: '0deg',
            transformOrigin: 'center',
            opacity: 1
        }, 0);
        tl.to(targets[1], {
            duration: .075,
            rotate: '0deg',
            transformOrigin: 'center'
        }, 0);
        tl.to(targets[2], {
            y: 0,
            delay: .12,
            duration: .075
        }, 0);
        tl.to(targets[2], {
            duration: .075,
            rotate: '-0deg',
            transformOrigin: 'center'
        }, 0);
        tl.duration(.5);
        return tl;
    };
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('PushMenu', $68d6353aa9c7876c$var$PushMenu);





class $17b01b0f2624846d$var$AboutHero extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        return [
            {
                targets: this.el,
                onInViewport: ()=>{
                    const contentTargets = this.el.querySelector('.AboutHero__content').children;
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(contentTargets, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const imageTarget = this.el.querySelector('.AboutHero__image');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(imageTarget, {
                        duration: 0.6,
                        opacity: 0,
                        x: 60,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('AboutHero', $17b01b0f2624846d$var$AboutHero);





class $4f6761c8b648f124$var$AboutServices extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    constructor(el, componentName){
        super(el, componentName);
        this.dom = {
            button: this.el.querySelector('.Button')
        };
    }
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el.querySelectorAll('.AboutServices__service'),
                onInViewport: (target)=>{
                    tl.from(target, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('AboutServices', $4f6761c8b648f124$var$AboutServices);





class $a7919923785f5adf$var$AboutTimeline extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el.querySelectorAll('.AboutTimeline__event'),
                onInViewport: (target)=>{
                    const targetTl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
                    const elements = {
                        circle: target.querySelector('.AboutTimeline__circle'),
                        content: target.querySelector('.AboutTimeline__event-content'),
                        figure: target.querySelector('figure')
                    };
                    targetTl.from(elements.circle, {
                        duration: 0.3,
                        scale: 0,
                        borderWidth: '28px',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    targetTl.from(target, {
                        duration: 0.2,
                        clearProps: 'all',
                        "--horizontal-line-scale": 0
                    });
                    targetTl.from([
                        elements.content,
                        elements.figure
                    ], {
                        duration: 0.5,
                        opacity: 0,
                        y: 60,
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    }, '>-0.1');
                    tl.add(targetTl, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('AboutTimeline', $a7919923785f5adf$var$AboutTimeline);





const $8a4bc28271890420$export$e5fcfdba4a8ae715 = {
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error'
};
class $8a4bc28271890420$export$2e2bcd8739ae039 extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    requiredRefs = [
        'form'
    ];
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    const inputsTarget = target.querySelector('.Form__inputs .row').children;
                    tl.from(inputsTarget, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0'); // stagger 0.13s with independent reveal animations);
                }
            }
        ];
    }
    constructor(el, componentName){
        super(el, componentName);
        this.init();
    }
    // override from a specific implementation.
    onSubmit() {}
    displayMessage({ type: type = $8a4bc28271890420$export$e5fcfdba4a8ae715.SUCCESS, message: message = null } = {}) {
        const { messageContainer: messageContainer } = this.refs;
        if (messageContainer) {
            if (!message) {
                // clear all
                Object.values($8a4bc28271890420$export$e5fcfdba4a8ae715).forEach((className)=>messageContainer.classList.remove(className));
                messageContainer.innerHTML = '';
                return;
            }
            messageContainer.classList.add(type);
            messageContainer.innerHTML = message;
        }
    }
    _handleSubmit = async (e)=>{
        e.preventDefault();
        const formData = new FormData(this.refs.form);
        await this.onSubmit(formData, e);
    };
    init = ()=>{
        this.refs.form.addEventListener('submit', this._handleSubmit);
    };
}


const $b03a5dd872522e8b$var$DEFAULT_HEADERS = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
};
async function $b03a5dd872522e8b$export$644d8ea042df96a6(endpoint, options) {
    const _options = {
        // although this is the default behavior according to the spec
        // firefox does not send the cookies without this explicit flag
        credentials: 'same-origin',
        ...options,
        headers: {
            ...$b03a5dd872522e8b$var$DEFAULT_HEADERS,
            ...options.headers
        }
    };
    const res = await fetch(`${endpoint}`, _options);
    // handle json responses
    if (res.status === 204) res.data = null;
    else if ((_options.headers || {}).Accept === 'application/json' && res.headers.get('Content-Type') === 'application/json') res.data = await res.json();
    // Ok request
    if (!res.ok) throw res;
    return res;
}


const $3697377c1018b338$var$MAKE_ENDPOINT = 'https://hook.eu1.make.com/ed05hvf294dt4mw84vc5m4lse7xlc4a3';
class $3697377c1018b338$var$CareerContactForm extends (0, $8a4bc28271890420$export$2e2bcd8739ae039) {
    async onSubmit(formData) {
        // compose e-mail message
        const fromName = formData.get('fromName');
        const fromEmailAddress = formData.get('fromEmailAddress');
        const fromPhone = formData.get('fromPhone');
        const wantedPosition = formData.get('wantedPosition');
        const message = formData.get('message');
        const messageSubject = `\u{1F6A8} Nov\xfd z\xe1jemce o pr\xe1ci z webov\xfdch str\xe1nek www.fkservis.cz (${fromName})`;
        const messageBody = `
            Dobr\xfd den, <br/> <br/>
            pan/\xed <b>${fromName}</b> m\xe1 z\xe1jem o pracovn\xed pozici <b>${wantedPosition}</b> a p\u{159}ikl\xe1d\xe1 n\xe1sleduj\xedc\xed zpr\xe1vu: <br/><br/> 
            \u{201E}<i>${message}</i>\u{201D} <br/><br/> 
            Pros\xedm, kontaktujte co nejd\u{159}\xedve z\xe1jemce na e-mailov\xe9 adrese: <b>${fromEmailAddress}</b> nebo telefonn\xedm \u{10D}\xedsle: <b>${fromPhone}</b>.
        `;
        try {
            const { data: data } = await (0, $b03a5dd872522e8b$export$644d8ea042df96a6)($3697377c1018b338$var$MAKE_ENDPOINT, {
                method: 'POST',
                body: JSON.stringify({
                    messageSubject: messageSubject,
                    messageBody: messageBody
                })
            });
            console.log('Data received: ', data);
            this.refs.form.reset();
            this.displayMessage({
                message: "D\u011Bkujeme, va\u0161e zpr\xe1va k n\xe1m \xfasp\u011B\u0161n\u011B dorazila. V nejbli\u017E\u0161\xedm mo\u017En\xe9m term\xednu v\xe1m odpov\xedme.\n"
            });
        } catch (errResponse) {
            console.error(errResponse);
            this.displayMessage({
                type: (0, $8a4bc28271890420$export$e5fcfdba4a8ae715).ERROR,
                message: "P\u0159i odes\xedl\xe1n\xed formul\xe1\u0159e se stala chyba"
            });
        // handle error
        // const {status, data, message} = errResponse;
        }
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('CareerContactForm', $3697377c1018b338$var$CareerContactForm);





class $cefa70332f663b47$var$CareerOpenPositionsList extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        return [
            {
                targets: this.el.querySelectorAll('.OpenPosition'),
                onInViewport: (target)=>{
                    const contentTargets = target.querySelector('.OpenPosition__content').children;
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(contentTargets, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const imageTarget = target.querySelector('.OpenPosition__image');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(imageTarget, {
                        duration: 0.6,
                        opacity: 0,
                        y: 60,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const bgTarget = target.querySelector('.OpenPosition__bg');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(bgTarget, {
                        duration: 1.2,
                        backgroundColor: '#FFFFFF',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('CareerOpenPositionsList', $cefa70332f663b47$var$CareerOpenPositionsList);





class $3ae5c5c9a89e4542$var$CommonBreadcrumbs extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el.querySelectorAll('li'),
                onInViewport: (target)=>{
                    tl.from(target, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations);
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('CommonBreadcrumbs', $3ae5c5c9a89e4542$var$CommonBreadcrumbs);





class $8da029445fd99adb$var$CommonCaption extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        return [
            {
                targets: this.el,
                onInViewport: ()=>{
                    const contentTargets = this.el.querySelector('.CaptionBox__content-wrapper').children;
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(contentTargets, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const bgTarget = this.el.querySelector('.CaptionBox__content-wrapper');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(bgTarget, {
                        duration: 1.2,
                        borderWidth: 0,
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('CaptionBox', $8da029445fd99adb$var$CommonCaption);




class $367e3f5e61820375$var$CommonFaq extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    constructor(el, componentName){
        super(el, componentName);
        this.init();
    }
    init = ()=>{
        let acc = document.getElementsByClassName("faq-question");
        let i;
        for(i = 0; i < acc.length; i++)acc[i].addEventListener("click", function() {
            this.classList.toggle("active");
            let panel = this.nextElementSibling;
            if (panel.style.maxHeight) panel.style.maxHeight = null;
            else panel.style.maxHeight = panel.scrollHeight + "px";
        });
    };
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('CommonFaq', $367e3f5e61820375$var$CommonFaq);





class $9554ca9caab4efaa$var$CommonHeading extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(target.querySelectorAll('.CommonHeading__heading'), {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('CommonHeading', $9554ca9caab4efaa$var$CommonHeading);



var $c288780dc0df6e37$exports = {};
/*
 * Copyright (c) 2012 Adobe Systems Incorporated. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License. *
 */ /**
 * balancetext.js
 *
 * Author: Randy Edmunds
 */ /* global define, module */ /*
 * Copyright (c) 2007-2009 unscriptable.com and John M. Hann
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the “Software”), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 *
 * Except as contained in this notice, the name(s) of the above
 * copyright holders (unscriptable.com and John M. Hann) shall not be
 * used in advertising or otherwise to promote the sale, use or other
 * dealings in this Software without prior written authorization.
 *
 * http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
 *
 * Tested to work on (lowest browser):
 * - Sarari 4
 * - Chrome 16
 * - Firefox 10
 * - IE 9
 * - Edge 13
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) define([], factory);
    else if ($c288780dc0df6e37$exports) $c288780dc0df6e37$exports = factory();
    else root.balanceText = factory();
})($c288780dc0df6e37$exports, ()=>{
    /**
     * Line breaking global vars
     */ let breakMatches, wsnwMatches, wsnwOffset;
    /**
     * Selectors and elements to watch;
     * calling $.balanceText(elements) adds "elements" to this list.
     */ const watching = {
        sel: [],
        el: []
    };
    /**
     * Have handlers been initialized?
     */ let handlersInitialized = false;
    /**
     * Is this a polyfill?
     */ let polyfilled = false;
    /**
     * Do nothing
     */ function noop() {}
    /**
     * Loop that works with array-likes
     * @param {Array-like} elements - List of elements to run a function on
     * @param {Function}   callback - The function to call on each supplied element
     */ function forEach(elements, callback) {
        Array.prototype.forEach.call(elements, callback);
    }
    /**
     * Polyfill for $(document).ready()
     *
     * @param {Function} fn - The function to execute when the document is ready
     */ function ready(fn) {
        if (document.readyState !== "loading") fn();
        else if (document.addEventListener) document.addEventListener("DOMContentLoaded", fn);
        else document.attachEvent("onreadystatechange", ()=>{
            if (document.readyState !== "loading") fn();
        });
    }
    /**
     * Debounces a function over a threshold
     *
     * @param {Function} func      - The function to debounce
     * @param {number}   threshold - time in ms
     * @param {boolean}  execAsap  - when true, execute immediately
     * @param args
     * @return {Function} Debounced function
     */ function debounce(func, threshold, execAsap, ...args) {
        let timeout;
        return function() {
            const obj = this;
            function delayed() {
                if (!execAsap) func.apply(obj, args);
                timeout = null;
            }
            if (timeout) clearTimeout(timeout);
            else if (execAsap) func.apply(obj, args);
            timeout = setTimeout(delayed, threshold || 100);
        };
    }
    /**
     * Determine whether the document supports TextWrap
     * @return {boolean}
     */ function hasTextWrap() {
        if (typeof window === "undefined") return false;
        const { style: style } = document.documentElement;
        return style.textWrap || style.WebkitTextWrap || style.MozTextWrap || style.MsTextWrap;
    }
    /**
     * Object for tracking next whitespace params
     */ // eslint-disable-next-line camelcase
    function NextWS_params() {
        this.reset();
    }
    NextWS_params.prototype.reset = function() {
        this.index = 0;
        this.width = 0;
    };
    /**
     * Check if index is contained in previously calculated list of white-space:nowrap ranges
     *
     * @param {number} index - the index of the character to check
     * @return {boolean}
     */ function isWhiteSpaceNoWrap(index) {
        // Is index inside 1 of the ranges?
        // start and end are breakable, but not inside range
        return wsnwMatches.some((range)=>range.start < index && index < range.end);
    }
    /**
     * Recursively calculate white-space:nowrap offsets for line.
     *
     * @param {Node}    el         - the element to act on
     * @param {boolean} includeTag - include length of tag itself
     */ function recursiveCalcNoWrapOffsetsForLine(el, includeTag) {
        if (el.nodeType === el.ELEMENT_NODE) {
            // Found an embedded tag
            const style = window.getComputedStyle(el);
            if (style.whiteSpace === "nowrap") {
                // Tag with white-space:nowrap - add match, skip children
                const len = el.outerHTML.length;
                wsnwMatches.push({
                    start: wsnwOffset,
                    end: wsnwOffset + len
                });
                wsnwOffset += len;
            } else {
                // Tag without white-space:nowrap - recursively check children of tag
                forEach(el.childNodes, (child)=>{
                    recursiveCalcNoWrapOffsetsForLine(child, true);
                });
                if (includeTag) // Length of opening tag, attributes, and closing tag
                wsnwOffset += el.outerHTML.length - el.innerHTML.length;
            }
        } else if (el.nodeType === el.COMMENT_NODE) wsnwOffset += el.length + 7; // delimiter: <!-- -->
        else if (el.nodeType === el.PROCESSING_INSTRUCTION_NODE) wsnwOffset += el.length + 2; // delimiter: < >
        else // Text node: add length
        wsnwOffset += el.length;
    }
    /**
     * Calculate white-space:nowrap offsets for line.
     *
     * @param {Node}    el             - the element to act on
     * @param {string}  oldWS          - "old" whitespace setting for temporarily resetting
     * @param {number}  lineCharOffset - char offset of current line from start of text
     */ function calcNoWrapOffsetsForLine(el, oldWS, lineCharOffset) {
        // For first line (lineCharOffset === 0), calculate start and end offsets for each
        // white-space:nowrap element in the line.
        if (lineCharOffset === 0) {
            // Reset whiteSpace setting when breakMatches is being calculated
            // so white-space:nowrap can be detected in text
            el.style.whiteSpace = oldWS;
            wsnwOffset = 0;
            wsnwMatches = [];
            recursiveCalcNoWrapOffsetsForLine(el, false);
            // Restore temporary whitespace setting to recalc width
            el.style.whiteSpace = "nowrap";
        } else {
            // For all other lines, update the offsets for current line
            // 1. Ignore matches less than offset
            // 2. Subtract offset from remaining matches
            const newMatches = [];
            wsnwMatches.forEach((match)=>{
                if (match.start > lineCharOffset) newMatches.push({
                    start: match.start - lineCharOffset,
                    end: match.end - lineCharOffset
                });
            });
            wsnwMatches = newMatches;
        }
    }
    /**
     * Strip balance-text tags from an element inserted in previous run
     *
     * @param {Node} el - the element to act on
     */ function removeTags(el) {
        // Remove soft-hyphen breaks
        let brs = el.querySelectorAll('br[data-owner="balance-text-hyphen"]');
        forEach(brs, (br)=>{
            br.outerHTML = "";
        });
        // Replace other breaks with whitespace
        brs = el.querySelectorAll('br[data-owner="balance-text"]');
        forEach(brs, (br)=>{
            br.outerHTML = " ";
        });
        // Restore hyphens inserted for soft-hyphens
        let spans = el.querySelectorAll('span[data-owner="balance-text-softhyphen"]');
        if (spans.length > 0) forEach(spans, (span)=>{
            const textNode = document.createTextNode("\u00ad");
            span.parentNode.insertBefore(textNode, span);
            span.parentNode.removeChild(span);
        });
        // Remove spans inserted for justified text
        spans = el.querySelectorAll('span[data-owner="balance-text-justify"]');
        if (spans.length > 0) {
            let txt = "";
            forEach(spans, (span)=>{
                txt += span.textContent;
                span.parentNode.removeChild(span);
            });
            el.innerHTML = txt;
        }
    }
    /**
     * Checks to see if we should justify the balanced text with the
     * element based on the textAlign property in the computed CSS
     *
     * @param {Node} el - element to check
     * @return {boolean}
     */ const isJustified = function(el) {
        const style = el.currentStyle || window.getComputedStyle(el, null);
        return style.textAlign === "justify";
    };
    /**
     * Add whitespace after words in text to justify the string to
     * the specified size.
     * @param {Node}    el       - the element to justify
     * @param {string}  txt      - text string
     * @param {number}  conWidth - container width
     * @return {string} Justified text
     */ function justify(el, txt, conWidth) {
        txt = txt.trim();
        const words = txt.split(" ").length;
        txt = `${txt} `;
        // if we don't have at least 2 words, no need to justify.
        if (words < 2) return txt;
        // Find width of text in the DOM
        const tmp = document.createElement("span");
        tmp.innerHTML = txt;
        el.appendChild(tmp);
        const size = tmp.offsetWidth;
        tmp.parentNode.removeChild(tmp);
        // Figure out our word spacing and return the element
        const wordSpacing = Math.floor((conWidth - size) / (words - 1));
        tmp.style.wordSpacing = `${wordSpacing}px`;
        tmp.setAttribute("data-owner", "balance-text-justify");
        const div = document.createElement("div");
        div.appendChild(tmp);
        return div.innerHTML;
    }
    /**
     * Returns true iff char at index is a break char outside of HTML < > tags.
     * Break char can be: whitespace (except non-breaking-space: u00a0),
     * hypen, emdash (u2014), endash (u2013), or soft-hyphen (u00ad).
     *
     * @param {string} txt   - the text to check
     * @param {number} index - the index of the character to check
     * @return {boolean}
     */ function isBreakChar(txt, index) {
        const re = /([^\S\u00a0]|-|\u2014|\u2013|\u00ad)(?![^<]*>)/g;
        let match;
        if (!breakMatches) {
            // Only calc break matches once per line
            breakMatches = [];
            match = re.exec(txt);
            while(match !== null){
                if (!isWhiteSpaceNoWrap(match.index)) breakMatches.push(match.index);
                match = re.exec(txt);
            }
        }
        return breakMatches.indexOf(index) !== -1;
    }
    /**
     * In the current implementation, an index is a break
     * opportunity in txt iff it is:
     * - 0 or txt.length
     * - index of a non-whitespace char immediately preceded by a
     *   whitespace, hyphen, soft-hyphen, em-dash, or en-dash char.
     *
     * Thus, it doesn't honour "white-space" or any other Unicode
     * line-breaking classes.)
     *
     * @precondition 0 <= index && index <= txt.length
     *
     * @param {string} txt   - the text to check
     * @param {number} index - the index to check
     * @return {boolean}
     */ function isBreakOpportunity(txt, index) {
        return index === 0 || index === txt.length || isBreakChar(txt, index - 1) && !isBreakChar(txt, index);
    }
    /**
     * Finds the first break opportunity (@see isBreakOpportunity)
     * in txt that's both after-or-equal-to index c in the direction dir
     * and resulting in line width equal to or past clamp(desWidth,
     * 0, conWidth) in direction dir.  Sets ret.index and ret.width
     * to the corresponding index and line width (from the start of
     * txt to ret.index).
     *
     * @param {Node}    el       - element
     * @param {string}  txt      - text string
     * @param {number}  conWidth - container width
     * @param {number}  desWidth - desired width
     * @param {number}  dir      - direction (-1 or +1)
     * @param {number}  c        - char index (0 <= c && c <= txt.length)
     * @param {Object}  ret      - return {index: {number}, width: {number}} of previous/next break
     */ function findBreakOpportunity(el, txt, conWidth, desWidth, dir, c, ret) {
        let w;
        if (txt && typeof txt === "string") for(;;){
            while(!isBreakOpportunity(txt, c))c += dir;
            el.innerHTML = txt.substr(0, c);
            w = el.offsetWidth;
            if (dir < 0) {
                if (w <= desWidth || w <= 0 || c === 0) break;
            } else if (desWidth <= w || conWidth <= w || c === txt.length) break;
            c += dir;
        }
        ret.index = c;
        ret.width = w;
    }
    /**
     * Detects the width of a non-breaking space character, given the height of
     * the element with no-wrap applied.
     *
     * @param {Node}   el - element
     * @param {number} h  - height
     * @return {number}
     */ function getSpaceWidth(el, h) {
        const container = document.createElement("div");
        container.style.display = "block";
        container.style.position = "absolute";
        container.style.bottom = 0;
        container.style.right = 0;
        container.style.width = 0;
        container.style.height = 0;
        container.style.margin = 0;
        container.style.padding = 0;
        container.style.visibility = "hidden";
        container.style.overflow = "hidden";
        const space = document.createElement("span");
        space.style.fontSize = "2000px";
        space.innerHTML = "&nbsp;";
        container.appendChild(space);
        el.appendChild(container);
        const dims = space.getBoundingClientRect();
        container.parentNode.removeChild(container);
        const spaceRatio = dims.height / dims.width;
        return h / spaceRatio;
    }
    /**
     * Get a list of elements regardless of input
     *
     * @param {string|Node|Array-like} elements - The selector to query, one or more elements
     * @return {Array<{Node}>}
     */ function getElementsList(elements) {
        if (!elements) return [];
        // is selector
        if (typeof elements === "string") return document.querySelectorAll(elements);
        // is single element
        if (elements.tagName && elements.querySelectorAll) return [
            elements
        ];
        return elements;
    }
    /**
     *  When a browser has native support for the text-wrap property,
     * the text balanceText plugin will let the browser handle it natively,
     * otherwise it will apply its own text balancing code.
     *
     * @param {string|Node|Array-like} elements - the list of elements to balance
     */ function balanceText(elements) {
        forEach(getElementsList(elements), (el)=>{
            // In a lower level language, this algorithm takes time
            // comparable to normal text layout other than the fact
            // that we do two passes instead of one, so we should
            // be able to do without this limit.
            const maxTextWidth = 5000;
            // strip balance-text generated tags
            removeTags(el);
            // save settings
            const oldWS = el.style.whiteSpace;
            const oldFloat = el.style.float;
            const oldDisplay = el.style.display;
            const oldPosition = el.style.position;
            const oldLH = el.style.lineHeight;
            // remove line height before measuring container size
            el.style.lineHeight = "normal";
            const containerWidth = el.offsetWidth;
            const containerHeight = el.offsetHeight;
            // temporary settings
            el.style.whiteSpace = "nowrap";
            el.style.float = "none";
            el.style.display = "inline";
            el.style.position = "static";
            let nowrapWidth = el.offsetWidth;
            const nowrapHeight = el.offsetHeight;
            // An estimate of the average line width reduction due
            // to trimming trailing space that we expect over all
            // lines other than the last.
            const spaceWidth = oldWS === "pre-wrap" ? 0 : getSpaceWidth(el, nowrapHeight);
            if (containerWidth > 0 && // prevent divide by zero
            nowrapWidth > containerWidth && // text is more than 1 line
            nowrapWidth < maxTextWidth) {
                let remainingText = el.innerHTML;
                let newText = "";
                let lineText = "";
                const shouldJustify = isJustified(el);
                const totLines = Math.round(containerHeight / nowrapHeight);
                let remLines = totLines;
                let lineCharOffset = 0;
                // loop vars
                let desiredWidth, guessIndex, le, ge, splitIndex, isHyphen, isSoftHyphen;
                // Determine where to break:
                while(remLines > 1){
                    // clear whitespace match cache for each line
                    breakMatches = null;
                    // Must calc white-space:nowrap offsets before first call to findBreakOpportunity()
                    calcNoWrapOffsetsForLine(el, oldWS, lineCharOffset);
                    desiredWidth = Math.round((nowrapWidth + spaceWidth) / remLines - spaceWidth);
                    // Guessed char index
                    guessIndex = Math.round((remainingText.length + 1) / remLines) - 1;
                    le = new NextWS_params();
                    // Find a breaking space somewhere before (or equal to) desired width,
                    // not necessarily the closest to the desired width.
                    findBreakOpportunity(el, remainingText, containerWidth, desiredWidth, -1, guessIndex, le);
                    // Find first breaking char after (or equal to) desired width.
                    ge = new NextWS_params();
                    guessIndex = le.index;
                    findBreakOpportunity(el, remainingText, containerWidth, desiredWidth, 1, guessIndex, ge);
                    // Find first breaking char before (or equal to) desired width.
                    le.reset();
                    guessIndex = ge.index;
                    findBreakOpportunity(el, remainingText, containerWidth, desiredWidth, -1, guessIndex, le);
                    // Find closest string to desired length
                    if (le.index === 0) splitIndex = ge.index;
                    else if (containerWidth < ge.width || le.index === ge.index) splitIndex = le.index;
                    else splitIndex = Math.abs(desiredWidth - le.width) < Math.abs(ge.width - desiredWidth) ? le.index : ge.index;
                    // Break string
                    lineText = remainingText.substr(0, splitIndex).replace(/\s$/, "");
                    isSoftHyphen = Boolean(lineText.match(/\u00ad$/));
                    if (isSoftHyphen) // Replace soft-hyphen causing break with explicit hyphen
                    lineText = lineText.replace(/\u00ad$/, '<span data-owner="balance-text-softhyphen">-</span>');
                    if (shouldJustify) newText += justify(el, lineText, containerWidth);
                    else {
                        newText += lineText;
                        isHyphen = isSoftHyphen || Boolean(lineText.match(/(-|\u2014|\u2013)$/));
                        newText += isHyphen ? '<br data-owner="balance-text-hyphen" />' : '<br data-owner="balance-text" />';
                    }
                    remainingText = remainingText.substr(splitIndex);
                    lineCharOffset = splitIndex;
                    // update counters
                    remLines--;
                    el.innerHTML = remainingText;
                    nowrapWidth = el.offsetWidth;
                }
                if (shouldJustify) el.innerHTML = newText + justify(el, remainingText, containerWidth);
                else el.innerHTML = newText + remainingText;
            }
            // restore settings
            el.style.whiteSpace = oldWS;
            el.style.float = oldFloat;
            el.style.display = oldDisplay;
            el.style.position = oldPosition;
            el.style.lineHeight = oldLH;
        });
    }
    /**
     * Call the balanceText plugin on elements that it's watching.
     */ function updateWatched() {
        const selectors = watching.sel.join(",");
        const selectedElements = getElementsList(selectors);
        const elements = Array.prototype.concat.apply(watching.el, selectedElements);
        balanceText(elements);
    }
    /**
     * Initialize the events for which to re-apply BalanceText.  They are:
     * - Document ready
     * - Document full load
     * - Window resize
     */ function initHandlers() {
        if (handlersInitialized) return;
        // Apply on DOM ready
        ready(updateWatched);
        // Reapply on full load
        window.addEventListener("load", updateWatched);
        // Reapply on resize
        window.addEventListener("resize", debounce(updateWatched));
        handlersInitialized = true;
    }
    /**
     * Apply the BalanceText routine on the document and watch the list
     * of elements.  On window resize, re-apply BalanceText to the given elements
     *
     * @param {string|Node|Array-like} elements - the elements to watch after applying BalanceText
     */ function balanceTextAndWatch(elements) {
        if (typeof elements === "string") watching.sel.push(elements);
        else forEach(getElementsList(elements), (el)=>{
            watching.el.push(el);
        });
        initHandlers();
        updateWatched();
    }
    /**
     * Stop watching elements
     *
     * @param {string|Node|Array-like} elements
     */ function unwatch(elements) {
        if (typeof elements === "string") watching.sel = watching.sel.filter((el)=>el !== elements);
        else {
            elements = getElementsList(elements);
            watching.el = watching.el.filter((el)=>elements.indexOf(el) === -1);
        }
    }
    /**
     * Treat this app as a polyfill.  Watch for changes to the .balance-text selector
     */ function polyfill() {
        if (polyfilled) return;
        watching.sel.push(".balance-text");
        initHandlers();
        polyfilled = true;
    }
    /**
     * Public interface
     *
     * @param {string|Node|Array-like} elements - elements to balance
     * @param {Object}                 options  - processing options
     *  - {boolean} watch - watch elements for resize
     */ function publicInterface(elements, options) {
        if (!elements) // empty call means polyfill (watch for changes)
        polyfill();
        else if (options && options.watch === true) balanceTextAndWatch(elements);
        else if (options && options.watch === false) unwatch(elements);
        else balanceText(elements);
    }
    publicInterface.updateWatched = updateWatched;
    if (hasTextWrap()) {
        noop.updateWatched = noop;
        return noop;
    }
    return publicInterface;
});




class $c00eda03da420472$var$CommonHeadline extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    constructor(el, componentName){
        super(el, componentName);
        (0, (/*@__PURE__*/$parcel$interopDefault($c288780dc0df6e37$exports)))();
    }
    get revealAnimations() {
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    let targets = [];
                    if (target.querySelector('.Headline__tagline')) targets.push(target.querySelector('.Headline__tagline'));
                    if (target.querySelector('.Headline__heading')) targets.push(target.querySelector('.Headline__heading'));
                    if (target.querySelector('.Headline__description')) targets.push(target.querySelector('.Headline__description'));
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(targets, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('Headline', $c00eda03da420472$var$CommonHeadline);





const $35c2373f034fb739$var$MAKE_ENDPOINT = 'https://hook.eu1.make.com/m1xyuwnw3i1n7jn66yuq3qnncaskaqif';
class $35c2373f034fb739$var$CommonLightContactForm extends (0, $8a4bc28271890420$export$2e2bcd8739ae039) {
    async onSubmit(formData) {
        // compose e-mail message
        const emailAddressOrPhone = formData.get('emailAddressOrPhone');
        const messageSubject = `\u{1F6A8} Nov\xfd kontakt z webov\xfdch str\xe1nek www.fkservis.cz (${emailAddressOrPhone})`;
        const messageBody = `Dobr\xfd den, <br/> <br/> n\u{11B}kdo m\xe1 z\xe1jem o na\u{161}e slu\u{17E}by. Pros\xedm, kontaktujte co nejd\u{159}\xedve z\xe1kazn\xedka na telefonn\xedm \u{10D}\xedsle nebo e-mailov\xe9 adrese: <b>${emailAddressOrPhone}</b>. <br/><br/> D\u{11B}kuji!`;
        try {
            const { data: data } = await (0, $b03a5dd872522e8b$export$644d8ea042df96a6)($35c2373f034fb739$var$MAKE_ENDPOINT, {
                method: 'POST',
                body: JSON.stringify({
                    messageSubject: messageSubject,
                    messageBody: messageBody
                })
            });
            console.log('Data received: ', data);
            this.refs.form.reset();
            this.displayMessage({
                message: `D\u{11B}kujeme, va\u{161}e kontaktn\xed \xfadaje k n\xe1m pr\xe1v\u{11B} dorazily. V nejbli\u{17E}\u{161}\xedm mo\u{17E}n\xe9m term\xednu v\xe1s budeme kontaktovat.`
            });
        } catch (errResponse) {
            console.error(errResponse);
            this.displayMessage({
                type: (0, $8a4bc28271890420$export$e5fcfdba4a8ae715).ERROR,
                message: "P\u0159i odes\xedl\xe1n\xed formul\xe1\u0159e se stala chyba"
            });
        // handle error
        // const {status, data, message} = errResponse;
        }
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('CommonLightContactForm', $35c2373f034fb739$var$CommonLightContactForm);





const $e2c047ffae303b6e$var$MAKE_ENDPOINT = 'https://hook.eu1.make.com/m1xyuwnw3i1n7jn66yuq3qnncaskaqif';
class $e2c047ffae303b6e$var$CommonHeavyContactForm extends (0, $8a4bc28271890420$export$2e2bcd8739ae039) {
    async onSubmit(formData) {
        // compose e-mail message
        const fromName = formData.get('fromName');
        const fromEmailAddress = formData.get('fromEmail');
        const fromPhone = formData.get('fromPhone');
        const fromCompany = formData.get('fromCompany');
        const message = formData.get('message');
        const messageSubject = `\u{1F6A8} Nov\xe1 popt\xe1vka z webov\xfdch str\xe1nek www.fkservis.cz (${fromName}, ${fromCompany})`;
        const messageBody = `
            Dobr\xfd den, <br/> <br/>
            pan/\xed <b>${fromName}</b> z firmy <b>${fromCompany}</b> n\xe1m zas\xedl\xe1 n\xe1sleduj\xedc\xed dotaz: <br/><br/> 
            \u{201E}<i>${message}</i>\u{201D} <br/><br/> 
            Pros\xedm, kontaktujte co nejd\u{159}\xedve z\xe1kazn\xedka na e-mailov\xe9 adrese: <b>${fromEmailAddress}</b> nebo telefonn\xedm \u{10D}\xedsle: <b>${fromPhone}</b>.
        `;
        try {
            const { data: data } = await (0, $b03a5dd872522e8b$export$644d8ea042df96a6)($e2c047ffae303b6e$var$MAKE_ENDPOINT, {
                method: 'POST',
                body: JSON.stringify({
                    messageSubject: messageSubject,
                    messageBody: messageBody
                })
            });
            console.log('Data received: ', data);
            this.refs.form.reset();
            this.displayMessage({
                message: "D\u011Bkujeme, va\u0161e zpr\xe1va k n\xe1m \xfasp\u011B\u0161n\u011B dorazila. V nejbli\u017E\u0161\xedm mo\u017En\xe9m term\xednu v\xe1m odpov\xedme.\n"
            });
        } catch (errResponse) {
            console.error(errResponse);
            this.displayMessage({
                type: (0, $8a4bc28271890420$export$e5fcfdba4a8ae715).ERROR,
                message: "P\u0159i odes\xedl\xe1n\xed formul\xe1\u0159e se stala chyba"
            });
        // handle error
        // const {status, data, message} = errResponse;
        }
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('CommonHeavyContactForm', $e2c047ffae303b6e$var$CommonHeavyContactForm);





class $f09a9ac7238c4c31$var$ContactEmployees extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el.querySelectorAll('.Employee'),
                onInViewport: (target)=>{
                    tl.from(target, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations);
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ContactEmployees', $f09a9ac7238c4c31$var$ContactEmployees);





class $e02f552fcc755966$var$ContactHero extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el.querySelectorAll('.ContactHero__channel'),
                onInViewport: (target)=>{
                    tl.from(target, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations);
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ContactHero', $e02f552fcc755966$var$ContactHero);





class $6666c64a957693da$export$3b0d6d7590275603 {
    constructor(apiKey = null, options = {}){
        this.apiKey = apiKey;
        this.options = options;
        if (typeof window === 'undefined') throw new Error('google-maps is supported only in browser environment');
    }
    load() {
        if (typeof this.api !== 'undefined') return Promise.resolve(this.api);
        if (typeof this.loader !== 'undefined') return this.loader;
        window[$6666c64a957693da$export$3b0d6d7590275603.CALLBACK_NAME] = ()=>{
            this.api = window['google'];
            if (typeof this.resolve === 'undefined') throw new Error('Should not happen');
            this.resolve(this.api);
        };
        window['gm_authFailure'] = ()=>{
            if (typeof this.reject === 'undefined') throw new Error('Should not happen');
            this.reject(new Error('google-maps: authentication error'));
        };
        return this.loader = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
            const script = document.createElement('script');
            script.src = this.createUrl();
            script.async = true;
            script.onerror = (e)=>reject(e);
            document.head.appendChild(script);
        });
    }
    createUrl() {
        const parameters = [
            `callback=${$6666c64a957693da$export$3b0d6d7590275603.CALLBACK_NAME}`
        ];
        if (this.apiKey) parameters.push(`key=${this.apiKey}`);
        for(let name in this.options)if (this.options.hasOwnProperty(name)) {
            let value = this.options[name];
            if (name === 'version') name = 'v';
            if (name === 'libraries') value = value.join(',');
            parameters.push(`${name}=${value}`);
        }
        return `https://maps.googleapis.com/maps/api/js?${parameters.join('&')}`;
    }
}
$6666c64a957693da$export$3b0d6d7590275603.CALLBACK_NAME = '_dk_google_maps_loader_cb';


class $d81c975f8ad381a5$var$ContactMap extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    constructor(el, componentName){
        super(el, componentName);
        this.init();
    }
    init = ()=>{
        const loader = new (0, $6666c64a957693da$export$3b0d6d7590275603)('AIzaSyCpaFo2YEw0jGiNXNx47kgf5rjmjT4UE1c');
        loader.load().then(function(google) {
            const companyLocation = {
                lat: 50.1693229,
                lng: 14.0577447
            };
            const map = new google.maps.Map(document.getElementById("map"), {
                center: companyLocation,
                mapId: 'fc5183eea6fe4b99',
                zoom: 10
            });
            const marker = new google.maps.Marker({
                position: companyLocation,
                map: map
            });
        });
    };
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(target, {
                        duration: 0.6,
                        opacity: 0,
                        x: 60,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ContactMap', $d81c975f8ad381a5$var$ContactMap);





class $d5a2397f2f003ce0$var$ContactOffice extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    const contentTargets = target.querySelector('.ContactOffice__content').children;
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(contentTargets, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const imageTarget = target.querySelector('.ContactOffice__image');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(imageTarget, {
                        duration: 0.6,
                        opacity: 0,
                        x: 60,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    // background fade in
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(this.el, {
                        duration: 1.2,
                        opacity: 0,
                        background: 'linear-gradient(90deg, #FFFFFF 50%, #FFFFFF 50%)',
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ContactOffice', $d5a2397f2f003ce0$var$ContactOffice);





class $df370fb748bdf2bf$var$HomepageHero extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    constructor(el, componentName){
        super(el, componentName);
        this.slider = this.refs.sliderEl && this.refs.sliderEl.slider;
        this.init();
    }
    init = ()=>{
        if (this.slider) this.slider.on('slideChange', this.onSlideChange);
    };
    onSlideChange = ()=>{
        if (this.refs.asideContent) {
            const slideFigcaption = this.slider.getCurrentSlide().querySelector('figcaption');
            this.refs.asideContent.innerHTML = slideFigcaption ? slideFigcaption.innerHTML : '';
        }
    };
    get revealAnimations() {
        return [
            {
                targets: this.el,
                onInViewport: ()=>{
                    const contentTargets = this.el.querySelector('.HomepageHero__content').children;
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(contentTargets, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const sliderTarget = this.el.querySelector('.HomepageHero__slider');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(sliderTarget, {
                        duration: 0.6,
                        opacity: 0,
                        x: 60,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('HomepageHero', $df370fb748bdf2bf$var$HomepageHero);





class $43c9bfbf510a16a9$var$HomepagePortfolio extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    requiredRefs = [
        'productLink'
    ];
    timer = null;
    isImageChanged = false;
    constructor(el, componentName){
        super(el, componentName);
        this.init();
    }
    init = ()=>{
        this.refs.productLink.forEach((el)=>{
            el.addEventListener('mouseenter', this.handleMouseEnter(el.dataset.product));
            el.addEventListener('mouseleave', this.handleMouseLeave(el.dataset.product));
        });
        this.dom = {
            defaultImage: this.el.querySelector('.Portfolio__card--multiple figure[data-product="default"]'),
            allImages: this.el.querySelectorAll('.Portfolio__card--multiple figure')
        };
        // prevents all images appearing on first hover animation
        (0, $9770947dcdc34a25$export$99ee26438460406a).set(this.dom.allImages, {
            autoAlpha: 0
        });
        (0, $9770947dcdc34a25$export$99ee26438460406a).set(this.dom.defaultImage, {
            autoAlpha: 1
        });
    };
    handleMouseEnter = (productName)=>(e)=>{
            const image = this.el.querySelector(`.Portfolio__card--multiple figure[data-product="${productName}"]`);
            if (image) {
                clearTimeout(this.timer);
                this.timer = setTimeout(()=>{
                    this.isImageChanged = true;
                    this.animateToImage(image);
                }, 100); // timeout to prevent changing when just movning mouse through the module
            }
        };
    handleMouseLeave = (productName)=>(e)=>{
            clearTimeout(this.timer);
            if (this.isImageChanged) // timeout to prevent animating to default when hovering from category to category
            this.timer = setTimeout(this.revertToDefault, 500);
        };
    revertToDefault = ()=>{
        this.animateToImage(this.dom.defaultImage);
    };
    animateToImage = (figureEl)=>{
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        tl.to(this.dom.allImages, {
            duration: 0.25,
            autoAlpha: 0
        });
        tl.to(figureEl, {
            duration: 0.35,
            autoAlpha: 1
        }, '-=0.1');
    };
    get revealAnimations() {
        return [
            {
                targets: this.el,
                onInViewport: ()=>{
                    const rightTarget = this.el.querySelectorAll('.Portfolio__card:first-child');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(rightTarget, {
                        duration: 0.6,
                        opacity: 0,
                        x: -30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const leftTarget = this.el.querySelectorAll('.Portfolio__card:last-child');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(leftTarget, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('Portfolio', $43c9bfbf510a16a9$var$HomepagePortfolio);





class $6452f31ca6dec3f8$var$HomepageReferences extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    constructor(el, componentName){
        super(el, componentName);
        this.slider = this.refs.sliderEl && this.refs.sliderEl.slider;
        this.init();
    }
    init = ()=>{
        if (this.slider) this.slider.on('slideChange', this.onSlideChange);
    };
    onSlideChange = ()=>{
        if (this.refs.asideContent) {
            const slideFigcaption = this.slider.getCurrentSlide().querySelector('figcaption');
            this.refs.asideContent.innerHTML = slideFigcaption ? slideFigcaption.innerHTML : '';
            const contentTargets = this.refs.asideContent.children;
            (0, $9770947dcdc34a25$export$99ee26438460406a).from(contentTargets, {
                duration: 0.6,
                opacity: 0,
                y: 30,
                stagger: 0.13,
                transition: 'none',
                clearProps: 'all',
                ease: 'power2.easeOut'
            });
        }
    };
    get revealAnimations() {
        return [
            {
                targets: this.el,
                onInViewport: ()=>{
                    const contentTargets = this.el.querySelector('.References__content').children;
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(contentTargets, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const imageTarget = this.el.querySelector('.References__slider');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(imageTarget, {
                        duration: 0.6,
                        opacity: 0,
                        y: 90,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const bgTarget = this.el.querySelector('.References__bg');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(bgTarget, {
                        duration: 0.6,
                        opacity: 0,
                        y: 60,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('References', $6452f31ca6dec3f8$var$HomepageReferences);





class $2d00e9734d9eb52d$var$HomepageServices extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el.querySelectorAll('.Service'),
                onInViewport: (target)=>{
                    tl.from(target, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('HomepageServices', $2d00e9734d9eb52d$var$HomepageServices);





class $bf86af918dcc26b4$var$HomepageTestimonial extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        return [
            {
                targets: this.el,
                onInViewport: ()=>{
                    const contentTargets = this.el.querySelector('.HomepageTestimonial__content').children;
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(contentTargets, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const imageTarget = this.el.querySelector('.HomepageTestimonial__image');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(imageTarget, {
                        duration: 0.6,
                        opacity: 0,
                        x: 60,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const bgTarget = this.el;
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(bgTarget, {
                        duration: 1.2,
                        backgroundColor: '#FFFFFF',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('HomepageTestimonial', $bf86af918dcc26b4$var$HomepageTestimonial);





class $91086ce46bbba122$var$ProductCards extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el.querySelectorAll('.ProductCards__card'),
                onInViewport: (target)=>{
                    tl.from(target, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ProductCards', $91086ce46bbba122$var$ProductCards);





class $5065c6ba6bf12a7a$var$ProductCategoryHero extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    const contentTargets = target.querySelector('.ProductCategoryHero__content-wrapper').children;
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(contentTargets, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const imageTarget = target.querySelector('.ProductCategoryHero__image');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(imageTarget, {
                        duration: 0.6,
                        opacity: 0,
                        x: 60,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    tl.from(target.querySelectorAll('.ProductCategoryHero__Children .Child'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations);
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ProductCategoryHero', $5065c6ba6bf12a7a$var$ProductCategoryHero);





class $5868a4bbd6687f7c$var$ProductCertificates extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    tl.from(target.querySelector('.ProductCertificates__heading'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    tl.from(target.querySelectorAll('.ProductCertificates__features li'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations);
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ProductCertificates', $5868a4bbd6687f7c$var$ProductCertificates);





class $c783a7622ae1df1f$var$ProductOptions extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    tl.from(target.querySelector('.ProductOptions__heading'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    tl.from(target.querySelectorAll('.ProductOptions__options li'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations);
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ProductOptions', $c783a7622ae1df1f$var$ProductOptions);





class $ac5809ca4271776c$var$ProductHero extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    const contentTargets = target.querySelector('.ProductHero__content').children;
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(contentTargets, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const imageTarget = target.querySelector('.ProductHero__slider');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(imageTarget, {
                        duration: 0.6,
                        opacity: 0,
                        x: 60,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ProductHero', $ac5809ca4271776c$var$ProductHero);





class $4505e215cacb6ed9$var$ProductFeatures extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    tl.from(target.querySelector('.ProductFeatures__heading'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    tl.from(target.querySelectorAll('.ProductFeatures__features li'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations);
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ProductFeatures', $4505e215cacb6ed9$var$ProductFeatures);





class $7b31f2c57c63b60d$var$ProductDownloads extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    tl.from(target.querySelector('.ProductDownloads__heading'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    tl.from(target.querySelectorAll('.ProductDownloads__file-wrapper'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations);
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ProductDownloads', $7b31f2c57c63b60d$var$ProductDownloads);





class $81c32094e0e0bba3$var$ProductGallery extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    tl.from(target.querySelector('.ProductGallery__heading'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    tl.from(target.querySelectorAll('.Image__wrapper'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations);
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ProductGallery', $81c32094e0e0bba3$var$ProductGallery);





class $e37fef7806d531b9$var$ProductRichFeatures extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    tl.from(target.querySelectorAll('.ProductRichFeatures__feature'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        ease: 'power2.easeOut'
                    });
                    tl.from(target.querySelectorAll('.ProductRichFeatures__button'), {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ProductRichFeatures', $e37fef7806d531b9$var$ProductRichFeatures);





class $6046bcee89df6f47$var$ProductTechnicalInformation extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    tl.from(target.querySelector('.ProductTechnicalInformation__heading'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    // starting animation immediately intentionally
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(target.querySelector('.ProductTechnicalInformation__table-wrapper'), {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ProductTechnicalInformation', $6046bcee89df6f47$var$ProductTechnicalInformation);





class $bb6d3bfd0a76ca41$var$ProductCategoryProductsList extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el.querySelectorAll('.Product__wrapper'),
                onInViewport: (target)=>{
                    tl.from(target, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations);
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ProductCategoryProductsList', $bb6d3bfd0a76ca41$var$ProductCategoryProductsList);





class $e22985d9447c39b3$var$ReferencesList extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el.querySelectorAll('.Reference'),
                onInViewport: (target)=>{
                    // more complex version
                    // const contentTargets = target.querySelector('.Reference__content-wrapper').children;
                    // gsap.from(contentTargets, {
                    //     duration: 0.6,
                    //     opacity: 0,
                    //     y: 30,
                    //     stagger: 0.13,
                    //     transition: 'none',
                    //     clearProps: 'all',
                    //     ease: 'power2.easeOut'
                    // });
                    //
                    // const imageTarget = target.querySelector('.Reference__image');
                    // gsap.from(imageTarget, {
                    //     duration: 0.6,
                    //     opacity: 0,
                    //     y: 30,
                    //     transition: 'none',
                    //     clearProps: 'all',
                    //     ease: 'power2.easeOut'
                    // });
                    // simpler version
                    tl.from(target, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        ease: 'power2.easeOut'
                    }, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations);
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ReferencesList', $e22985d9447c39b3$var$ReferencesList);





class $f766292a1ca82319$var$ReferencesProjectCategories extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        return [
            {
                targets: this.el.querySelectorAll('.ReferenceCategory'),
                onInViewport: (target)=>{
                    const contentTargets = target.querySelector('.ReferenceCategory__content-wrapper');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(contentTargets, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const imageTarget = target.querySelector('.ReferenceCategory__image');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(imageTarget, {
                        duration: 0.6,
                        opacity: 0,
                        y: 60,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const bgTarget = target.querySelector('.ReferenceCategory__bg');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(bgTarget, {
                        duration: 1.2,
                        backgroundColor: '#FFFFFF',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('ReferenceCategoriesList', $f766292a1ca82319$var$ReferencesProjectCategories);





class $d880dabbf492c3ac$var$SolutionHero extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    const contentTargets = target.querySelector('.SolutionHero__content').children;
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(contentTargets, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const imageTarget = target.querySelector('.SolutionHero__image');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(imageTarget, {
                        duration: 0.6,
                        opacity: 0,
                        x: 60,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    const dividerTarget = target.querySelector('.SolutionHero__divider');
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(dividerTarget, {
                        duration: 1.2,
                        opacity: 0,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('SolutionHero', $d880dabbf492c3ac$var$SolutionHero);





class $1838bff1af8a51a7$var$SolutionFeaturesCards extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el.querySelectorAll('.SolutionFeaturesCards__card'),
                onInViewport: (target)=>{
                    const targetTl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
                    targetTl.from(target, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    tl.add(targetTl, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('SolutionFeaturesCards', $1838bff1af8a51a7$var$SolutionFeaturesCards);





class $f06d63300d971196$var$SolutionFeaturesGrid extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el.querySelectorAll('.SolutionFeaturesGrid__feature'),
                onInViewport: (target)=>{
                    const targetTl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
                    targetTl.from(target, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    tl.add(targetTl, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('SolutionFeaturesGrid', $f06d63300d971196$var$SolutionFeaturesGrid);





class $1c4bfe2fee9e55da$var$SolutionFeaturesList extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el.querySelectorAll('.SolutionFeaturesList__feature'),
                onInViewport: (target)=>{
                    const targetTl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
                    const elements = {
                        image: target.querySelector('.SolutionFeaturesList__feature__image'),
                        content: target.querySelector('.SolutionFeaturesList__feature__content').children
                    };
                    targetTl.from(elements.image, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    }, 0);
                    targetTl.from(elements.content, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    }, 0);
                    tl.add(targetTl, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('SolutionFeaturesList', $1c4bfe2fee9e55da$var$SolutionFeaturesList);





class $1d4ff01455cc7670$var$SolutionProductCategories extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        const tl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
        return [
            {
                targets: this.el.querySelectorAll('.SolutionProductCategories__category-wrapper'),
                onInViewport: (target)=>{
                    const targetTl = (0, $9770947dcdc34a25$export$99ee26438460406a).timeline();
                    targetTl.from(target, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    tl.add(targetTl, tl.isActive() ? '<0.13' : '+=0') // stagger 0.13s with independent reveal animations
                    ;
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('SolutionProductCategories', $1d4ff01455cc7670$var$SolutionProductCategories);





class $bef7ac5bcf9b134f$var$SolutionProduct extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    const elements = {
                        content: target.querySelectorAll('.SolutionProduct__content__description ul li'),
                        image: target.querySelectorAll('.SolutionProduct__content__image'),
                        button: target.querySelectorAll('.SolutionProduct__button')
                    };
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(elements.content, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(elements.image, {
                        duration: 0.6,
                        opacity: 0,
                        x: 60,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(elements.button, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('SolutionProduct', $bef7ac5bcf9b134f$var$SolutionProduct);





class $8a413bf08e4461b0$var$SolutionProducts extends (0, $fb95888796e08f9b$export$55ae5207ce896a6b) {
    get revealAnimations() {
        return [
            {
                targets: this.el,
                onInViewport: (target)=>{
                    const elements = {
                        commonFeatures: target.querySelectorAll('.SolutionProducts__common-features__feature-wrapper'),
                        products: target.querySelectorAll('.SolutionProducts__products__product')
                    };
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(elements.commonFeatures, {
                        duration: 0.6,
                        opacity: 0,
                        x: 30,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(elements.products, {
                        duration: 0.6,
                        opacity: 0,
                        x: 60,
                        stagger: 0.13,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                    (0, $9770947dcdc34a25$export$99ee26438460406a).from(elements.button, {
                        duration: 0.6,
                        opacity: 0,
                        y: 30,
                        transition: 'none',
                        clearProps: 'all',
                        ease: 'power2.easeOut'
                    });
                }
            }
        ];
    }
}
(0, $0ae05e362631bcb5$export$2e2bcd8739ae039).add('SolutionProducts', $8a413bf08e4461b0$var$SolutionProducts);


/*
* Initialize registered components
*/ const $d7216836c20394ce$var$components = [];
Object.entries((0, $0ae05e362631bcb5$export$2e2bcd8739ae039).getDictionary()).map(([componentName, componentClassDefinition])=>{
    document.querySelectorAll(`.${componentName}`).forEach((el)=>{
        $d7216836c20394ce$var$components.push(new componentClassDefinition(el, componentName));
    });
});

})();
//# sourceMappingURL=index.js.map
